/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
export type Maybe<T> = T | null
export type InputMaybe<T> = T | null | undefined
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never }
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  DateTime: { input: any; output: any }
  JSON: { input: any; output: any }
}

export enum AccountType {
  Custom = 'Custom',
  Express = 'Express',
  Standard = 'Standard',
}

export type AddCampaignDomainInput = {
  campaignId: Scalars['ID']['input']
  campaignSlug: Scalars['ID']['input']
}

export type AddCampaignMatchedGivingSettingResult = {
  __typename?: 'AddCampaignMatchedGivingSettingResult'
  id: Scalars['String']['output']
}

export type AddMergeFieldInput = {
  description?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
}

export type AddPageBucketSlugsForCampaignInput = {
  campaignId: Scalars['ID']['input']
  slugs: Array<PageBucketSlugsDetailsInput>
}

export type AddPageSlugsForCampaignInput = {
  campaignId: Scalars['ID']['input']
  slugs: Array<PageSlugsDetailsInput>
}

export type AddPayPalByReferralInput = {
  merchantEmail: Scalars['String']['input']
  merchantId: Scalars['String']['input']
  mode: Mode
}

export type AddressInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>
  addressLine2?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  postcode?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
}

export type AggregatedGiving = {
  __typename?: 'AggregatedGiving'
  amount: Scalars['Float']['output']
  date: Scalars['DateTime']['output']
}

export type AggregatedGivings = {
  __typename?: 'AggregatedGivings'
  amounts: Array<AggregatedGiving>
  total?: Maybe<Scalars['Float']['output']>
}

export type AggregatedGivingsInput = {
  end: Scalars['DateTime']['input']
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
  start: Scalars['DateTime']['input']
  timezoneOffsetInMinutes: Scalars['Int']['input']
}

export type AggregationSetting = {
  groupSettings?: Maybe<Array<AggregationSettingItem>>
  isAllPagesLinked?: Maybe<Scalars['Boolean']['output']>
}

export type AggregationSettingItem = {
  dataSources?: Maybe<Array<Scalars['ID']['output']>>
  groupId: Scalars['ID']['output']
  groupName?: Maybe<Scalars['String']['output']>
  isAllPagesLinked?: Maybe<Scalars['Boolean']['output']>
  pageBucketIds?: Maybe<Array<Scalars['ID']['output']>>
  pageIds: Array<Scalars['ID']['output']>
}

export enum AggregationSettingType {
  All = 'All',
  Individual = 'Individual',
  Selected = 'Selected',
}

export type AggregationSettings = {
  __typename?: 'AggregationSettings'
  commentSetting?: Maybe<CommentAggregationSetting>
  countdownTimerSetting?: Maybe<CountdownTimerAggregationSetting>
  matchedGivingSetting?: Maybe<MatchedGivingAggregationSetting>
  progressBarSetting?: Maybe<ProgressBarAggregationSetting>
}

export type AmountTrigger = {
  __typename?: 'AmountTrigger'
  amountStart: Scalars['Float']['output']
  pageId: Scalars['ID']['output']
}

export type AmountTriggerInput = {
  amountStart: Scalars['Float']['input']
  pageId: Scalars['ID']['input']
}

export enum AnalyticsDeviceType {
  Desktop = 'Desktop',
  Mobile = 'Mobile',
  Tablet = 'Tablet',
}

export type AnalyticsInput = {
  campaignId?: InputMaybe<Scalars['String']['input']>
  charityId?: InputMaybe<Scalars['String']['input']>
  deviceType?: InputMaybe<AnalyticsDeviceType>
  deviceUUID?: InputMaybe<Scalars['String']['input']>
  donationPageUrl?: InputMaybe<Scalars['String']['input']>
  eventId?: InputMaybe<Scalars['String']['input']>
  fbc?: InputMaybe<Scalars['String']['input']>
  fbp?: InputMaybe<Scalars['String']['input']>
  hasFbPixel?: InputMaybe<Scalars['Boolean']['input']>
  hasGoogleAnalytics?: InputMaybe<Scalars['Boolean']['input']>
  isConversionsApi?: InputMaybe<Scalars['Boolean']['input']>
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
  isLocalStorageAllowed?: InputMaybe<Scalars['Boolean']['input']>
  pageId?: InputMaybe<Scalars['String']['input']>
  pixelId?: InputMaybe<Scalars['String']['input']>
  userAgent?: InputMaybe<Scalars['String']['input']>
}

export type AnalyticsIntegrationSettings = {
  __typename?: 'AnalyticsIntegrationSettings'
  ga4Settings: Array<Ga4IntegrationSetting>
  gtmSettings: Array<GtmIntegrationSetting>
  identityPartnerSettings?: Maybe<IdentityPartnerSetting>
  pixelConversionsApiSettings: Array<PixelConversionsApiIntegrationSetting>
  raiserEdgeIntegrationSettings?: Maybe<Array<RaiserEdgeIntegrationSetting>>
}

export enum AnalyticsType {
  Ga4 = 'Ga4',
  Gtm = 'Gtm',
  PixelConversionsApi = 'PixelConversionsApi',
}

export type ApiDonationCampaignAnalyticsSettings = {
  __typename?: 'ApiDonationCampaignAnalyticsSettings'
  ga4Analytic?: Maybe<ApiDonationGa4Setting>
  googleAnalytic?: Maybe<ApiDonationGtmSetting>
  metaPixelAnalytic?: Maybe<ApiDonationMetaPixelAnalyticSetting>
}

export type ApiDonationCampaignSettings = {
  __typename?: 'ApiDonationCampaignSettings'
  aggregationSettings?: Maybe<AggregationSettings>
  analyticSettings?: Maybe<ApiDonationCampaignAnalyticsSettings>
  isPeerToPeerGivingNotificationEnabled?: Maybe<Scalars['Boolean']['output']>
  matchedGivingSettings?: Maybe<Array<CampaignMatchedGivingSetting>>
  pageReferences: Array<PageReference>
}

export type ApiDonationCharityPageRedirectionSettings = {
  __typename?: 'ApiDonationCharityPageRedirectionSettings'
  from: Scalars['String']['output']
  to?: Maybe<Scalars['String']['output']>
  type: PageRedirectType
}

export type ApiDonationCharitySettings = {
  __typename?: 'ApiDonationCharitySettings'
  redirectUrl?: Maybe<Scalars['String']['output']>
}

export type ApiDonationGtmSetting = {
  __typename?: 'ApiDonationGTMSetting'
  googleTagId?: Maybe<Scalars['ID']['output']>
  isEnabled?: Maybe<Scalars['Boolean']['output']>
}

export type ApiDonationGa4Setting = {
  __typename?: 'ApiDonationGa4Setting'
  ga4MeasurementId?: Maybe<Scalars['ID']['output']>
  isEnabled?: Maybe<Scalars['Boolean']['output']>
}

export type ApiDonationMetaPixelAnalyticSetting = {
  __typename?: 'ApiDonationMetaPixelAnalyticSetting'
  isConversionsAPI?: Maybe<Scalars['Boolean']['output']>
  metaPixelId?: Maybe<Scalars['ID']['output']>
}

export type Appeal = {
  __typename?: 'Appeal'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  rows: Array<Maybe<Row>>
}

export type ApplicationFeeRefundTransactionDetail = {
  __typename?: 'ApplicationFeeRefundTransactionDetail'
  applicationFeeAmount: Scalars['Float']['output']
}

export enum AssetCategoryType {
  Document = 'Document',
  Image = 'Image',
}

export type AuthenticateProfileResponse = {
  __typename?: 'AuthenticateProfileResponse'
  profileUrl: Scalars['String']['output']
  token: Scalars['String']['output']
}

export type Balance = {
  __typename?: 'Balance'
  count: Scalars['Int']['output']
  totalAmount: Scalars['Float']['output']
}

export type BaseCampaignSettings = {
  __typename?: 'BaseCampaignSettings'
  endDateTime?: Maybe<Scalars['String']['output']>
  goal?: Maybe<Scalars['Float']['output']>
  startDateTime?: Maybe<Scalars['String']['output']>
}

export type BonusGoal = {
  __typename?: 'BonusGoal'
  customTickColor?: Maybe<Scalars['String']['output']>
  customTickUrl?: Maybe<Scalars['String']['output']>
  index: Scalars['Int']['output']
  isTickHidden?: Maybe<Scalars['Boolean']['output']>
  showPastGoals?: Maybe<Scalars['Boolean']['output']>
  text?: Maybe<Text>
}

export type BonusGoalInput = {
  customTickColor?: InputMaybe<Scalars['String']['input']>
  customTickUrl?: InputMaybe<Scalars['String']['input']>
  index: Scalars['Int']['input']
  isTickHidden?: InputMaybe<Scalars['Boolean']['input']>
  showPastGoals?: InputMaybe<Scalars['Boolean']['input']>
  text?: InputMaybe<TextInput>
}

export type Branding = {
  __typename?: 'Branding'
  id: Scalars['ID']['output']
  isDefault: Scalars['Boolean']['output']
  logoStyle?: Maybe<Scalars['String']['output']>
  logoURL?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type Button = Component & {
  __typename?: 'Button'
  buttonText: Scalars['String']['output']
  buttonType: Scalars['String']['output']
  html?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  target?: Maybe<Scalars['String']['output']>
  type: ComponentType
  url?: Maybe<Scalars['String']['output']>
}

export type ButtonInput = {
  buttonType: Scalars['String']['input']
  componentId: Scalars['ID']['input']
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  target?: InputMaybe<Scalars['String']['input']>
  text: Scalars['String']['input']
  type: ComponentTypeInput
  url?: InputMaybe<Scalars['String']['input']>
}

export type CamaignGa4Setting = {
  __typename?: 'CamaignGa4Setting'
  ga4SettingId?: Maybe<Scalars['ID']['output']>
  isDisabled?: Maybe<Scalars['Boolean']['output']>
}

export type CamaignGtmSetting = {
  __typename?: 'CamaignGtmSetting'
  gtmSettingId?: Maybe<Scalars['ID']['output']>
  isDisabled?: Maybe<Scalars['Boolean']['output']>
}

export type Campaign = {
  __typename?: 'Campaign'
  buckets?: Maybe<Array<PageBucketDetail>>
  campaignDomain?: Maybe<Scalars['String']['output']>
  endDate?: Maybe<Scalars['String']['output']>
  goal?: Maybe<Scalars['Float']['output']>
  id: Scalars['ID']['output']
  isP2PEnabled: Scalars['Boolean']['output']
  pages?: Maybe<Array<PageDetail>>
  platformFeeType?: Maybe<PlatformFeeType>
  startDate?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
  type?: Maybe<CampaignType>
}

export type CampaignAnalyticsSettings = {
  __typename?: 'CampaignAnalyticsSettings'
  ga4?: Maybe<CamaignGa4Setting>
  gtm?: Maybe<CamaignGtmSetting>
  pixelConversionsApi?: Maybe<CampaignPixelSetting>
}

export type CampaignAnalyticsSettingsInput = {
  campaignId: Scalars['ID']['input']
  ga4?: InputMaybe<CampaignGa4SettingInput>
  gtm?: InputMaybe<CampaignGtmSettingInput>
  pixelConversionsApi?: InputMaybe<CampaignPixelSettingInput>
}

export type CampaignAsset = {
  __typename?: 'CampaignAsset'
  categoryType: AssetCategoryType
  fileName: Scalars['String']['output']
  id: Scalars['ID']['output']
  url: Scalars['String']['output']
}

export type CampaignDomain = {
  __typename?: 'CampaignDomain'
  domain: Scalars['String']['output']
  origin: Scalars['String']['output']
  slug?: Maybe<Scalars['String']['output']>
}

export type CampaignDonationByDateStat = {
  __typename?: 'CampaignDonationByDateStat'
  date: Scalars['String']['output']
  donationAmount: Scalars['Float']['output']
  donationCount: Scalars['Int']['output']
}

export type CampaignDonorAmountStat = {
  __typename?: 'CampaignDonorAmountStat'
  amount: Scalars['Float']['output']
  donorName: Scalars['String']['output']
}

export type CampaignGa4SettingInput = {
  ga4SettingId?: InputMaybe<Scalars['ID']['input']>
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>
}

export type CampaignGtmSettingInput = {
  gtmSettingId?: InputMaybe<Scalars['ID']['input']>
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>
}

export type CampaignMatchedGivingSetting = {
  __typename?: 'CampaignMatchedGivingSetting'
  endAt?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  name: Scalars['String']['output']
  rounds: Array<CampaignMatchedGivingSettingItem>
  startAt: Scalars['String']['output']
}

export type CampaignMatchedGivingSettingInput = {
  campaignId: Scalars['String']['input']
  endAt?: InputMaybe<Scalars['String']['input']>
  matchedGivingSettingId?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  rounds: Array<CampaignMatchedGivingSettingItemInput>
  startAt: Scalars['String']['input']
}

export type CampaignMatchedGivingSettingItem = {
  __typename?: 'CampaignMatchedGivingSettingItem'
  endFundRange: Scalars['Float']['output']
  multiplier: Scalars['Float']['output']
  startFundRange: Scalars['Float']['output']
}

export type CampaignMatchedGivingSettingItemInput = {
  endFundRange: Scalars['Float']['input']
  multiplier: Scalars['Float']['input']
  startFundRange: Scalars['Float']['input']
}

export type CampaignMetadata = {
  __typename?: 'CampaignMetadata'
  CampaignGoal?: Maybe<Scalars['String']['output']>
  CampaignName?: Maybe<Scalars['String']['output']>
  fbPixelId?: Maybe<Scalars['String']['output']>
  ga4ScriptId?: Maybe<Scalars['String']['output']>
  gtmScriptId?: Maybe<Scalars['String']['output']>
  isConversionsApi?: Maybe<Scalars['Boolean']['output']>
  ogImage?: Maybe<Scalars['String']['output']>
  ogTitle?: Maybe<Scalars['String']['output']>
}

export type CampaignOverview = {
  __typename?: 'CampaignOverview'
  buckets?: Maybe<Array<PageBucketDetail>>
  campaignSettings?: Maybe<CampaignSettings>
  id: Scalars['ID']['output']
  pages?: Maybe<Array<PageDetail>>
  totalAmount: Scalars['Float']['output']
  totalDonors: Scalars['Int']['output']
}

export type CampaignPageDonationAmountStat = {
  __typename?: 'CampaignPageDonationAmountStat'
  amount: Scalars['Float']['output']
  count: Scalars['Int']['output']
  pageName: Scalars['String']['output']
}

export type CampaignPaymentSettings = {
  __typename?: 'CampaignPaymentSettings'
  paypal?: Maybe<CharityPayPalSettings>
  platformFeeType?: Maybe<PlatformFeeType>
  stripe?: Maybe<CharityStripeSettings>
}

export type CampaignPixelSetting = {
  __typename?: 'CampaignPixelSetting'
  isDisabled?: Maybe<Scalars['Boolean']['output']>
  pixelSettingId?: Maybe<Scalars['ID']['output']>
}

export type CampaignPixelSettingInput = {
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>
  pixelSettingId?: InputMaybe<Scalars['ID']['input']>
}

export type CampaignSettings = {
  __typename?: 'CampaignSettings'
  aggregationSettings?: Maybe<AggregationSettings>
  analyticsSettings?: Maybe<CampaignAnalyticsSettings>
  baseSettings?: Maybe<BaseCampaignSettings>
  campaignDomain?: Maybe<Scalars['String']['output']>
  defaultCampaignPageId?: Maybe<Scalars['ID']['output']>
  emailReceiptSettings?: Maybe<EmailReceiptSettings>
  isPeerToPeerGivingNotificationEnabled?: Maybe<Scalars['Boolean']['output']>
  matchedGivingSettings?: Maybe<Array<CampaignMatchedGivingSetting>>
  pageReferences?: Maybe<Array<PageReference>>
  paymentSettings?: Maybe<PreviewCampaignPaymentSettings>
  peerToPeerPageMapSettings?: Maybe<PeerToPeerPageMapSettings>
}

export type CampaignTrigger = {
  __typename?: 'CampaignTrigger'
  campaignTriggerId?: Maybe<Scalars['ID']['output']>
  dateTimeTriggers: Array<DateTimeTrigger>
}

export type CampaignTriggerInput = {
  campaignId: Scalars['ID']['input']
  campaignTriggerId?: InputMaybe<Scalars['ID']['input']>
  dateTimeTriggers: Array<DateTimeTriggerInput>
  pageBucketId: Scalars['ID']['input']
}

export enum CampaignType {
  Appeal = 'Appeal',
  GivingDay = 'GivingDay',
  P2P = 'P2P',
  VirtualGift = 'VirtualGift',
}

export type CampaignUtmTagDonationAmountStat = {
  __typename?: 'CampaignUtmTagDonationAmountStat'
  amount: Scalars['Float']['output']
  count: Scalars['Int']['output']
  tagName: Scalars['String']['output']
  tagValue: Scalars['String']['output']
}

export type CancelSubscriptionInput = {
  externalSubscriptionId: Scalars['String']['input']
  paymentSubscriptionId: Scalars['ID']['input']
}

export type Charity = {
  __typename?: 'Charity'
  description: Scalars['String']['output']
  id: Scalars['ID']['output']
  isActive: Scalars['Boolean']['output']
  logo: Scalars['String']['output']
  name: Scalars['String']['output']
  url?: Maybe<Scalars['String']['output']>
}

export type CharityAsset = {
  __typename?: 'CharityAsset'
  categoryType: AssetCategoryType
  fileName: Scalars['String']['output']
  id: Scalars['ID']['output']
  url: Scalars['String']['output']
}

export type CharityClaim = {
  __typename?: 'CharityClaim'
  id: Scalars['ID']['output']
  logoUrl?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
}

export type CharityDetail = {
  __typename?: 'CharityDetail'
  abn?: Maybe<Scalars['String']['output']>
  autoSendTaxSummaryEmailDate?: Maybe<Scalars['String']['output']>
  branding?: Maybe<Scalars['ID']['output']>
  description?: Maybe<Scalars['String']['output']>
  domain?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  faviconUrl?: Maybe<Scalars['String']['output']>
  fromEmail?: Maybe<Scalars['String']['output']>
  fromName?: Maybe<Scalars['String']['output']>
  isDgrEndorsed?: Maybe<Scalars['Boolean']['output']>
  logoUrl?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  reversedLogoUrl?: Maybe<Scalars['String']['output']>
  sendPdfReceipt?: Maybe<Scalars['Boolean']['output']>
}

export type CharityDetailInput = {
  abn: Scalars['String']['input']
  autoSendTaxSummaryEmailDate?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  faviconUrl?: InputMaybe<Scalars['String']['input']>
  isDgrEndorsed: Scalars['Boolean']['input']
  logoUrl?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  phone?: InputMaybe<Scalars['String']['input']>
  reversedLogoUrl?: InputMaybe<Scalars['String']['input']>
  sendPdfReceipt: Scalars['Boolean']['input']
}

export type CharityDonorPortalPermissionsInput = {
  regularGivingPermissions?: InputMaybe<CharityDonorPortalRegularGivingPermissionsInput>
}

export type CharityDonorPortalRegularGivingPermissions = {
  __typename?: 'CharityDonorPortalRegularGivingPermissions'
  canCancelDonation: Scalars['Boolean']['output']
  canEditAmount: Scalars['Boolean']['output']
  canEditDonationEndDate: Scalars['Boolean']['output']
  canEditFrequency: Scalars['Boolean']['output']
  canEditName: Scalars['Boolean']['output']
  canEditNextPaymentDate: Scalars['Boolean']['output']
  canPauseDonation: Scalars['Boolean']['output']
  canResumeDonation: Scalars['Boolean']['output']
  updatePaymentDetails: UpdatePaymentMethodPermission
}

export type CharityDonorPortalRegularGivingPermissionsInput = {
  canCancelDonation: Scalars['Boolean']['input']
  canEditAmount: Scalars['Boolean']['input']
  canEditDonationEndDate: Scalars['Boolean']['input']
  canEditFrequency: Scalars['Boolean']['input']
  canEditName: Scalars['Boolean']['input']
  canEditNextPaymentDate: Scalars['Boolean']['input']
  canPauseDonation: Scalars['Boolean']['input']
  canResumeDonation: Scalars['Boolean']['input']
  updatePaymentDetails: UpdatePaymentMethodPermission
}

export type CharityDonorPortalSettings = {
  __typename?: 'CharityDonorPortalSettings'
  branding?: Maybe<Scalars['ID']['output']>
  domain?: Maybe<Scalars['String']['output']>
  regularGivingPermissions?: Maybe<CharityDonorPortalRegularGivingPermissions>
}

export type CharityMetadata = {
  __typename?: 'CharityMetadata'
  ABN?: Maybe<Scalars['String']['output']>
  CharityName?: Maybe<Scalars['String']['output']>
  CustomFields?: Maybe<Scalars['String']['output']>
  Email?: Maybe<Scalars['String']['output']>
  FaviconUrl?: Maybe<Scalars['String']['output']>
  LogoUrl?: Maybe<Scalars['String']['output']>
  Phone?: Maybe<Scalars['String']['output']>
  ReversedLogoUrl?: Maybe<Scalars['String']['output']>
}

export type CharityOfflineSettings = {
  __typename?: 'CharityOfflineSettings'
  accountId: Scalars['String']['output']
  id: Scalars['ID']['output']
  label?: Maybe<Scalars['String']['output']>
  providerType?: Maybe<PaymentProviderType>
}

export type CharityPageRedirectionSetting = {
  __typename?: 'CharityPageRedirectionSetting'
  externalTo?: Maybe<Scalars['String']['output']>
  from: Array<CharityPageRedirectionSettingItem>
  id: Scalars['ID']['output']
  to?: Maybe<CharityPageRedirectionSettingItem>
}

export type CharityPageRedirectionSettingItem = {
  __typename?: 'CharityPageRedirectionSettingItem'
  campaignId: Scalars['ID']['output']
  campaignName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  type: PageRedirectType
}

export type CharityPageRedirectionSettingItemInput = {
  id: Scalars['ID']['input']
  type: PageRedirectType
}

export type CharityPageRedirectionSettingsInput = {
  externalTo?: InputMaybe<Scalars['String']['input']>
  from: Array<CharityPageRedirectionSettingItemInput>
  id: Scalars['ID']['input']
  to?: InputMaybe<CharityPageRedirectionSettingItemInput>
}

export type CharityPayPalSettings = {
  __typename?: 'CharityPayPalSettings'
  id: Scalars['ID']['output']
  isDefault?: Maybe<Scalars['Boolean']['output']>
  label?: Maybe<Scalars['String']['output']>
  merchantEmail?: Maybe<Scalars['String']['output']>
  providerType?: Maybe<PaymentProviderType>
}

export type CharityPayPalSettingsInput = {
  label: Scalars['String']['input']
  merchantEmail: Scalars['String']['input']
  merchantId: Scalars['ID']['input']
}

export type CharityPaymentSettings = {
  __typename?: 'CharityPaymentSettings'
  offline?: Maybe<Array<CharityOfflineSettings>>
  payPal?: Maybe<Array<CharityPayPalSettings>>
  platformFeeType?: Maybe<PlatformFeeType>
  stripe?: Maybe<Array<CharityStripeSettings>>
}

export type CharityStripeSettings = {
  __typename?: 'CharityStripeSettings'
  accountId: Scalars['String']['output']
  id: Scalars['ID']['output']
  isDefault?: Maybe<Scalars['Boolean']['output']>
  label?: Maybe<Scalars['String']['output']>
  providerType?: Maybe<PaymentProviderType>
}

export type CharityStripeSettingsInput = {
  accountId: Scalars['String']['input']
  label: Scalars['String']['input']
}

export enum CharityTaxSummaryMessageType {
  Everyone = 'Everyone',
  RegularGivingsOnly = 'RegularGivingsOnly',
}

export enum CharityTaxSummarySendLogStatus {
  Completed = 'Completed',
  Failed = 'Failed',
  Initiated = 'Initiated',
  Processing = 'Processing',
}

export type CharityTaxSummaryStatus = {
  __typename?: 'CharityTaxSummaryStatus'
  isSendLogExists: Scalars['Boolean']['output']
  status?: Maybe<CharityTaxSummarySendLogStatus>
  totalEmailCount?: Maybe<Scalars['Int']['output']>
}

export type CharityTemplateDetail = {
  __typename?: 'CharityTemplateDetail'
  id: Scalars['ID']['output']
  layout?: Maybe<Page>
  name?: Maybe<Scalars['String']['output']>
  screenshotImageUrl?: Maybe<Scalars['String']['output']>
}

export enum CharityTemplateType {
  Page = 'Page',
  Section = 'Section',
}

export type CharityUser = {
  __typename?: 'CharityUser'
  email: Scalars['String']['output']
  name?: Maybe<Scalars['String']['output']>
  role?: Maybe<Role>
  userId: Scalars['ID']['output']
}

export type CharityUserWithPagination = {
  __typename?: 'CharityUserWithPagination'
  items: Array<CharityUser>
  totalRecords: Scalars['Int']['output']
}

export type Color = {
  __typename?: 'Color'
  hex: Scalars['String']['output']
  rgb: RgbColor
}

export type ColorInput = {
  hex: Scalars['String']['input']
  rgb: RgbColorInput
}

export type Column = Component & {
  __typename?: 'Column'
  components: Array<PageComponent>
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
}

export type ColumnInput = {
  componentId: Scalars['ID']['input']
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  type: ComponentTypeInput
}

export type Comment = {
  __typename?: 'Comment'
  amount: Scalars['Float']['output']
  dedicateeName?: Maybe<Scalars['String']['output']>
  donatedAt: Scalars['DateTime']['output']
  donatedBy: Scalars['String']['output']
  donatedTo?: Maybe<DonatedTo>
  id: Scalars['ID']['output']
  matchedAmount?: Maybe<Scalars['Float']['output']>
  matchedDonationAmount?: Maybe<Scalars['Float']['output']>
  message?: Maybe<Scalars['String']['output']>
  organisationName?: Maybe<Scalars['String']['output']>
}

export type CommentAggregationSetting = AggregationSetting & {
  __typename?: 'CommentAggregationSetting'
  groupSettings?: Maybe<Array<CommentAggregationSettingItem>>
  isAllPagesLinked?: Maybe<Scalars['Boolean']['output']>
}

export type CommentAggregationSettingItem = AggregationSettingItem & {
  __typename?: 'CommentAggregationSettingItem'
  amountToShowOver?: Maybe<Scalars['Float']['output']>
  dataSources?: Maybe<Array<Scalars['ID']['output']>>
  endVisibleTime?: Maybe<Scalars['DateTime']['output']>
  groupId: Scalars['ID']['output']
  groupName?: Maybe<Scalars['String']['output']>
  isAllPagesLinked?: Maybe<Scalars['Boolean']['output']>
  pageBucketIds?: Maybe<Array<Scalars['ID']['output']>>
  pageIds: Array<Scalars['ID']['output']>
  startVisibleTime?: Maybe<Scalars['DateTime']['output']>
}

export type CommentAggregationSettingItemInput = {
  amountToShowOver?: InputMaybe<Scalars['Float']['input']>
  dataSources?: InputMaybe<Array<Scalars['ID']['input']>>
  endVisibleTime?: InputMaybe<Scalars['DateTime']['input']>
  groupId: Scalars['ID']['input']
  groupName?: InputMaybe<Scalars['String']['input']>
  isAllPagesLinked?: InputMaybe<Scalars['Boolean']['input']>
  pageBucketIds?: InputMaybe<Array<Scalars['ID']['input']>>
  pageIds: Array<Scalars['ID']['input']>
  startVisibleTime?: InputMaybe<Scalars['DateTime']['input']>
}

export type CommentInput = {
  charityId: Scalars['ID']['input']
  dedicateeEmail?: InputMaybe<Scalars['String']['input']>
  dedicateeName?: InputMaybe<Scalars['String']['input']>
  fullName: Scalars['String']['input']
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
  isPIIPublic: Scalars['Boolean']['input']
  message?: InputMaybe<Scalars['String']['input']>
  organisationName?: InputMaybe<Scalars['String']['input']>
  paymentSubscriptionId?: InputMaybe<Scalars['ID']['input']>
  paymentTransactionId?: InputMaybe<Scalars['ID']['input']>
  profileId?: InputMaybe<Scalars['ID']['input']>
}

export type Comments = Component & {
  __typename?: 'Comments'
  amountToShowOver?: Maybe<Scalars['Int']['output']>
  end?: Maybe<Scalars['DateTime']['output']>
  hideBeforeStart?: Maybe<Scalars['Boolean']['output']>
  hideOnEnd?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  isAllPagesLinked?: Maybe<Scalars['Boolean']['output']>
  layout: CommentsLayout
  linkedPageIds?: Maybe<Array<Scalars['ID']['output']>>
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  showAmount: Scalars['Boolean']['output']
  showMessage: Scalars['Boolean']['output']
  showTotal: Scalars['Boolean']['output']
  showViewAll: Scalars['Boolean']['output']
  start?: Maybe<Scalars['DateTime']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
}

export type CommentsInput = {
  amountToShowOver?: InputMaybe<Scalars['Int']['input']>
  componentId: Scalars['ID']['input']
  end?: InputMaybe<Scalars['DateTime']['input']>
  hideBeforeStart?: InputMaybe<Scalars['Boolean']['input']>
  hideOnEnd?: InputMaybe<Scalars['Boolean']['input']>
  isAllPagesLinked?: InputMaybe<Scalars['Boolean']['input']>
  layout: CommentsLayout
  linkedPageIds?: InputMaybe<Array<Scalars['ID']['input']>>
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  showAmount: Scalars['Boolean']['input']
  showMessage: Scalars['Boolean']['input']
  showTotal: Scalars['Boolean']['input']
  showViewAll: Scalars['Boolean']['input']
  start?: InputMaybe<Scalars['DateTime']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  type: ComponentTypeInput
}

export enum CommentsLayout {
  Horizontal = 'HORIZONTAL',
  Vertical = 'VERTICAL',
}

export type CommentsQueryInput = {
  campaignId: Scalars['ID']['input']
  charityId: Scalars['ID']['input']
  hasFundraiserSupported?: InputMaybe<Scalars['Boolean']['input']>
  includeMatchedAmount?: InputMaybe<Scalars['Boolean']['input']>
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
  onlyDedicatedComments?: InputMaybe<Scalars['Boolean']['input']>
  pageId?: InputMaybe<Scalars['ID']['input']>
  pageIds?: InputMaybe<Array<Scalars['ID']['input']>>
  pagination?: InputMaybe<PaginationQuery>
  profileId?: InputMaybe<Scalars['ID']['input']>
}

export type CommentsQueryResult = {
  __typename?: 'CommentsQueryResult'
  comments: Array<Comment>
  totalRecords: Scalars['Int']['output']
}

export type Component = {
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
}

export enum ComponentDirection {
  BottomToTop = 'BottomToTop',
  LeftToRight = 'LeftToRight',
  RightToLeft = 'RightToLeft',
  TopToBottom = 'TopToBottom',
}

export enum ComponentType {
  Button = 'Button',
  Column = 'Column',
  Comments = 'Comments',
  CountdownTimer = 'CountdownTimer',
  DollarHandles = 'DollarHandles',
  DonationForm = 'DonationForm',
  Empty = 'Empty',
  Footer = 'Footer',
  FundraiserButton = 'FundraiserButton',
  FundraiserProfile = 'FundraiserProfile',
  Header = 'Header',
  Image = 'Image',
  Leaderboard = 'Leaderboard',
  LoginForm = 'LoginForm',
  PageOptions = 'PageOptions',
  PostDonationForm = 'PostDonationForm',
  ProgressBar = 'ProgressBar',
  ProgressImage = 'ProgressImage',
  RegisterForm = 'RegisterForm',
  Row = 'Row',
  SocialShare = 'SocialShare',
  Text = 'Text',
  Video = 'Video',
  VirtualGiftAmountSelector = 'VirtualGiftAmountSelector',
  VirtualGiftItemDownload = 'VirtualGiftItemDownload',
  VirtualGiftPaymentForm = 'VirtualGiftPaymentForm',
  VirtualGiftPersonalisation = 'VirtualGiftPersonalisation',
  VirtualGiftPreviewImage = 'VirtualGiftPreviewImage',
  VirtualGiftSection = 'VirtualGiftSection',
}

export enum ComponentTypeInput {
  ButtonElement = 'ButtonElement',
  ColumnElement = 'ColumnElement',
  CommentsElement = 'CommentsElement',
  CountdownTimerElement = 'CountdownTimerElement',
  CustomFieldElement = 'CustomFieldElement',
  DollarHandlesElement = 'DollarHandlesElement',
  DonationFormElement = 'DonationFormElement',
  EmptyElement = 'EmptyElement',
  FooterElement = 'FooterElement',
  FundraiserButtonElement = 'FundraiserButtonElement',
  FundraiserProfileElement = 'FundraiserProfileElement',
  HeaderElement = 'HeaderElement',
  ImageElement = 'ImageElement',
  LeaderboardElement = 'LeaderboardElement',
  LoginFormElement = 'LoginFormElement',
  PageOptionsElement = 'PageOptionsElement',
  PostDonationFormElement = 'PostDonationFormElement',
  ProgressBarElement = 'ProgressBarElement',
  ProgressImageElement = 'ProgressImageElement',
  RegisterFormElement = 'RegisterFormElement',
  RowElement = 'RowElement',
  SocialShareElement = 'SocialShareElement',
  TextElement = 'TextElement',
  VideoElement = 'VideoElement',
  VirtualGiftSectionElement = 'VirtualGiftSectionElement',
}

export type ComponentsInput = {
  buttonElements?: InputMaybe<Array<ButtonInput>>
  columnElements?: InputMaybe<Array<ColumnInput>>
  commentsElements?: InputMaybe<Array<CommentsInput>>
  countdownTimerElements?: InputMaybe<Array<CountdownTimerInput>>
  customFieldElements?: InputMaybe<Array<CustomFieldElementInput>>
  dollarHandlesElements?: InputMaybe<Array<DollarHandlesInput>>
  donationFormElements?: InputMaybe<Array<DonationFormInput>>
  fundraiserButtonElements?: InputMaybe<Array<FundraiserButtonInput>>
  fundraiserProfileElements?: InputMaybe<Array<FundraiserProfileInput>>
  imageElements?: InputMaybe<Array<ImageInput>>
  leaderboardElements?: InputMaybe<Array<LeaderboardInput>>
  loginFormElements?: InputMaybe<Array<LoginFormInput>>
  pageOptionsElements?: InputMaybe<Array<PageOptionsInput>>
  postDonationFormElements?: InputMaybe<Array<PostDonationFormInput>>
  progressBarElements?: InputMaybe<Array<ProgressBarInput>>
  progressImageElements?: InputMaybe<Array<ProgressImageInput>>
  registerFormElements?: InputMaybe<Array<RegisterFormInput>>
  rowElements?: InputMaybe<Array<RowInput>>
  socialShareElements?: InputMaybe<Array<SocialShareInput>>
  textElements?: InputMaybe<Array<TextInput>>
  videoElements?: InputMaybe<Array<VideoInput>>
  virtualGiftSectionElements?: InputMaybe<Array<VirtualGiftSectionInput>>
}

export type CountdownTimer = Component & {
  __typename?: 'CountdownTimer'
  bonusFinishTimes?: Maybe<Array<Scalars['DateTime']['output']>>
  end?: Maybe<Scalars['DateTime']['output']>
  finish?: Maybe<Scalars['DateTime']['output']>
  hideBeforeStart?: Maybe<Scalars['Boolean']['output']>
  hideOnEnd?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  start?: Maybe<Scalars['DateTime']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
}

export type CountdownTimerAggregationSetting = AggregationSetting & {
  __typename?: 'CountdownTimerAggregationSetting'
  groupSettings?: Maybe<Array<CountdownTimerAggregationSettingItem>>
  isAllPagesLinked?: Maybe<Scalars['Boolean']['output']>
}

export type CountdownTimerAggregationSettingItem = AggregationSettingItem & {
  __typename?: 'CountdownTimerAggregationSettingItem'
  bonusFinishTimes?: Maybe<Array<Scalars['DateTime']['output']>>
  dataSources?: Maybe<Array<Scalars['ID']['output']>>
  endVisibleTime?: Maybe<Scalars['DateTime']['output']>
  finishTime?: Maybe<Scalars['DateTime']['output']>
  groupId: Scalars['ID']['output']
  groupName?: Maybe<Scalars['String']['output']>
  isAllPagesLinked?: Maybe<Scalars['Boolean']['output']>
  pageBucketIds?: Maybe<Array<Scalars['ID']['output']>>
  pageIds: Array<Scalars['ID']['output']>
  startVisibleTime?: Maybe<Scalars['DateTime']['output']>
}

export type CountdownTimerAggregationSettingItemInput = {
  bonusFinishTimes?: InputMaybe<Array<Scalars['DateTime']['input']>>
  endVisibleTime?: InputMaybe<Scalars['DateTime']['input']>
  finishTime?: InputMaybe<Scalars['DateTime']['input']>
  groupId: Scalars['ID']['input']
  groupName?: InputMaybe<Scalars['String']['input']>
  pageBucketIds?: InputMaybe<Array<Scalars['ID']['input']>>
  pageIds: Array<Scalars['ID']['input']>
  startVisibleTime?: InputMaybe<Scalars['DateTime']['input']>
}

export type CountdownTimerInput = {
  componentId: Scalars['ID']['input']
  end?: InputMaybe<Scalars['DateTime']['input']>
  finish?: InputMaybe<Scalars['DateTime']['input']>
  hideBeforeStart?: InputMaybe<Scalars['Boolean']['input']>
  hideOnEnd?: InputMaybe<Scalars['Boolean']['input']>
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  start?: InputMaybe<Scalars['DateTime']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  type: ComponentTypeInput
}

export enum CountdownTimerVariation {
  Compact = 'Compact',
  Full = 'Full',
}

export type CreateBrandingApiResponse = {
  __typename?: 'CreateBrandingAPIResponse'
  brandingId: Scalars['ID']['output']
}

export type CreateBrandingInput = {
  isDefault: Scalars['Boolean']['input']
  logoFileContentType: Scalars['String']['input']
  name: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type CreateBrandingResponse = {
  __typename?: 'CreateBrandingResponse'
  id: Scalars['ID']['output']
}

export type CreateCampaignApiResponse = {
  __typename?: 'CreateCampaignAPIResponse'
  campaignId: Scalars['ID']['output']
  campaignTitle: Scalars['String']['output']
  campaignType: CampaignType
  endDate?: Maybe<Scalars['String']['output']>
  goal?: Maybe<Scalars['Float']['output']>
  startDate?: Maybe<Scalars['String']['output']>
}

export type CreateCampaignInput = {
  endAt?: InputMaybe<Scalars['String']['input']>
  goal?: InputMaybe<Scalars['Float']['input']>
  startAt?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  type: CampaignType
}

export type CreateCharityInput = {
  abn?: InputMaybe<Scalars['String']['input']>
  auth0Id: Scalars['String']['input']
  name: Scalars['String']['input']
}

export type CreateCharityResult = {
  __typename?: 'CreateCharityResult'
  charityId: Scalars['String']['output']
  charityUserId: Scalars['String']['output']
}

export type CreateManualDonationInput = {
  address?: InputMaybe<AddressInput>
  amount: Scalars['Float']['input']
  campaignId: Scalars['ID']['input']
  comment?: InputMaybe<Scalars['String']['input']>
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  isAnonymous: Scalars['Boolean']['input']
  lastName: Scalars['String']['input']
  mobile?: InputMaybe<Scalars['String']['input']>
  mode: Mode
  organisation?: InputMaybe<Scalars['String']['input']>
  pageId: Scalars['ID']['input']
  paymentMethodId: Scalars['String']['input']
  profileId?: InputMaybe<Scalars['ID']['input']>
  profileName?: InputMaybe<Scalars['String']['input']>
  receiptOption: GivingReceiptOptionSetting
  stripeCustomerId: Scalars['String']['input']
}

export type CreateManualSubscriptionInput = {
  address?: InputMaybe<AddressInput>
  amount: Scalars['Float']['input']
  campaignId: Scalars['ID']['input']
  comment?: InputMaybe<Scalars['String']['input']>
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  givingFrequency: DonationFrequency
  isAnonymous: Scalars['Boolean']['input']
  lastName: Scalars['String']['input']
  mobile?: InputMaybe<Scalars['String']['input']>
  mode: Mode
  nextPaymentDate: Scalars['String']['input']
  organisation?: InputMaybe<Scalars['String']['input']>
  pageId: Scalars['ID']['input']
  paymentMethodId: Scalars['String']['input']
  profileId?: InputMaybe<Scalars['ID']['input']>
  profileName?: InputMaybe<Scalars['String']['input']>
  receiptOption: SubscriptionReceiptOptionSetting
  stripeCustomerId: Scalars['String']['input']
}

export type CreateOfflineDonationInput = {
  address?: InputMaybe<AddressInput>
  amount: Scalars['Float']['input']
  campaignId: Scalars['ID']['input']
  comment?: InputMaybe<Scalars['String']['input']>
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  isAnonymous: Scalars['Boolean']['input']
  lastName: Scalars['String']['input']
  mobile?: InputMaybe<Scalars['String']['input']>
  mode: Mode
  organisation?: InputMaybe<Scalars['String']['input']>
  pageId: Scalars['ID']['input']
  postComment?: Scalars['Boolean']['input']
  profileId?: InputMaybe<Scalars['ID']['input']>
  profileName?: InputMaybe<Scalars['String']['input']>
  sendReceipt: Scalars['Boolean']['input']
}

export type CreateOrderInput = {
  campaignId: Scalars['ID']['input']
  cancelUrl: Scalars['String']['input']
  charityId: Scalars['ID']['input']
  currency: Scalars['String']['input']
  deviceUUID?: InputMaybe<Scalars['String']['input']>
  donationFormAmount: Scalars['Float']['input']
  donationPageUrl: Scalars['String']['input']
  donorPaysAmount?: InputMaybe<Scalars['Float']['input']>
  email: Scalars['String']['input']
  eventId?: InputMaybe<Scalars['String']['input']>
  fbc?: InputMaybe<Scalars['String']['input']>
  fbp?: InputMaybe<Scalars['String']['input']>
  isDonorChooseToPayFee?: InputMaybe<Scalars['Boolean']['input']>
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
  pageBucketId?: InputMaybe<Scalars['ID']['input']>
  pageId: Scalars['ID']['input']
  profileId?: InputMaybe<Scalars['ID']['input']>
  profileName?: InputMaybe<Scalars['String']['input']>
  returnUrl: Scalars['String']['input']
}

export type CreateOrderResponse = {
  __typename?: 'CreateOrderResponse'
  aggregateId: Scalars['String']['output']
  id?: Maybe<Scalars['String']['output']>
  orderUrl?: Maybe<Scalars['String']['output']>
  payerActionUrl?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
}

export type CreatePageBucketInput = {
  campaignId: Scalars['ID']['input']
  pageId: Scalars['ID']['input']
}

export type CreatePageInput = {
  campaignId: Scalars['ID']['input']
  htmlLayout?: InputMaybe<Scalars['String']['input']>
  pageLayout?: InputMaybe<PageLayoutInput>
  pageName?: InputMaybe<Scalars['String']['input']>
  pageType: PageType
}

export type CreatePageStateInput = {
  campaignId: Scalars['ID']['input']
  htmlLayout?: InputMaybe<Scalars['String']['input']>
  isPartOfGivingDayInit?: InputMaybe<Scalars['Boolean']['input']>
  pageBucketId?: InputMaybe<Scalars['ID']['input']>
  pageLayout?: InputMaybe<PageLayoutInput>
  pageName?: InputMaybe<Scalars['String']['input']>
}

export type CreatePaymentIntentInput = {
  campaignId: Scalars['ID']['input']
  charityId: Scalars['ID']['input']
  currency: Scalars['String']['input']
  deviceUUID?: InputMaybe<Scalars['String']['input']>
  donationFormAmount: Scalars['Float']['input']
  donationPageUrl: Scalars['String']['input']
  donorPaysAmount?: InputMaybe<Scalars['Float']['input']>
  email: Scalars['String']['input']
  eventId?: InputMaybe<Scalars['String']['input']>
  fbc?: InputMaybe<Scalars['String']['input']>
  fbp?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  isDonorChooseToPayFee?: InputMaybe<Scalars['Boolean']['input']>
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  pageBucketId?: InputMaybe<Scalars['ID']['input']>
  pageId: Scalars['ID']['input']
  paymentMethodType: PaymentMethodType
  profileId?: InputMaybe<Scalars['ID']['input']>
  profileName?: InputMaybe<Scalars['String']['input']>
}

export type CreatePaymentIntentResponse = {
  __typename?: 'CreatePaymentIntentResponse'
  clientSecret: Scalars['String']['output']
  paymentIntentId?: Maybe<Scalars['String']['output']>
  paymentTransactionId: Scalars['String']['output']
}

export type CreatePaypalReferralLinkInput = {
  merchantEmail: Scalars['String']['input']
  mode: Mode
}

export type CreatePaypalReferralLinkResponse = {
  __typename?: 'CreatePaypalReferralLinkResponse'
  merchantEmail: Scalars['String']['output']
  referralLink: Scalars['String']['output']
  referralToken: Scalars['String']['output']
}

export type CreateProfileCategoryInput = {
  campaignId: Scalars['ID']['input']
  name: Scalars['String']['input']
  pageId?: InputMaybe<Scalars['ID']['input']>
  type: ProfileEntity
}

export type CreateSubscriptionInput = {
  campaignId: Scalars['ID']['input']
  charityId: Scalars['ID']['input']
  currency: Scalars['String']['input']
  deviceUUID?: InputMaybe<Scalars['String']['input']>
  donationFormAmount: Scalars['Float']['input']
  donationPageUrl: Scalars['String']['input']
  donorPaysAmount?: InputMaybe<Scalars['Float']['input']>
  email: Scalars['String']['input']
  eventId?: InputMaybe<Scalars['String']['input']>
  fbc?: InputMaybe<Scalars['String']['input']>
  fbp?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  givingFrequency: DonationFrequency
  installment?: InputMaybe<InstallmentInput>
  isDonorChooseToPayFee?: InputMaybe<Scalars['Boolean']['input']>
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  pageBucketId?: InputMaybe<Scalars['ID']['input']>
  pageId: Scalars['ID']['input']
  paymentMethodType: PaymentMethodType
  profileId?: InputMaybe<Scalars['ID']['input']>
  profileName?: InputMaybe<Scalars['String']['input']>
}

export type CreateSubscriptionResponse = {
  __typename?: 'CreateSubscriptionResponse'
  clientSecret: Scalars['String']['output']
  paymentSubscriptionId: Scalars['String']['output']
  subscriptionId: Scalars['String']['output']
}

export type CreateTemplateInput = {
  htmlLayout?: InputMaybe<Scalars['String']['input']>
  layout: PageLayoutInput
  name: Scalars['String']['input']
  pageType: PageType
  screenshotImageUrl?: InputMaybe<Scalars['String']['input']>
  type: CharityTemplateType
}

export type CreateUserForCharityInput = {
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
  roleId: Scalars['String']['input']
}

export type CustomField = {
  __typename?: 'CustomField'
  acceptedValues?: Maybe<Array<CustomFieldValue>>
  elementType: CustomFieldElementType
  fieldDescription?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type CustomFieldElementInput = {
  acceptedValues?: InputMaybe<Array<CustomFieldValueInput>>
  customFieldSettingId: Scalars['ID']['input']
  defaultValue?: InputMaybe<Scalars['String']['input']>
  elementType: CustomFieldElementType
  fieldDescription?: InputMaybe<Scalars['String']['input']>
  fieldType: CustomFieldType
  isRequired: Scalars['Boolean']['input']
  label: Scalars['String']['input']
}

export enum CustomFieldElementType {
  Checkbox = 'Checkbox',
  DatePicker = 'DatePicker',
  Dropdown = 'Dropdown',
  Hidden = 'Hidden',
  InputText = 'InputText',
  MultiSelect = 'MultiSelect',
  RadioButton = 'RadioButton',
  SingleSelect = 'SingleSelect',
  Switch = 'Switch',
  TextArea = 'TextArea',
}

export type CustomFieldInput = {
  acceptedValues?: InputMaybe<Array<CustomFieldValueInput>>
  elementType: CustomFieldElementType
  fieldDescription?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  name: Scalars['String']['input']
}

export type CustomFieldSetting = {
  __typename?: 'CustomFieldSetting'
  acceptedValues?: Maybe<Array<CustomFieldValue>>
  defaultValue?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  elementType: CustomFieldElementType
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  type: CustomFieldType
}

export type CustomFieldSettingInput = {
  acceptedValues?: InputMaybe<Array<CustomFieldValueInput>>
  defaultValue?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  elementType: CustomFieldElementType
  id?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  type: CustomFieldType
}

export enum CustomFieldType {
  Address = 'Address',
  Custom = 'Custom',
  DateOfBirth = 'DateOfBirth',
}

export type CustomFieldValue = {
  __typename?: 'CustomFieldValue'
  key: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type CustomFieldValueInput = {
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type DateTimeTrigger = {
  __typename?: 'DateTimeTrigger'
  amountTriggers: Array<AmountTrigger>
  dateTimeStart: Scalars['DateTime']['output']
  pageId: Scalars['ID']['output']
}

export type DateTimeTriggerInput = {
  amountTriggers: Array<AmountTriggerInput>
  dateTimeStart: Scalars['DateTime']['input']
  pageId: Scalars['ID']['input']
}

export type DeleteAnalyticsSettingInput = {
  settingId: Scalars['String']['input']
  type?: InputMaybe<AnalyticsType>
}

export type DeleteCampaignInput = {
  campaignId: Scalars['ID']['input']
}

export type DeletePageInput = {
  campaignId: Scalars['ID']['input']
  pageId: Scalars['ID']['input']
  pageType: PageType
}

export type DollarHandle = {
  __typename?: 'DollarHandle'
  amount: Scalars['Int']['output']
  description?: Maybe<Scalars['String']['output']>
  hasDescription?: Maybe<Scalars['Boolean']['output']>
  hasImage?: Maybe<Scalars['Boolean']['output']>
  imageUrl?: Maybe<Scalars['String']['output']>
  isPersonalised?: Maybe<Scalars['Boolean']['output']>
  text?: Maybe<Text>
}

export type DollarHandleInput = {
  amount: Scalars['Int']['input']
  description?: InputMaybe<Scalars['String']['input']>
  hasDescription?: InputMaybe<Scalars['Boolean']['input']>
  hasImage?: InputMaybe<Scalars['Boolean']['input']>
  imageUrl?: InputMaybe<Scalars['String']['input']>
  isPersonalised?: InputMaybe<Scalars['Boolean']['input']>
  text?: InputMaybe<TextInput>
}

export type DollarHandles = Component & {
  __typename?: 'DollarHandles'
  dollarHandles: Array<DollarHandle>
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
}

export type DollarHandlesInput = {
  componentId: Scalars['ID']['input']
  dollarHandles: Array<DollarHandleInput>
  hasDescription?: InputMaybe<Scalars['Boolean']['input']>
  hasImage?: InputMaybe<Scalars['Boolean']['input']>
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  type: ComponentTypeInput
}

export type DonatedTo = {
  __typename?: 'DonatedTo'
  name: Scalars['String']['output']
  slug: Scalars['String']['output']
}

export type DonationForm = Component & {
  __typename?: 'DonationForm'
  dollarHandles: Array<DollarHandle>
  dollarHandlesDefault?: Maybe<Scalars['Int']['output']>
  donationFrequency: Array<DonationFrequency>
  donationFrequencyDefault?: Maybe<Scalars['Int']['output']>
  extraFields: Array<ExtraField>
  id: Scalars['ID']['output']
  legalUrl?: Maybe<Scalars['String']['output']>
  matchedGivings?: Maybe<Array<CampaignMatchedGivingSetting>>
  minimumAmount?: Maybe<Scalars['Int']['output']>
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  text?: Maybe<Text>
  title?: Maybe<Scalars['String']['output']>
  type: ComponentType
}

export type DonationFormInput = {
  componentId: Scalars['ID']['input']
  dollarHandles: Array<DollarHandleInput>
  dollarHandlesDefault?: InputMaybe<Scalars['Int']['input']>
  donationFrequency: Array<DonationFrequency>
  donationFrequencyDefault?: InputMaybe<Scalars['Int']['input']>
  extraFields: Array<ExtraFieldInput>
  legalUrl?: InputMaybe<Scalars['String']['input']>
  matchedGiving?: InputMaybe<MatchedGivingInput>
  minimumAmount?: InputMaybe<Scalars['Int']['input']>
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  text?: InputMaybe<TextInput>
  title?: InputMaybe<Scalars['String']['input']>
  type: ComponentTypeInput
}

export enum DonationFrequency {
  Every_4Weeks = 'EVERY_4_WEEKS',
  Fortnightly = 'FORTNIGHTLY',
  Monthly = 'MONTHLY',
  OneTime = 'ONE_TIME',
  Quarterly = 'QUARTERLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY',
}

export enum DonationFrequencyFilter {
  OnceOff = 'OnceOff',
  Recurring = 'Recurring',
}

export type DonationPagePaymentProviderSettings = {
  __typename?: 'DonationPagePaymentProviderSettings'
  payPalMerchantSetting?: Maybe<PayPalMerchantSetting>
  stripePaymentSettings?: Maybe<StripePaymentSettings>
}

export type DonorGiving = {
  __typename?: 'DonorGiving'
  amount: Scalars['Float']['output']
  campaignTitle?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTime']['output']
  donationFrequencyType: GivingDonationFrequency
  givingId: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  paymentMethodType: PaymentMethodType
  status: GivingStatus
}

export type DonorGivingsQueryResult = {
  __typename?: 'DonorGivingsQueryResult'
  items: Array<DonorGiving>
  totalRecords: Scalars['Int']['output']
}

export type DonorPortalSlugResponse = {
  __typename?: 'DonorPortalSlugResponse'
  branding?: Maybe<Scalars['String']['output']>
  charityId: Scalars['ID']['output']
  donorPortalRegularGivingPermissions: CharityDonorPortalRegularGivingPermissions
}

export type DonorProfile = {
  __typename?: 'DonorProfile'
  firstName?: Maybe<Scalars['String']['output']>
  lastName?: Maybe<Scalars['String']['output']>
}

export type DonorSubscription = {
  __typename?: 'DonorSubscription'
  amount: Scalars['Float']['output']
  campaignTitle?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTime']['output']
  externalSubscriptionId: Scalars['String']['output']
  frequency: GivingDonationFrequency
  lastInvoice?: Maybe<SubscriptionInvoice>
  name?: Maybe<Scalars['String']['output']>
  nextPaymentDate?: Maybe<Scalars['DateTime']['output']>
  paymentMethodType: PaymentMethodType
  regularGivings: Array<DonorSubscriptionRegularGiving>
  resumeAt?: Maybe<Scalars['DateTime']['output']>
  scheduledUpdate?: Maybe<SubscriptionScheduledUpdate>
  status: SubscriptionStatus
  subscriptionEndDate?: Maybe<Scalars['DateTime']['output']>
  subscriptionId: Scalars['ID']['output']
  subscriptionStartDate: Scalars['DateTime']['output']
}

export type DonorSubscriptionRegularGiving = {
  __typename?: 'DonorSubscriptionRegularGiving'
  amount: Scalars['Float']['output']
  createdAt: Scalars['DateTime']['output']
  name?: Maybe<Scalars['String']['output']>
  paymentMethodType: PaymentMethodType
  regularGivingId: Scalars['ID']['output']
  status: GivingStatus
}

export type DonorSubscriptionsQueryResult = {
  __typename?: 'DonorSubscriptionsQueryResult'
  items: Array<DonorSubscription>
  totalRecords: Scalars['Int']['output']
}

export type DonorSummaryInput = {
  email: Scalars['String']['input']
  endDate: Scalars['DateTime']['input']
  isLiveMode: Scalars['Boolean']['input']
  startDate: Scalars['DateTime']['input']
}

export type DuplicateCampaignInput = {
  campaign: CreateCampaignInput
  campaignId: Scalars['ID']['input']
  duplicateSettings: Scalars['Boolean']['input']
  pagesToDuplicate: Array<Scalars['ID']['input']>
}

export type DuplicatePageInput = {
  campaignId: Scalars['ID']['input']
  pageId: Scalars['ID']['input']
  pageType: PageType
}

export type DuplicatePageStateInput = {
  campaignId: Scalars['ID']['input']
  pageBucketId: Scalars['ID']['input']
  pageId: Scalars['ID']['input']
  pageName?: InputMaybe<Scalars['String']['input']>
}

export type ElementSettings = {
  __typename?: 'ElementSettings'
  matchedGivings?: Maybe<Array<CampaignMatchedGivingSetting>>
  progressBar?: Maybe<ProgressBarAggregationSettingItem>
}

export type EmailReceiptSettingItem = {
  __typename?: 'EmailReceiptSettingItem'
  from?: Maybe<Scalars['String']['output']>
  receiptPageId: Scalars['ID']['output']
  replyTo?: Maybe<Scalars['String']['output']>
  subject?: Maybe<Scalars['String']['output']>
}

export type EmailReceiptSettings = {
  __typename?: 'EmailReceiptSettings'
  items?: Maybe<Array<EmailReceiptSettingItem>>
  profileRegisteredNotificationEmails?: Maybe<Array<PeerToPeerFundraiserRegistrationNotificationSettingValue>>
  profileRegisteredNotificationEmailsEnabled?: Maybe<Scalars['Boolean']['output']>
  receiptOptionSetting?: Maybe<ReceiptOptionSetting>
}

export type Empty = Component & {
  __typename?: 'Empty'
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
}

export type ExchangeStripeOAuthInput = {
  code: Scalars['String']['input']
  state: Scalars['String']['input']
}

export type ExtraField = {
  __typename?: 'ExtraField'
  conditionalFields?: Maybe<Array<ExtraField>>
  customField?: Maybe<CustomField>
  defaultValue?: Maybe<Scalars['String']['output']>
  hideLabel?: Maybe<Scalars['Boolean']['output']>
  isHidden?: Maybe<Scalars['Boolean']['output']>
  isRequired: Scalars['Boolean']['output']
  label: Scalars['String']['output']
  name: Scalars['String']['output']
  order?: Maybe<Scalars['Int']['output']>
  placeholder?: Maybe<Scalars['String']['output']>
  type: ExtraFieldType
}

export type ExtraFieldInput = {
  conditionalFields?: InputMaybe<Array<ExtraFieldInput>>
  customField?: InputMaybe<CustomFieldInput>
  defaultValue?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  isHidden?: InputMaybe<Scalars['Boolean']['input']>
  isRequired: Scalars['Boolean']['input']
  label: Scalars['String']['input']
  name: Scalars['String']['input']
  order?: InputMaybe<Scalars['Int']['input']>
  placeholder?: InputMaybe<Scalars['String']['input']>
  type: ExtraFieldType
}

export enum ExtraFieldType {
  Address = 'Address',
  Comments = 'Comments',
  Custom = 'Custom',
  DedicateTo = 'DedicateTo',
  Email = 'Email',
  Phone = 'Phone',
  Profile = 'Profile',
  Text = 'Text',
}

export type FeatureFlag = {
  __typename?: 'FeatureFlag'
  enabled: Scalars['Boolean']['output']
  key: Scalars['String']['output']
}

export type FeeRange = {
  __typename?: 'FeeRange'
  endRange?: Maybe<Scalars['Float']['output']>
  fixFee?: Maybe<Scalars['Float']['output']>
  percentageFee?: Maybe<Scalars['Float']['output']>
  startRange?: Maybe<Scalars['Float']['output']>
}

export type FindCampaignAssetsResponse = {
  __typename?: 'FindCampaignAssetsResponse'
  assetId: Scalars['ID']['output']
  categoryType?: Maybe<AssetCategoryType>
  fileName: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type Footer = Component & {
  __typename?: 'Footer'
  id: Scalars['ID']['output']
  keyInformation?: Maybe<Text>
  keyInformationText?: Maybe<Scalars['String']['output']>
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  taxDeductible?: Maybe<Text>
  taxDeductibleText?: Maybe<Scalars['String']['output']>
  type: ComponentType
}

export type FooterInput = {
  componentId: Scalars['ID']['input']
  keyInformation?: InputMaybe<TextInput>
  keyInformationText?: InputMaybe<Scalars['String']['input']>
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  taxDeductible?: InputMaybe<TextInput>
  taxDeductibleText?: InputMaybe<Scalars['String']['input']>
  type: ComponentTypeInput
}

export type FormCustomFieldInput = {
  customFieldSettingId?: InputMaybe<Scalars['ID']['input']>
  name: Scalars['String']['input']
  values: Array<Scalars['String']['input']>
}

export type FormData = {
  __typename?: 'FormData'
  formId: Scalars['ID']['output']
  formValues: Array<FormValue>
  id: Scalars['ID']['output']
}

export type FormDataQueryResult = {
  __typename?: 'FormDataQueryResult'
  formData: Array<FormData>
  headers: Array<Scalars['String']['output']>
}

export type FormValue = {
  __typename?: 'FormValue'
  customFieldSettingId?: Maybe<Scalars['ID']['output']>
  name?: Maybe<Scalars['String']['output']>
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export type FundraiserButton = Component & {
  __typename?: 'FundraiserButton'
  id: Scalars['ID']['output']
  loginForm: LoginForm
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  registerForm: RegisterForm
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
}

export type FundraiserButtonInput = {
  componentId: Scalars['ID']['input']
  loginForm: LoginFormInput
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  registerForm: RegisterFormInput
  styles?: InputMaybe<Scalars['JSON']['input']>
  type: ComponentTypeInput
}

export type FundraiserProfile = Component & {
  __typename?: 'FundraiserProfile'
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
}

export type FundraiserProfileInput = {
  componentId: Scalars['ID']['input']
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  subComponents: Scalars['JSON']['input']
  type: ComponentTypeInput
}

export type FundraiserProfileSubcomponents = {
  __typename?: 'FundraiserProfileSubcomponents'
  profileName: Scalars['ID']['output']
  socialShare?: Maybe<Scalars['ID']['output']>
}

export type FundraiserRegistrationEmailInput = {
  displayName: Scalars['String']['input']
  email: Scalars['String']['input']
}

export type Ga4IntegrationSetting = {
  __typename?: 'Ga4IntegrationSetting'
  measurementId: Scalars['String']['output']
  name: Scalars['String']['output']
  settingId: Scalars['ID']['output']
}

export type Ga4IntegrationSettingInput = {
  measurementId: Scalars['String']['input']
  name: Scalars['String']['input']
}

export type GetCampaignPaymentSettingsApiResponse = {
  __typename?: 'GetCampaignPaymentSettingsAPIResponse'
  payPalSetting?: Maybe<CharityPayPalSettings>
  platformFeeType?: Maybe<PlatformFeeType>
  stripeSetting?: Maybe<CharityStripeSettings>
}

export type GetCampaignPerformanceStatsQueryResult = {
  __typename?: 'GetCampaignPerformanceStatsQueryResult'
  averageDonationAmount: Scalars['Float']['output']
  donationAmounts: Array<CampaignDonorAmountStat>
  donationCount: Scalars['Int']['output']
  donationsByDates: Array<CampaignDonationByDateStat>
  pageDonationAmounts: Array<CampaignPageDonationAmountStat>
  totalAmount: Scalars['Float']['output']
  utmTagDonationAmounts: Array<CampaignUtmTagDonationAmountStat>
}

export type Giving = {
  __typename?: 'Giving'
  campaign: GivingCampaignDetail
  comment?: Maybe<GivingCommentDetail>
  createdAt: Scalars['DateTime']['output']
  currencyCode: Scalars['String']['output']
  donatedAmount: Scalars['Float']['output']
  donationFrequency: GivingDonationFrequency
  donor?: Maybe<GivingDonorDetail>
  donorPaysAmount?: Maybe<Scalars['Float']['output']>
  givingId: Scalars['ID']['output']
  page: GivingPageDetail
  paymentMethodType: PaymentMethodType
  paypal?: Maybe<GivingPaypalTransactionDetail>
  platformFeesAmount?: Maybe<Scalars['Float']['output']>
  refundedAmount: Scalars['Float']['output']
  status: GivingStatus
  stripe?: Maybe<GivingStripeTransactionDetail>
  transactionId?: Maybe<Scalars['ID']['output']>
}

export type GivingCampaignDetail = {
  __typename?: 'GivingCampaignDetail'
  campaignId: Scalars['String']['output']
  campaignTitle?: Maybe<Scalars['String']['output']>
}

export type GivingCommentDetail = {
  __typename?: 'GivingCommentDetail'
  commentId: Scalars['ID']['output']
  message?: Maybe<Scalars['String']['output']>
}

export enum GivingDonationFrequency {
  Every4Weeks = 'Every4Weeks',
  Fortnightly = 'Fortnightly',
  Monthly = 'Monthly',
  OneTime = 'OneTime',
  Quarterly = 'Quarterly',
  Weekly = 'Weekly',
  Yearly = 'Yearly',
}

export type GivingDonorDetail = {
  __typename?: 'GivingDonorDetail'
  donationFormFirstName?: Maybe<Scalars['String']['output']>
  donationFormLastName?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  externalFirstName?: Maybe<Scalars['String']['output']>
  externalLastName?: Maybe<Scalars['String']['output']>
  fullName?: Maybe<Scalars['String']['output']>
}

export enum GivingFrequencyType {
  OneOff = 'OneOff',
  Recurring = 'Recurring',
}

export type GivingPageDetail = {
  __typename?: 'GivingPageDetail'
  pageId: Scalars['ID']['output']
  pageName?: Maybe<Scalars['String']['output']>
}

export type GivingPaypalTransactionDetail = {
  __typename?: 'GivingPaypalTransactionDetail'
  captureId?: Maybe<Scalars['String']['output']>
  orderId: Scalars['String']['output']
}

export enum GivingReceiptOptionSetting {
  Always = 'Always',
  None = 'None',
}

export enum GivingStatus {
  Cancelled = 'Cancelled',
  Failed = 'Failed',
  Incomplete = 'Incomplete',
  PartiallyRefunded = 'PartiallyRefunded',
  Pending = 'Pending',
  Refunded = 'Refunded',
  Succeeded = 'Succeeded',
  Unknown = 'Unknown',
}

export type GivingStripeTransactionDetail = {
  __typename?: 'GivingStripeTransactionDetail'
  paymentIntentId?: Maybe<Scalars['String']['output']>
}

export enum GivingType {
  Facebook = 'Facebook',
  Internal = 'Internal',
  Offline = 'Offline',
}

export type GivingsFilterInput = {
  donationFrequency?: InputMaybe<DonationFrequencyFilter>
  mode?: InputMaybe<Mode>
  paymentMethod?: InputMaybe<PaymentMethodType>
  search?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<GivingStatus>
}

export type GivingsQueryInput = {
  endDate?: InputMaybe<Scalars['String']['input']>
  filter?: InputMaybe<GivingsFilterInput>
  pageNumber: Scalars['Int']['input']
  pageSize?: InputMaybe<Scalars['Int']['input']>
  startDate?: InputMaybe<Scalars['String']['input']>
}

export type GivingsQueryResult = {
  __typename?: 'GivingsQueryResult'
  items: Array<Giving>
  totalRecords: Scalars['Int']['output']
}

export type GtmIntegrationSetting = {
  __typename?: 'GtmIntegrationSetting'
  name: Scalars['String']['output']
  settingId: Scalars['ID']['output']
  tagId: Scalars['String']['output']
}

export type GtmIntegrationSettingInput = {
  name: Scalars['String']['input']
  tagId: Scalars['String']['input']
}

export type Header = Component & {
  __typename?: 'Header'
  hasDonateButton: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
}

export type HeaderInput = {
  componentId: Scalars['ID']['input']
  hasDonateButton: Scalars['Boolean']['input']
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  type: ComponentTypeInput
}

export type IdentityPartnerSetting = {
  __typename?: 'IdentityPartnerSetting'
  items: Array<MoveDataIntegrationSetting>
}

export type IdentityPartnerSettingInput = {
  settingId?: InputMaybe<Scalars['ID']['input']>
  webhookUrl: Scalars['String']['input']
}

export type Image = Component & {
  __typename?: 'Image'
  alt?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  mergeFieldId?: Maybe<Scalars['String']['output']>
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
  url?: Maybe<Scalars['String']['output']>
}

export type ImageInput = {
  alt?: InputMaybe<Scalars['String']['input']>
  componentId: Scalars['ID']['input']
  mergeFieldId?: InputMaybe<Scalars['String']['input']>
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  type: ComponentTypeInput
  url?: InputMaybe<Scalars['String']['input']>
}

export type InitCampaignInput = {
  campaignId: Scalars['ID']['input']
  campaignType: CampaignType
  templateId: Scalars['ID']['input']
  templateType: TemplateType
}

export type InstallmentInput = {
  totalAmount?: InputMaybe<Scalars['Float']['input']>
  totalNumberOfInstallments: Scalars['Int']['input']
}

export type Leaderboard = Component & {
  __typename?: 'Leaderboard'
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
}

export type LeaderboardInput = {
  componentId: Scalars['ID']['input']
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  subComponents: Scalars['JSON']['input']
  type: ComponentTypeInput
}

export type LoginForm = Component & {
  __typename?: 'LoginForm'
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
}

export type LoginFormInput = {
  componentId: Scalars['ID']['input']
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  subComponents: Scalars['JSON']['input']
  type: ComponentTypeInput
}

export type LoginFormSubcomponents = {
  __typename?: 'LoginFormSubcomponents'
  title?: Maybe<Scalars['ID']['output']>
}

export type MatchedGivingAggregationSetting = AggregationSetting & {
  __typename?: 'MatchedGivingAggregationSetting'
  groupSettings?: Maybe<Array<MatchedGivingAggregationSettingItem>>
  isAllPagesLinked?: Maybe<Scalars['Boolean']['output']>
}

export type MatchedGivingAggregationSettingItem = AggregationSettingItem & {
  __typename?: 'MatchedGivingAggregationSettingItem'
  dataSources?: Maybe<Array<Scalars['ID']['output']>>
  groupId: Scalars['ID']['output']
  groupName?: Maybe<Scalars['String']['output']>
  isAllPagesLinked?: Maybe<Scalars['Boolean']['output']>
  matchedGivingSettingIds: Array<Scalars['ID']['output']>
  pageBucketIds?: Maybe<Array<Scalars['ID']['output']>>
  pageIds: Array<Scalars['ID']['output']>
}

export type MatchedGivingAggregationSettingItemInput = {
  groupId: Scalars['ID']['input']
  groupName?: InputMaybe<Scalars['String']['input']>
  matchedGivingSettingIds: Array<Scalars['ID']['input']>
  pageBucketIds?: InputMaybe<Array<Scalars['ID']['input']>>
  pageIds: Array<Scalars['ID']['input']>
}

export type MatchedGivingInput = {
  accentColor?: InputMaybe<ColorInput>
  dollarCap?: InputMaybe<Scalars['Int']['input']>
  multiplier: Scalars['Int']['input']
}

export type MatchedGivingProgressResult = {
  __typename?: 'MatchedGivingProgressResult'
  amount: Scalars['Float']['output']
}

export type MatchedGivingQueryResult = {
  __typename?: 'MatchedGivingQueryResult'
  items: Array<MatchedGivingRecord>
  totalRecords: Scalars['Int']['output']
}

export type MatchedGivingRecord = {
  __typename?: 'MatchedGivingRecord'
  campaignTitle: Scalars['String']['output']
  createdAt: Scalars['DateTime']['output']
  donorEmail: Scalars['String']['output']
  donorName: Scalars['String']['output']
  givingAmount: Scalars['Float']['output']
  givingId: Scalars['ID']['output']
  matchedAmount: Scalars['Float']['output']
  matchedDonationAmount: Scalars['Float']['output']
  matchedGivingId: Scalars['ID']['output']
  matchedGivingSettingName: Scalars['String']['output']
  multiplier: Scalars['Int']['output']
  pageName: Scalars['String']['output']
  totalAmount: Scalars['Float']['output']
}

export type MediaLibraryAsset = {
  __typename?: 'MediaLibraryAsset'
  altText?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  sizeInBytes?: Maybe<Scalars['Int']['output']>
  title?: Maybe<Scalars['String']['output']>
  uploadedAt: Scalars['DateTime']['output']
  uploadedBy?: Maybe<Scalars['ID']['output']>
  url: Scalars['String']['output']
}

export type MediaLibraryAssetsInput = {
  pageNumber?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<MediaLibrarySortBy>
  sortDirection?: InputMaybe<MediaLibrarySortDirection>
  uploadedFrom?: InputMaybe<Scalars['DateTime']['input']>
  uploadedTo?: InputMaybe<Scalars['DateTime']['input']>
}

export type MediaLibraryAssetsResult = {
  __typename?: 'MediaLibraryAssetsResult'
  items: Array<MediaLibraryAsset>
  totalCount: Scalars['Int']['output']
}

export enum MediaLibrarySortBy {
  Date = 'Date',
  Name = 'Name',
  Size = 'Size',
}

export enum MediaLibrarySortDirection {
  Asc = 'Asc',
  Desc = 'Desc',
}

export type MergeField = {
  __typename?: 'MergeField'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  tag: Scalars['String']['output']
}

export type MergeFieldSetting = {
  __typename?: 'MergeFieldSetting'
  CsvHeader?: Maybe<Scalars['String']['output']>
  IsAnimated?: Maybe<Scalars['Boolean']['output']>
  MergeFieldName: Scalars['String']['output']
  MergeFieldSettingId: Scalars['String']['output']
  MergeTag: Scalars['String']['output']
  MergeTagDisplayText?: Maybe<Scalars['String']['output']>
  MergeTagFallback?: Maybe<Scalars['String']['output']>
  MergeTagOptions?: Maybe<Scalars['JSON']['output']>
  MergeTagType?: Maybe<MergeTagType>
  QueryParameter: Scalars['String']['output']
  TemplateName?: Maybe<Scalars['String']['output']>
}

export enum MergeTagType {
  Dynamic = 'Dynamic',
  Formula = 'Formula',
  Link = 'Link',
  Static = 'Static',
  Super = 'Super',
}

export type Metadata = {
  __typename?: 'Metadata'
  campaign?: Maybe<CampaignMetadata>
  charity?: Maybe<CharityMetadata>
  page?: Maybe<PageMetadata>
}

export enum Mode {
  Live = 'Live',
  Test = 'Test',
}

export type MoveDataIntegrationSetting = {
  __typename?: 'MoveDataIntegrationSetting'
  settingId?: Maybe<Scalars['ID']['output']>
  webhookUrl: Scalars['String']['output']
}

export type Mutation = {
  __typename?: 'Mutation'
  addCampaignDomain: Scalars['ID']['output']
  addCampaignMatchedGivingSetting: AddCampaignMatchedGivingSettingResult
  addCustomFieldSetting: CustomFieldSetting
  addGa4Setting?: Maybe<Scalars['ID']['output']>
  addGtmSetting?: Maybe<Scalars['ID']['output']>
  addMergeField: Scalars['ID']['output']
  addPageBucketSlugsForCampaign?: Maybe<Array<Scalars['ID']['output']>>
  addPageSlugsForCampaign?: Maybe<Array<Scalars['ID']['output']>>
  addPayPalByReferral?: Maybe<Scalars['String']['output']>
  addPixelConversionsApiSetting?: Maybe<Scalars['ID']['output']>
  addRaiserEdgeIntegrationSetting?: Maybe<Scalars['String']['output']>
  approveIdentityPartnerSettings?: Maybe<Scalars['Boolean']['output']>
  approveRaiserEdgeIntegrationSetting?: Maybe<Scalars['Boolean']['output']>
  authenticateDonorToken: Scalars['String']['output']
  authenticateProfile: AuthenticateProfileResponse
  authenticateToken: Scalars['String']['output']
  cancelSubscription?: Maybe<Scalars['Boolean']['output']>
  changeRole?: Maybe<Scalars['Boolean']['output']>
  connectStripeStandardAccountOAuth?: Maybe<Scalars['String']['output']>
  createBranding: CreateBrandingResponse
  createCampaign: Campaign
  createCharity: CreateCharityResult
  createManualDonation?: Maybe<Scalars['ID']['output']>
  createManualSubscription?: Maybe<Scalars['ID']['output']>
  createOfflineDonation?: Maybe<Scalars['ID']['output']>
  createOrder: CreateOrderResponse
  createPage: PageResponse
  createPageBucket: PageResponse
  createPageState: PageResponse
  createPaymentIntent: CreatePaymentIntentResponse
  createPaypalReferralLink: CreatePaypalReferralLinkResponse
  createProfileCategory: Scalars['ID']['output']
  createStripeSubscriptionDonorPortalLink: StripeSubscriptionDonorPortalLink
  createSubscription: CreateSubscriptionResponse
  createTemplate: Scalars['ID']['output']
  createThankYouPage: PageResponse
  createUserForCharity?: Maybe<Scalars['Boolean']['output']>
  deleteAnalyticsSetting?: Maybe<Scalars['ID']['output']>
  deleteCampaign: Scalars['ID']['output']
  deleteCampaignAsset?: Maybe<Scalars['Boolean']['output']>
  deleteMediaLibraryAsset: Scalars['Boolean']['output']
  deletePage: Scalars['ID']['output']
  deleteTemplate: Scalars['ID']['output']
  deleteUserFromCharity?: Maybe<Scalars['Boolean']['output']>
  duplicateCampaign: Scalars['ID']['output']
  duplicatePage: PageResponse
  duplicatePageState: PageResponse
  duplicateThankYouPage: PageResponse
  exchangeStripeOAuthCode?: Maybe<Scalars['String']['output']>
  initCampaign: PageResponse
  initFundraiserPages?: Maybe<Scalars['Boolean']['output']>
  initGivingDayCampaign: PageResponse
  login: Scalars['String']['output']
  loginDonor: Scalars['String']['output']
  loginProfile: Scalars['String']['output']
  pauseSubscription?: Maybe<Scalars['Boolean']['output']>
  postComment: Scalars['Boolean']['output']
  publishPage: Array<PageDetail>
  publishThankYouPage: Array<PageDetail>
  recordStats?: Maybe<Scalars['Boolean']['output']>
  regenerateCustomerPortalSession: Scalars['Boolean']['output']
  registerEmail: RegisterEmailResponse
  registerProfile: RegisterProfileResult
  resendReceipt?: Maybe<Scalars['ID']['output']>
  resumeSubscription?: Maybe<SubscriptionStatus>
  saveDetails: PageResponse
  saveDraft: PageResponse
  savePageBucketDetails?: Maybe<Scalars['Boolean']['output']>
  savePageMetadata?: Maybe<Scalars['Boolean']['output']>
  saveThankYouPageDraft: PageResponse
  selectCharity?: Maybe<Scalars['Boolean']['output']>
  sendCharityTaxSummary: Scalars['Boolean']['output']
  sendTestEmail?: Maybe<Scalars['ID']['output']>
  setCampaignAnalyticsSettings: Scalars['ID']['output']
  setCampaignPayPalSettings: SetCampaignPaymentProviderSettingsResponse
  setCampaignPlatformFeeType?: Maybe<Scalars['ID']['output']>
  setCampaignStripeSettings: SetCampaignPaymentProviderSettingsResponse
  setCampaignTriggers?: Maybe<Scalars['String']['output']>
  setCharityBranding: Scalars['Boolean']['output']
  setCharityDetail: Scalars['ID']['output']
  setCharityDonorPortalPermissions?: Maybe<Scalars['Boolean']['output']>
  setCharityPageRedirectionSettings?: Maybe<Scalars['Boolean']['output']>
  setCharityPayPalSettings: SetPaymentProviderSettingsResponse
  setCharityPlatformFee?: Maybe<Scalars['String']['output']>
  setCharityStripeSettings: SetPaymentProviderSettingsResponse
  setCommentAggregationSetting: Scalars['Boolean']['output']
  setCountdownTimerAggregationSetting: Scalars['Boolean']['output']
  setDefaultCampaignPage: Scalars['Boolean']['output']
  setEmailReceiptOptions: Scalars['Boolean']['output']
  setEmailReceiptSetting: Scalars['Boolean']['output']
  setEmailSettings: Scalars['Boolean']['output']
  setFundraiserRegistrationNotificationsForProfile: Scalars['Boolean']['output']
  setMatchedGivingAggregationSetting: Scalars['Boolean']['output']
  setProgressBarAggregationSetting: Scalars['Boolean']['output']
  setReceiptPageReferences: Scalars['Boolean']['output']
  setThankYouPageReferences: Scalars['Boolean']['output']
  submitDonorSummary?: Maybe<Scalars['Boolean']['output']>
  submitFormValues: Scalars['Boolean']['output']
  submitPostDonationFormValues: Scalars['Boolean']['output']
  submitQuickPayValues: Scalars['Boolean']['output']
  toggleDonationNotificationForProfile: Scalars['Boolean']['output']
  toggleWelcomeEmailForProfile: Scalars['Boolean']['output']
  updateBranding: UpdateBrandingResponse
  updateCampaignTitle: Scalars['ID']['output']
  updateCustomFieldSetting: Scalars['ID']['output']
  updateGa4Setting?: Maybe<Scalars['ID']['output']>
  updateGtmSetting?: Maybe<Scalars['ID']['output']>
  updateMediaLibraryAsset: Scalars['Boolean']['output']
  updatePaymentIntent: UpdatePaymentIntentResponse
  updatePaymentIntentDetails: UpdatePaymentIntentResponse
  updatePixelConversionsApiSetting?: Maybe<Scalars['ID']['output']>
  updateProfile: Scalars['Boolean']['output']
  updateProfileAdmin: Scalars['Boolean']['output']
  updateSubscription: UpdateSubscriptionResponse
  updateSubscriptionAdmin?: Maybe<UpdateSubscriptionAdminResponse>
  updateSubscriptionDetails: UpdateSubscriptionResponse
  updateTemplate: Scalars['ID']['output']
  validateAndCreateCustomerPortalSession: Scalars['String']['output']
}

export type MutationAddCampaignDomainArgs = {
  addCampaignDomainInput: AddCampaignDomainInput
}

export type MutationAddCampaignMatchedGivingSettingArgs = {
  input: CampaignMatchedGivingSettingInput
}

export type MutationAddCustomFieldSettingArgs = {
  input: CustomFieldSettingInput
}

export type MutationAddGa4SettingArgs = {
  input: Ga4IntegrationSettingInput
}

export type MutationAddGtmSettingArgs = {
  input: GtmIntegrationSettingInput
}

export type MutationAddMergeFieldArgs = {
  input: AddMergeFieldInput
}

export type MutationAddPageBucketSlugsForCampaignArgs = {
  addPageBucketSlugsForCampaignInput?: InputMaybe<AddPageBucketSlugsForCampaignInput>
}

export type MutationAddPageSlugsForCampaignArgs = {
  addPageSlugsForCampaignInput?: InputMaybe<AddPageSlugsForCampaignInput>
}

export type MutationAddPayPalByReferralArgs = {
  input: AddPayPalByReferralInput
}

export type MutationAddPixelConversionsApiSettingArgs = {
  input: PixelConversionsApiIntegrationSettingInput
}

export type MutationAddRaiserEdgeIntegrationSettingArgs = {
  input: RaiserEdgeIntegrationSettingInput
}

export type MutationApproveIdentityPartnerSettingsArgs = {
  input: IdentityPartnerSettingInput
}

export type MutationApproveRaiserEdgeIntegrationSettingArgs = {
  code: Scalars['String']['input']
  state: Scalars['String']['input']
}

export type MutationAuthenticateDonorTokenArgs = {
  token: Scalars['String']['input']
}

export type MutationAuthenticateProfileArgs = {
  campaignId: Scalars['ID']['input']
  charityId: Scalars['ID']['input']
  encodedToken: Scalars['String']['input']
}

export type MutationAuthenticateTokenArgs = {
  token: Scalars['String']['input']
}

export type MutationCancelSubscriptionArgs = {
  input: CancelSubscriptionInput
}

export type MutationChangeRoleArgs = {
  mfaJwt: Scalars['String']['input']
  roleId: Scalars['String']['input']
  userId: Scalars['String']['input']
}

export type MutationConnectStripeStandardAccountOAuthArgs = {
  isLiveMode: Scalars['Boolean']['input']
}

export type MutationCreateBrandingArgs = {
  brandingInput: CreateBrandingInput
}

export type MutationCreateCampaignArgs = {
  campaignInput: CreateCampaignInput
}

export type MutationCreateCharityArgs = {
  charityInput: CreateCharityInput
}

export type MutationCreateManualDonationArgs = {
  input: CreateManualDonationInput
}

export type MutationCreateManualSubscriptionArgs = {
  input: CreateManualSubscriptionInput
}

export type MutationCreateOfflineDonationArgs = {
  input: CreateOfflineDonationInput
}

export type MutationCreateOrderArgs = {
  input: CreateOrderInput
}

export type MutationCreatePageArgs = {
  createPageInput: CreatePageInput
}

export type MutationCreatePageBucketArgs = {
  createPageBucketInput: CreatePageBucketInput
}

export type MutationCreatePageStateArgs = {
  createPageStateInput: CreatePageStateInput
}

export type MutationCreatePaymentIntentArgs = {
  input: CreatePaymentIntentInput
  ip?: InputMaybe<Scalars['String']['input']>
}

export type MutationCreatePaypalReferralLinkArgs = {
  input: CreatePaypalReferralLinkInput
}

export type MutationCreateProfileCategoryArgs = {
  input: CreateProfileCategoryInput
}

export type MutationCreateStripeSubscriptionDonorPortalLinkArgs = {
  input: StripeSubscriptionDonorPortalLinkInput
}

export type MutationCreateSubscriptionArgs = {
  input: CreateSubscriptionInput
  ip?: InputMaybe<Scalars['String']['input']>
}

export type MutationCreateTemplateArgs = {
  input: CreateTemplateInput
}

export type MutationCreateThankYouPageArgs = {
  createPageInput: CreatePageInput
}

export type MutationCreateUserForCharityArgs = {
  input: CreateUserForCharityInput
  mfaJwt: Scalars['String']['input']
}

export type MutationDeleteAnalyticsSettingArgs = {
  input: DeleteAnalyticsSettingInput
}

export type MutationDeleteCampaignArgs = {
  deleteCampaignInput: DeleteCampaignInput
}

export type MutationDeleteCampaignAssetArgs = {
  assetId: Scalars['ID']['input']
  campaignId: Scalars['ID']['input']
}

export type MutationDeleteMediaLibraryAssetArgs = {
  assetId: Scalars['ID']['input']
}

export type MutationDeletePageArgs = {
  deletePageInput: DeletePageInput
}

export type MutationDeleteTemplateArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteUserFromCharityArgs = {
  mfaJwt: Scalars['String']['input']
  userId: Scalars['String']['input']
}

export type MutationDuplicateCampaignArgs = {
  duplicateCampaignInput: DuplicateCampaignInput
}

export type MutationDuplicatePageArgs = {
  duplicatePageInput: DuplicatePageInput
}

export type MutationDuplicatePageStateArgs = {
  duplicatePageStateInput: DuplicatePageStateInput
}

export type MutationDuplicateThankYouPageArgs = {
  duplicatePageInput: DuplicatePageInput
}

export type MutationExchangeStripeOAuthCodeArgs = {
  input: ExchangeStripeOAuthInput
}

export type MutationInitCampaignArgs = {
  initCampaignInput: InitCampaignInput
}

export type MutationInitFundraiserPagesArgs = {
  campaignId: Scalars['ID']['input']
}

export type MutationInitGivingDayCampaignArgs = {
  initCampaignInput: InitCampaignInput
}

export type MutationLoginArgs = {
  email: Scalars['String']['input']
}

export type MutationLoginDonorArgs = {
  email: Scalars['String']['input']
}

export type MutationLoginProfileArgs = {
  campaignId: Scalars['ID']['input']
  charityId: Scalars['ID']['input']
  email: Scalars['String']['input']
}

export type MutationPauseSubscriptionArgs = {
  input?: InputMaybe<PauseSubscriptionInput>
}

export type MutationPostCommentArgs = {
  comment: CommentInput
}

export type MutationPublishPageArgs = {
  publishPageInput?: InputMaybe<PublishPageInput>
}

export type MutationPublishThankYouPageArgs = {
  publishPageInput?: InputMaybe<PublishPageInput>
}

export type MutationRecordStatsArgs = {
  input: AnalyticsInput
  ip?: InputMaybe<Scalars['String']['input']>
}

export type MutationRegenerateCustomerPortalSessionArgs = {
  externalSubscriptionId: Scalars['String']['input']
}

export type MutationRegisterEmailArgs = {
  campaignId: Scalars['ID']['input']
  charityId: Scalars['ID']['input']
  email: Scalars['String']['input']
}

export type MutationRegisterProfileArgs = {
  input: RegisterProfileInput
  token: Scalars['String']['input']
}

export type MutationResendReceiptArgs = {
  input?: InputMaybe<ResendReceiptInput>
}

export type MutationResumeSubscriptionArgs = {
  input?: InputMaybe<ResumeSubscriptionInput>
}

export type MutationSaveDetailsArgs = {
  saveDetailsInput: SaveDetailsInput
}

export type MutationSaveDraftArgs = {
  saveDraftInput?: InputMaybe<SaveDraftInput>
}

export type MutationSavePageBucketDetailsArgs = {
  campaignId: Scalars['ID']['input']
  name?: InputMaybe<Scalars['String']['input']>
  pageBucketId: Scalars['ID']['input']
}

export type MutationSavePageMetadataArgs = {
  savePageMetadataInput?: InputMaybe<SavePageMetadataInput>
}

export type MutationSaveThankYouPageDraftArgs = {
  saveDraftInput?: InputMaybe<SaveDraftInput>
}

export type MutationSelectCharityArgs = {
  input: SelectCharityInput
}

export type MutationSendCharityTaxSummaryArgs = {
  input: SendCharityTaxSummaryInput
}

export type MutationSendTestEmailArgs = {
  sendTestReceiptInput?: InputMaybe<SendTestReceiptInput>
}

export type MutationSetCampaignAnalyticsSettingsArgs = {
  input: CampaignAnalyticsSettingsInput
}

export type MutationSetCampaignPayPalSettingsArgs = {
  input: SetCampaignPaymentProviderSettingsInput
}

export type MutationSetCampaignPlatformFeeTypeArgs = {
  input: SetCampaignPlatformFeeTypeInput
}

export type MutationSetCampaignStripeSettingsArgs = {
  input: SetCampaignPaymentProviderSettingsInput
}

export type MutationSetCampaignTriggersArgs = {
  input: CampaignTriggerInput
}

export type MutationSetCharityBrandingArgs = {
  brandingId: Scalars['ID']['input']
}

export type MutationSetCharityDetailArgs = {
  input: CharityDetailInput
}

export type MutationSetCharityDonorPortalPermissionsArgs = {
  input: CharityDonorPortalPermissionsInput
}

export type MutationSetCharityPageRedirectionSettingsArgs = {
  input: Array<CharityPageRedirectionSettingsInput>
}

export type MutationSetCharityPayPalSettingsArgs = {
  input: CharityPayPalSettingsInput
}

export type MutationSetCharityPlatformFeeArgs = {
  platformFeeType: PlatformFeeType
}

export type MutationSetCharityStripeSettingsArgs = {
  input: CharityStripeSettingsInput
}

export type MutationSetCommentAggregationSettingArgs = {
  campaignId: Scalars['ID']['input']
  input: Array<CommentAggregationSettingItemInput>
}

export type MutationSetCountdownTimerAggregationSettingArgs = {
  campaignId: Scalars['ID']['input']
  input: Array<CountdownTimerAggregationSettingItemInput>
}

export type MutationSetDefaultCampaignPageArgs = {
  input: SetDefaultCampaignPageInput
}

export type MutationSetEmailReceiptOptionsArgs = {
  input: SetEmailReceiptOptionsInput
}

export type MutationSetEmailReceiptSettingArgs = {
  input: SetEmailSettingItemInput
}

export type MutationSetEmailSettingsArgs = {
  input: SetCampaignEmailSettingInput
}

export type MutationSetFundraiserRegistrationNotificationsForProfileArgs = {
  input: SetFundraiserRegistrationNotificationsForProfileInput
}

export type MutationSetMatchedGivingAggregationSettingArgs = {
  campaignId: Scalars['ID']['input']
  input: Array<MatchedGivingAggregationSettingItemInput>
}

export type MutationSetProgressBarAggregationSettingArgs = {
  campaignId: Scalars['ID']['input']
  input: Array<ProgressBarAggregationSettingItemInput>
}

export type MutationSetReceiptPageReferencesArgs = {
  input: SetReceiptPageReferencesInput
}

export type MutationSetThankYouPageReferencesArgs = {
  input: SetThankYouPageReferencesInput
}

export type MutationSubmitDonorSummaryArgs = {
  input: DonorSummaryInput
}

export type MutationSubmitFormValuesArgs = {
  input: SubmitFormValuesInput
}

export type MutationSubmitPostDonationFormValuesArgs = {
  input: SubmitPostDonationFormValuesInput
}

export type MutationSubmitQuickPayValuesArgs = {
  input: QuickPayValuesInput
}

export type MutationToggleDonationNotificationForProfileArgs = {
  campaignId: Scalars['ID']['input']
  isEnabled: Scalars['Boolean']['input']
}

export type MutationToggleWelcomeEmailForProfileArgs = {
  campaignId: Scalars['ID']['input']
  isEnabled: Scalars['Boolean']['input']
}

export type MutationUpdateBrandingArgs = {
  brandingInput: UpdateBrandingInput
}

export type MutationUpdateCampaignTitleArgs = {
  campaignId: Scalars['ID']['input']
  campaignTitle: Scalars['String']['input']
}

export type MutationUpdateCustomFieldSettingArgs = {
  input: CustomFieldSettingInput
}

export type MutationUpdateGa4SettingArgs = {
  input: Array<UpdateGa4IntegrationSettingInput>
}

export type MutationUpdateGtmSettingArgs = {
  input: Array<UpdateGtmIntegrationSettingInput>
}

export type MutationUpdateMediaLibraryAssetArgs = {
  input: UpdateMediaLibraryAssetInput
}

export type MutationUpdatePaymentIntentArgs = {
  input: UpdatePaymentInput
  ip?: InputMaybe<Scalars['String']['input']>
}

export type MutationUpdatePaymentIntentDetailsArgs = {
  input: UpdatePaymentDetailsInput
}

export type MutationUpdatePixelConversionsApiSettingArgs = {
  input: Array<UpdatePixelConversionsApiIntegrationSettingInput>
}

export type MutationUpdateProfileArgs = {
  input: UpdateProfileInput
  token: Scalars['String']['input']
}

export type MutationUpdateProfileAdminArgs = {
  input: UpdateProfileInput
}

export type MutationUpdateSubscriptionArgs = {
  input: UpdatePaymentInput
  ip?: InputMaybe<Scalars['String']['input']>
}

export type MutationUpdateSubscriptionAdminArgs = {
  input: UpdateSubscriptionAdminInput
}

export type MutationUpdateSubscriptionDetailsArgs = {
  input: UpdatePaymentDetailsInput
}

export type MutationUpdateTemplateArgs = {
  input: UpdateTemplateInput
}

export type MutationValidateAndCreateCustomerPortalSessionArgs = {
  subscriptionId: Scalars['String']['input']
  tenantId: Scalars['ID']['input']
  token: Scalars['ID']['input']
}

export type OfflineTransactionExternalData = {
  __typename?: 'OfflineTransactionExternalData'
  offlineTransactionId: Scalars['String']['output']
}

export type OrderComponent = {
  __typename?: 'OrderComponent'
  childComponents?: Maybe<Array<OrderComponent>>
  id: Scalars['String']['output']
}

export type OrderComponentInput = {
  children?: InputMaybe<Array<OrderComponentInput>>
  componentId: Scalars['String']['input']
  displayIndex: Scalars['Int']['input']
}

export type Page = {
  __typename?: 'Page'
  branding?: Maybe<Scalars['String']['output']>
  charityPageTemplateId?: Maybe<Scalars['ID']['output']>
  charityPageTemplateVersion?: Maybe<Scalars['Int']['output']>
  components: Array<PageComponent>
  desktop: Array<OrderComponent>
  elementSettings?: Maybe<ElementSettings>
  footer?: Maybe<Footer>
  header?: Maybe<Header>
  id: Scalars['ID']['output']
  index: Scalars['Int']['output']
  mobile?: Maybe<Array<OrderComponent>>
  name?: Maybe<Scalars['String']['output']>
  versionNumber?: Maybe<Scalars['Int']['output']>
}

export type PageBucketDetail = {
  __typename?: 'PageBucketDetail'
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  pageIds?: Maybe<Array<Scalars['ID']['output']>>
  slug?: Maybe<Scalars['String']['output']>
}

export type PageBucketSlugsDetailsInput = {
  pageBucketId: Scalars['ID']['input']
  pageBucketSlug: Scalars['String']['input']
}

export type PageComponent =
  | Button
  | Column
  | Comments
  | CountdownTimer
  | DollarHandles
  | DonationForm
  | Empty
  | Footer
  | FundraiserButton
  | FundraiserProfile
  | Header
  | Image
  | Leaderboard
  | LoginForm
  | PageOptions
  | PostDonationForm
  | ProgressBar
  | ProgressImage
  | RegisterForm
  | Row
  | SocialShare
  | Text
  | Video
  | VirtualGiftSection

export type PageDetail = {
  __typename?: 'PageDetail'
  hasBeenPublished?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  index: Scalars['Int']['output']
  name?: Maybe<Scalars['String']['output']>
  pageBucketId?: Maybe<Scalars['ID']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  screenshotImageUrl?: Maybe<Scalars['String']['output']>
  slug?: Maybe<Scalars['String']['output']>
  status: PageStatusType
  type?: Maybe<PageType>
}

export type PageLayoutInput = {
  branding: Scalars['String']['input']
  components: ComponentsInput
  desktop: Array<OrderComponentInput>
  footer?: InputMaybe<FooterInput>
  header?: InputMaybe<HeaderInput>
  htmlLayout?: InputMaybe<Scalars['String']['input']>
  mobile?: InputMaybe<Array<OrderComponentInput>>
}

export type PageMetadata = {
  __typename?: 'PageMetadata'
  OgDescription?: Maybe<Scalars['String']['output']>
  OgImage?: Maybe<Scalars['String']['output']>
  OgTitle?: Maybe<Scalars['String']['output']>
  pageKeywords?: Maybe<Scalars['String']['output']>
}

export type PageOptions = Component & {
  __typename?: 'PageOptions'
  faviconUrl?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  siteTitle?: Maybe<Scalars['String']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
}

export type PageOptionsInput = {
  componentId: Scalars['ID']['input']
  faviconUrl?: InputMaybe<Scalars['String']['input']>
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  siteTitle?: InputMaybe<Scalars['String']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  type: ComponentTypeInput
}

export enum PageRedirectType {
  Campaign = 'Campaign',
  External = 'External',
  Page = 'Page',
  PageBucket = 'PageBucket',
  Profile = 'Profile',
}

export type PageReference = {
  __typename?: 'PageReference'
  pageId: Scalars['ID']['output']
  receiptPageIds: Array<Scalars['ID']['output']>
  thankYouPageIds: Array<Scalars['ID']['output']>
}

export type PageResponse = {
  __typename?: 'PageResponse'
  id: Scalars['ID']['output']
}

export type PageSlugsDetailsInput = {
  pageId: Scalars['ID']['input']
  pageSlug: Scalars['String']['input']
}

export enum PageStatusType {
  Draft = 'Draft',
  Published = 'Published',
}

export enum PageType {
  DonationPage = 'DonationPage',
  EmbeddedDonationForm = 'EmbeddedDonationForm',
  FundraiserWelcomeEmail = 'FundraiserWelcomeEmail',
  GroupProfile = 'GroupProfile',
  Login = 'Login',
  Receipt = 'Receipt',
  Register = 'Register',
  SingleProfile = 'SingleProfile',
  ThankYouPage = 'ThankYouPage',
}

export type PaginationQuery = {
  pageNumber: Scalars['Int']['input']
  pageSize: Scalars['Int']['input']
  search?: InputMaybe<Scalars['String']['input']>
}

export type PaginationResponse = {
  __typename?: 'PaginationResponse'
  currentPage: Scalars['Int']['output']
  hasNext: Scalars['Boolean']['output']
  hasPrev: Scalars['Boolean']['output']
  next?: Maybe<Scalars['String']['output']>
  pageSize: Scalars['Int']['output']
  prev?: Maybe<Scalars['String']['output']>
  totalItems: Scalars['Int']['output']
  totalPages: Scalars['Int']['output']
}

export type PauseSubscriptionInput = {
  externalSubscriptionId: Scalars['String']['input']
  paymentSubscriptionId: Scalars['ID']['input']
  resumeAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type PayPalMerchantSetting = {
  __typename?: 'PayPalMerchantSetting'
  clientId?: Maybe<Scalars['String']['output']>
  merchantEmail?: Maybe<Scalars['String']['output']>
  merchantId?: Maybe<Scalars['String']['output']>
}

export type PayPalTransactionExternalData = {
  __typename?: 'PayPalTransactionExternalData'
  captureId: Scalars['String']['output']
  merchantEmail: Scalars['String']['output']
  merchantId: Scalars['String']['output']
  orderId: Scalars['String']['output']
}

export enum PaymentCardType {
  Amex = 'Amex',
  Mastercard = 'Mastercard',
  Visa = 'Visa',
}

export enum PaymentChargeType {
  Destination = 'Destination',
  Direct = 'Direct',
}

export enum PaymentMethodType {
  ApplePay = 'ApplePay',
  CreditCard = 'CreditCard',
  DirectDebit = 'DirectDebit',
  GooglePay = 'GooglePay',
  Offline = 'Offline',
  PayPal = 'PayPal',
}

export enum PaymentProviderType {
  Offline = 'Offline',
  PayPal = 'PayPal',
  StripeCustom = 'StripeCustom',
  StripeStandard = 'StripeStandard',
}

export type PaymentSettings = {
  __typename?: 'PaymentSettings'
  donationPagePaymentProviderSettings: DonationPagePaymentProviderSettings
  donorPaysPlatformFees?: Maybe<Array<Maybe<PlatformFee>>>
  platformFeeType: PlatformFeeType
  tax?: Maybe<Tax>
}

export type PaymentTransaction = {
  __typename?: 'PaymentTransaction'
  applicationFeeTransaction?: Maybe<ApplicationFeeRefundTransactionDetail>
  createdAt: Scalars['DateTime']['output']
  givingId: Scalars['ID']['output']
  netPaymentTransactionAmount: Scalars['Float']['output']
  paymentTransaction?: Maybe<PaymentTransactionDetail>
  refundTransaction?: Maybe<RefundTransactionDetail>
  transactionExternalData: TransactionExternalData
}

export type PaymentTransactionDetail = {
  __typename?: 'PaymentTransactionDetail'
  charityTipAmount?: Maybe<Scalars['Float']['output']>
  donationFormAmount: Scalars['Float']['output']
  transactionAmount: Scalars['Float']['output']
  transactionFees: TransactionFees
}

export type PaymentTransactionQueryResult = {
  __typename?: 'PaymentTransactionQueryResult'
  items: Array<PaymentTransaction>
  totalRecords: Scalars['Int']['output']
}

export type Payout = {
  __typename?: 'Payout'
  applicationFeeTransaction?: Maybe<ApplicationFeeRefundTransactionDetail>
  endAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  paymentTransaction?: Maybe<PaymentTransactionDetail>
  payoutDate: Scalars['DateTime']['output']
  refundTransaction?: Maybe<RefundTransactionDetail>
  startAt: Scalars['DateTime']['output']
  status?: Maybe<PayoutStatus>
  transferAmount: Scalars['Float']['output']
}

export type PayoutQueryResult = {
  __typename?: 'PayoutQueryResult'
  items: Array<Payout>
  totalRecords: Scalars['Int']['output']
}

export enum PayoutStatus {
  Failed = 'Failed',
  Processing = 'Processing',
  Succeeded = 'Succeeded',
}

export type PeerToPeerFundraiserRegistrationNotificationSettingValue = {
  __typename?: 'PeerToPeerFundraiserRegistrationNotificationSettingValue'
  displayName: Scalars['String']['output']
  email: Scalars['String']['output']
}

export type PeerToPeerPageMapItem = {
  __typename?: 'PeerToPeerPageMapItem'
  categoryId?: Maybe<Scalars['String']['output']>
  pageId?: Maybe<Scalars['String']['output']>
}

export type PeerToPeerPageMapSettings = {
  __typename?: 'PeerToPeerPageMapSettings'
  multipleFundraiserPageIds?: Maybe<Array<PeerToPeerPageMapItem>>
  singleFundraiserPageIds?: Maybe<Array<PeerToPeerPageMapItem>>
}

export type PixelConversionsApiIntegrationSetting = {
  __typename?: 'PixelConversionsApiIntegrationSetting'
  isConversionsApi: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  pixelId: Scalars['String']['output']
  settingId: Scalars['ID']['output']
  testEventCode?: Maybe<Scalars['String']['output']>
}

export type PixelConversionsApiIntegrationSettingInput = {
  conversionsApiToken?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  pixelId: Scalars['String']['input']
  testEventCode?: InputMaybe<Scalars['String']['input']>
}

export type PlatformFee = {
  __typename?: 'PlatformFee'
  feeRanges?: Maybe<Array<FeeRange>>
  givingFrequencyType: GivingFrequencyType
  givingType: GivingType
  paymentProviderType: PaymentProviderType
  platformFeeType: PlatformFeeType
}

export enum PlatformFeeType {
  CharityPays = 'CharityPays',
  DonorPays = 'DonorPays',
}

export type PostDonationForm = Component & {
  __typename?: 'PostDonationForm'
  buttonText: Scalars['String']['output']
  extraFields: Array<ExtraField>
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
}

export type PostDonationFormInput = {
  buttonText: Scalars['String']['input']
  componentId: Scalars['ID']['input']
  extraFields: Array<ExtraFieldInput>
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  subComponents?: InputMaybe<Scalars['JSON']['input']>
  type: ComponentTypeInput
}

export type PostDonationFormSubcomponents = {
  __typename?: 'PostDonationFormSubcomponents'
  title?: Maybe<Scalars['ID']['output']>
}

export type PrevalidateDonation = {
  __typename?: 'PrevalidateDonation'
  campaignId: Scalars['ID']['output']
  charityId: Scalars['ID']['output']
  donationFormAmount: Scalars['Float']['output']
  ipAddress: Scalars['String']['output']
  pageId: Scalars['ID']['output']
}

export type PreviewCampaignPaymentSettings = {
  __typename?: 'PreviewCampaignPaymentSettings'
  hasPaypal?: Maybe<Scalars['Boolean']['output']>
  hasStripe?: Maybe<Scalars['Boolean']['output']>
  platformFeeType?: Maybe<PlatformFeeType>
}

export type PreviewQueryResult = {
  __typename?: 'PreviewQueryResult'
  campaignSettings?: Maybe<CampaignSettings>
  metadata?: Maybe<Metadata>
  page: Page
  profiles?: Maybe<Array<ProfileData>>
}

export type ProfileCategory = {
  __typename?: 'ProfileCategory'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  profileEntity?: Maybe<ProfileEntity>
}

export type ProfileData = {
  __typename?: 'ProfileData'
  campaignId?: Maybe<Scalars['ID']['output']>
  category?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  goal?: Maybe<Scalars['Float']['output']>
  id: Scalars['String']['output']
  isGivingNotificationEnabled?: Maybe<Scalars['Boolean']['output']>
  logoUrl?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  owner?: Maybe<ProfileOwnerData>
  profileUrl?: Maybe<Scalars['String']['output']>
  progressAmount?: Maybe<Scalars['Float']['output']>
  status?: Maybe<ProfileStatus>
}

export enum ProfileEntity {
  Group = 'Group',
  Single = 'Single',
}

export type ProfileOwnerData = {
  __typename?: 'ProfileOwnerData'
  email: Scalars['String']['output']
  firstName: Scalars['String']['output']
  lastName: Scalars['String']['output']
}

export enum ProfileQueryOrderType {
  DateAscending = 'DateAscending',
  DateDescending = 'DateDescending',
  TotalDescending = 'TotalDescending',
}

export enum ProfileStatus {
  Active = 'Active',
  Approved = 'Approved',
}

export type ProgressBar = Component & {
  __typename?: 'ProgressBar'
  bonusGoals?: Maybe<Array<BonusGoal>>
  end?: Maybe<Scalars['DateTime']['output']>
  finalGoal?: Maybe<BonusGoal>
  goals?: Maybe<Array<Scalars['Int']['output']>>
  hideBeforeStart?: Maybe<Scalars['Boolean']['output']>
  hideOnEnd?: Maybe<Scalars['Boolean']['output']>
  hideOnGoalReached?: Maybe<Scalars['Boolean']['output']>
  hideWhenMatchedGivingActive?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  isAllPagesLinked?: Maybe<Scalars['Boolean']['output']>
  linkedPageIds?: Maybe<Array<Scalars['ID']['output']>>
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  offset?: Maybe<Scalars['Float']['output']>
  start?: Maybe<Scalars['DateTime']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  text?: Maybe<Text>
  title?: Maybe<Scalars['String']['output']>
  type: ComponentType
}

export type ProgressBarAggregationSetting = AggregationSetting & {
  __typename?: 'ProgressBarAggregationSetting'
  groupSettings?: Maybe<Array<ProgressBarAggregationSettingItem>>
  isAllPagesLinked?: Maybe<Scalars['Boolean']['output']>
}

export type ProgressBarAggregationSettingItem = AggregationSettingItem & {
  __typename?: 'ProgressBarAggregationSettingItem'
  dataSources?: Maybe<Array<Scalars['ID']['output']>>
  endVisibleTime?: Maybe<Scalars['DateTime']['output']>
  groupId: Scalars['ID']['output']
  groupName?: Maybe<Scalars['String']['output']>
  hideWhenMatchedGivingActive?: Maybe<Scalars['Boolean']['output']>
  isAllPagesLinked?: Maybe<Scalars['Boolean']['output']>
  isGoalHidden?: Maybe<Scalars['Boolean']['output']>
  offset?: Maybe<Scalars['Float']['output']>
  pageBucketIds?: Maybe<Array<Scalars['ID']['output']>>
  pageIds: Array<Scalars['ID']['output']>
  progressBarGoals?: Maybe<Array<ProgressBarGoal>>
  startVisibleTime?: Maybe<Scalars['DateTime']['output']>
}

export type ProgressBarAggregationSettingItemInput = {
  dataSources?: InputMaybe<Array<Scalars['ID']['input']>>
  endVisibleTime?: InputMaybe<Scalars['DateTime']['input']>
  groupId: Scalars['ID']['input']
  groupName?: InputMaybe<Scalars['String']['input']>
  hideWhenMatchedGivingActive?: InputMaybe<Scalars['Boolean']['input']>
  isAllPagesLinked?: InputMaybe<Scalars['Boolean']['input']>
  isGoalHidden?: InputMaybe<Scalars['Boolean']['input']>
  offset?: InputMaybe<Scalars['Float']['input']>
  pageBucketIds?: InputMaybe<Array<Scalars['ID']['input']>>
  pageIds: Array<Scalars['ID']['input']>
  progressBarGoals?: InputMaybe<Array<ProgressBarGoalInput>>
  startVisibleTime?: InputMaybe<Scalars['DateTime']['input']>
}

export type ProgressBarAmount = {
  __typename?: 'ProgressBarAmount'
  amount?: Maybe<Scalars['Float']['output']>
}

export type ProgressBarGoal = {
  __typename?: 'ProgressBarGoal'
  goal: Scalars['Float']['output']
  index: Scalars['Int']['output']
}

export type ProgressBarGoalInput = {
  goal: Scalars['Float']['input']
  index: Scalars['Int']['input']
}

export type ProgressBarInput = {
  bonusGoals?: InputMaybe<Array<BonusGoalInput>>
  componentId: Scalars['ID']['input']
  end?: InputMaybe<Scalars['DateTime']['input']>
  goals?: InputMaybe<Array<Scalars['Int']['input']>>
  hideBeforeStart?: InputMaybe<Scalars['Boolean']['input']>
  hideOnEnd?: InputMaybe<Scalars['Boolean']['input']>
  hideOnGoalReached?: InputMaybe<Scalars['Boolean']['input']>
  hideWhenMatchedGivingActive?: InputMaybe<Scalars['Boolean']['input']>
  isAllPagesLinked?: InputMaybe<Scalars['Boolean']['input']>
  linkedPageIds?: InputMaybe<Array<Scalars['ID']['input']>>
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  offset?: InputMaybe<Scalars['Float']['input']>
  start?: InputMaybe<Scalars['DateTime']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  text?: InputMaybe<TextInput>
  title?: InputMaybe<Scalars['String']['input']>
  type: ComponentTypeInput
}

export type ProgressImage = Component & {
  __typename?: 'ProgressImage'
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
}

export type ProgressImageInput = {
  componentId: Scalars['ID']['input']
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  subComponents: Scalars['JSON']['input']
  type: ComponentTypeInput
}

export type ProgressImageSubComponents = {
  __typename?: 'ProgressImageSubComponents'
  backgroundImage?: Maybe<Scalars['ID']['output']>
  foregroundText?: Maybe<Scalars['ID']['output']>
  image: Scalars['ID']['output']
}

export type PublishPageInput = {
  campaignId: Scalars['ID']['input']
  ids: Array<Scalars['ID']['input']>
}

export type Query = {
  __typename?: 'Query'
  aggregatedGivings?: Maybe<AggregatedGivings>
  aggregationSettings: AggregationSettings
  analyticsIntegrationSettings: AnalyticsIntegrationSettings
  branding: Branding
  brandings: Array<Branding>
  campaign: Campaign
  campaignAggregateGivingStats: GetCampaignPerformanceStatsQueryResult
  campaignAmountsByDate: Array<CampaignDonationByDateStat>
  campaignAnalyticsSettings: CampaignAnalyticsSettings
  campaignAssets: Array<CampaignAsset>
  campaignDomain: CampaignDomain
  campaignLandingPageId?: Maybe<Scalars['ID']['output']>
  campaignMatchedGivingSettings: Array<CampaignMatchedGivingSetting>
  campaignPageDonationAmounts: Array<CampaignPageDonationAmountStat>
  campaignPageMetadata?: Maybe<PageMetadata>
  campaignPaymentSettings: CampaignPaymentSettings
  campaignPerformance: GetCampaignPerformanceStatsQueryResult
  campaignSettings: CampaignSettings
  campaignTopDonationAmounts: Array<CampaignDonorAmountStat>
  campaignTriggers?: Maybe<CampaignTrigger>
  campaignUtmTagDonationAmounts: Array<CampaignUtmTagDonationAmountStat>
  campaigns: Array<Campaign>
  campaignsOverview: Array<CampaignOverview>
  capturePayment: Scalars['Boolean']['output']
  charities: Array<Charity>
  charity: Charity
  charityDetail: CharityDetail
  charityDonorPortalSettings?: Maybe<CharityDonorPortalSettings>
  charityMergeTags: Array<MergeFieldSetting>
  charityMetadata?: Maybe<CharityMetadata>
  charityPageRedirectionSetting: Array<CharityPageRedirectionSetting>
  charityPaymentSettings: CharityPaymentSettings
  charityProfileCategories: Array<ProfileCategory>
  charityStripeCustomProviderSettings: CharityPaymentSettings
  charityTaxSummaryStatus: CharityTaxSummaryStatus
  charityTaxSummaryTotalEmailCount: Scalars['Int']['output']
  charityTemplateLayout: Page
  charityTemplates: Array<CharityTemplateDetail>
  charityUserRoles: Array<Role>
  charityUsers?: Maybe<CharityUserWithPagination>
  claims: Array<CharityClaim>
  comments: CommentsQueryResult
  customFieldSettings: Array<CustomFieldSetting>
  donorGivings: DonorGivingsQueryResult
  donorPortalSettings: DonorPortalSlugResponse
  donorProfile: DonorProfile
  donorSubscriptions: DonorSubscriptionsQueryResult
  featureFlag: Scalars['JSON']['output']
  formData: FormDataQueryResult
  fullMatchedGivingProgress: MatchedGivingProgressResult
  givings: GivingsQueryResult
  leaderboard: Array<ProfileData>
  matchedGivingProgress: MatchedGivingProgressResult
  matchedGivingRecords: MatchedGivingQueryResult
  mediaLibraryAssets: MediaLibraryAssetsResult
  mergeFields: Array<MergeField>
  page: Page
  pageBuckets: Array<PageBucketDetail>
  pageLayout: Page
  pageMetadata?: Maybe<Metadata>
  pages: Array<PageDetail>
  pagesWithPageTypes: Array<PageDetail>
  paymentSettings?: Maybe<PaymentSettings>
  paymentTransactions: PaymentTransactionQueryResult
  payout: Payout
  payoutTransactions: Array<PaymentTransaction>
  payouts: PayoutQueryResult
  previewLayout: PreviewQueryResult
  profileCategories: Array<ProfileCategory>
  profileData: ProfileData
  profiles: Array<ProfileData>
  progressBarAmount?: Maybe<ProgressBarAmount>
  purl: Scalars['JSON']['output']
  purlParams: Scalars['JSON']['output']
  salesforceContact?: Maybe<SalesforceContact>
  searchBySlug: SlugResponse
  sectionTemplates: Scalars['JSON']['output']
  subscriptions: SubscriptionsQueryResult
  templatePage?: Maybe<Page>
  thankYouPage: Page
  thankYouPageIdFromId: Scalars['ID']['output']
  thankYouPageLayout: Page
  thankYouPageReferences: Array<Scalars['ID']['output']>
  thankYouPages: Array<PageDetail>
  unpaidBalance: Balance
  unpaidTransactions: Array<PaymentTransaction>
  validateToken: Scalars['Boolean']['output']
}

export type QueryAggregatedGivingsArgs = {
  input: AggregatedGivingsInput
}

export type QueryAggregationSettingsArgs = {
  campaignId: Scalars['ID']['input']
  pageBucketId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryBrandingArgs = {
  id: Scalars['ID']['input']
}

export type QueryCampaignArgs = {
  id: Scalars['ID']['input']
}

export type QueryCampaignAggregateGivingStatsArgs = {
  campaignId: Scalars['ID']['input']
  endDate: Scalars['DateTime']['input']
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
  startDate: Scalars['DateTime']['input']
  timezoneOffsetInMinutes: Scalars['Int']['input']
}

export type QueryCampaignAmountsByDateArgs = {
  campaignId: Scalars['ID']['input']
  endDate: Scalars['DateTime']['input']
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
  startDate: Scalars['DateTime']['input']
  timezoneOffsetInMinutes: Scalars['Int']['input']
}

export type QueryCampaignAnalyticsSettingsArgs = {
  campaignId: Scalars['ID']['input']
}

export type QueryCampaignAssetsArgs = {
  campaignId: Scalars['ID']['input']
  pagination: PaginationQuery
}

export type QueryCampaignDomainArgs = {
  campaignId: Scalars['ID']['input']
}

export type QueryCampaignLandingPageIdArgs = {
  campaignId: Scalars['ID']['input']
  isLiveMode: Scalars['Boolean']['input']
  pageBucketId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryCampaignMatchedGivingSettingsArgs = {
  campaignId: Scalars['ID']['input']
}

export type QueryCampaignPageDonationAmountsArgs = {
  campaignId: Scalars['ID']['input']
  endDate: Scalars['DateTime']['input']
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
  startDate: Scalars['DateTime']['input']
  timezoneOffsetInMinutes: Scalars['Int']['input']
}

export type QueryCampaignPageMetadataArgs = {
  campaignId: Scalars['ID']['input']
  pageId: Scalars['ID']['input']
}

export type QueryCampaignPaymentSettingsArgs = {
  campaignId: Scalars['ID']['input']
}

export type QueryCampaignPerformanceArgs = {
  campaignId: Scalars['ID']['input']
  endDate: Scalars['DateTime']['input']
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
  startDate: Scalars['DateTime']['input']
  timezoneOffsetInMinutes: Scalars['Int']['input']
}

export type QueryCampaignSettingsArgs = {
  campaignId: Scalars['ID']['input']
}

export type QueryCampaignTopDonationAmountsArgs = {
  campaignId: Scalars['ID']['input']
  endDate: Scalars['DateTime']['input']
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
  startDate: Scalars['DateTime']['input']
  timezoneOffsetInMinutes: Scalars['Int']['input']
}

export type QueryCampaignTriggersArgs = {
  campaignId: Scalars['ID']['input']
  pageBucketId: Scalars['ID']['input']
}

export type QueryCampaignUtmTagDonationAmountsArgs = {
  campaignId: Scalars['ID']['input']
  endDate: Scalars['DateTime']['input']
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
  startDate: Scalars['DateTime']['input']
  timezoneOffsetInMinutes: Scalars['Int']['input']
}

export type QueryCampaignsArgs = {
  pagination: PaginationQuery
}

export type QueryCampaignsOverviewArgs = {
  campaignIds: Array<Scalars['ID']['input']>
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryCapturePaymentArgs = {
  orderId: Scalars['String']['input']
}

export type QueryCharityMetadataArgs = {
  charityId: Scalars['ID']['input']
}

export type QueryCharityTaxSummaryStatusArgs = {
  financialYear: Scalars['Int']['input']
  isLiveMode: Scalars['Boolean']['input']
}

export type QueryCharityTaxSummaryTotalEmailCountArgs = {
  financialYear: Scalars['Int']['input']
  isLiveMode: Scalars['Boolean']['input']
  taxSummarySettingType: CharityTaxSummaryMessageType
}

export type QueryCharityTemplateLayoutArgs = {
  pageId: Scalars['ID']['input']
}

export type QueryCharityTemplatesArgs = {
  pageType: PageType
  type: CharityTemplateType
}

export type QueryCharityUsersArgs = {
  pagination: PaginationQuery
}

export type QueryClaimsArgs = {
  pagination?: InputMaybe<PaginationQuery>
}

export type QueryCommentsArgs = {
  query: CommentsQueryInput
}

export type QueryDonorGivingsArgs = {
  input: GivingsQueryInput
}

export type QueryDonorPortalSettingsArgs = {
  url: Scalars['String']['input']
}

export type QueryDonorSubscriptionsArgs = {
  input: GivingsQueryInput
  token: Scalars['String']['input']
}

export type QueryFeatureFlagArgs = {
  flags: Array<Scalars['String']['input']>
}

export type QueryFormDataArgs = {
  formId: Scalars['ID']['input']
}

export type QueryFullMatchedGivingProgressArgs = {
  campaignId: Scalars['ID']['input']
  isLiveMode: Scalars['Boolean']['input']
  matchedGivingId: Scalars['ID']['input']
}

export type QueryGivingsArgs = {
  input: GivingsQueryInput
}

export type QueryLeaderboardArgs = {
  campaignId: Scalars['ID']['input']
  charityId: Scalars['ID']['input']
  isApprovedOnly?: InputMaybe<Scalars['Boolean']['input']>
  isLiveMode: Scalars['Boolean']['input']
  orderBy: ProfileQueryOrderType
}

export type QueryMatchedGivingProgressArgs = {
  campaignId: Scalars['ID']['input']
  isLiveMode: Scalars['Boolean']['input']
  matchedGivingId: Scalars['ID']['input']
}

export type QueryMatchedGivingRecordsArgs = {
  mode: Mode
  pageNumber: Scalars['Int']['input']
  pageSize: Scalars['Int']['input']
}

export type QueryMediaLibraryAssetsArgs = {
  input?: InputMaybe<MediaLibraryAssetsInput>
}

export type QueryMergeFieldsArgs = {
  name?: InputMaybe<Scalars['String']['input']>
}

export type QueryPageArgs = {
  campaignId?: InputMaybe<Scalars['ID']['input']>
  id: Scalars['ID']['input']
  profileId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryPageBucketsArgs = {
  campaignId: Scalars['ID']['input']
}

export type QueryPageLayoutArgs = {
  pageId: Scalars['ID']['input']
  pageType?: InputMaybe<PageType>
}

export type QueryPageMetadataArgs = {
  campaignId: Scalars['ID']['input']
  charityId: Scalars['ID']['input']
  pageId: Scalars['ID']['input']
}

export type QueryPagesArgs = {
  campaignId: Scalars['ID']['input']
  pageTypes: Array<PageType>
}

export type QueryPagesWithPageTypesArgs = {
  campaignId: Scalars['ID']['input']
  pageTypes: Array<PageType>
}

export type QueryPaymentSettingsArgs = {
  campaignId: Scalars['ID']['input']
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryPaymentTransactionsArgs = {
  endDate: Scalars['String']['input']
  mode: Mode
  pageNumber: Scalars['Int']['input']
  pageSize: Scalars['Int']['input']
  paymentProviderId?: InputMaybe<Scalars['ID']['input']>
  startDate: Scalars['String']['input']
}

export type QueryPayoutArgs = {
  payoutId: Scalars['ID']['input']
}

export type QueryPayoutTransactionsArgs = {
  payoutId: Scalars['ID']['input']
}

export type QueryPayoutsArgs = {
  mode: Mode
  pageNumber: Scalars['Int']['input']
  pageSize: Scalars['Int']['input']
  paymentProviderId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryPreviewLayoutArgs = {
  previewId: Scalars['ID']['input']
}

export type QueryProfileCategoriesArgs = {
  campaignId: Scalars['ID']['input']
}

export type QueryProfileDataArgs = {
  campaignId: Scalars['ID']['input']
  charityId: Scalars['ID']['input']
  profileId: Scalars['ID']['input']
}

export type QueryProfilesArgs = {
  campaignId: Scalars['ID']['input']
  isApprovedOnly?: InputMaybe<Scalars['Boolean']['input']>
  isLiveMode: Scalars['Boolean']['input']
  orderBy: ProfileQueryOrderType
}

export type QueryProgressBarAmountArgs = {
  campaignId: Scalars['ID']['input']
  isAllPagesLinked: Scalars['Boolean']['input']
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
  pageIds?: InputMaybe<Array<Scalars['ID']['input']>>
  profileId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryPurlArgs = {
  campaignId: Scalars['ID']['input']
  charityId: Scalars['ID']['input']
  id?: InputMaybe<Scalars['String']['input']>
  params?: InputMaybe<Scalars['String']['input']>
}

export type QueryPurlParamsArgs = {
  campaignId: Scalars['ID']['input']
  charityId: Scalars['ID']['input']
  id?: InputMaybe<Scalars['String']['input']>
  params?: InputMaybe<Scalars['String']['input']>
}

export type QuerySalesforceContactArgs = {
  charityId: Scalars['ID']['input']
  contactId: Scalars['String']['input']
  donorId: Scalars['String']['input']
}

export type QuerySearchBySlugArgs = {
  isLiveMode: Scalars['Boolean']['input']
  url: Scalars['String']['input']
}

export type QuerySectionTemplatesArgs = {
  pageType: PageType
}

export type QuerySubscriptionsArgs = {
  input: SubscriptionsQueryInput
}

export type QueryTemplatePageArgs = {
  templateId: Scalars['ID']['input']
  templateType: TemplateType
}

export type QueryThankYouPageArgs = {
  pageId: Scalars['ID']['input']
}

export type QueryThankYouPageIdFromIdArgs = {
  campaignId: Scalars['ID']['input']
  pageId: Scalars['ID']['input']
}

export type QueryThankYouPageLayoutArgs = {
  pageId: Scalars['ID']['input']
}

export type QueryThankYouPageReferencesArgs = {
  campaignId: Scalars['ID']['input']
  pageId: Scalars['ID']['input']
}

export type QueryThankYouPagesArgs = {
  campaignId: Scalars['ID']['input']
}

export type QueryUnpaidBalanceArgs = {
  mode: Mode
  paymentProviderId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryUnpaidTransactionsArgs = {
  mode: Mode
  paymentProviderId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryValidateTokenArgs = {
  charityId: Scalars['ID']['input']
  profileId?: InputMaybe<Scalars['ID']['input']>
  token: Scalars['String']['input']
}

export type QuickPayValuesInput = {
  address?: InputMaybe<AddressInput>
  charityId: Scalars['ID']['input']
  customFields?: InputMaybe<Array<FormCustomFieldInput>>
  firstName: Scalars['String']['input']
  fullAddress?: InputMaybe<Scalars['String']['input']>
  lastName: Scalars['String']['input']
  organisation?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  transactionId: Scalars['ID']['input']
}

export type RgbColor = {
  __typename?: 'RGBColor'
  a?: Maybe<Scalars['Int']['output']>
  b: Scalars['Int']['output']
  g: Scalars['Int']['output']
  r: Scalars['Int']['output']
}

export type RgbColorInput = {
  a?: InputMaybe<Scalars['Int']['input']>
  b: Scalars['Int']['input']
  g: Scalars['Int']['input']
  r: Scalars['Int']['input']
}

export type RaiserEdgeIntegrationSetting = {
  __typename?: 'RaiserEdgeIntegrationSetting'
  callbackUrl: Scalars['String']['output']
  clientId: Scalars['String']['output']
  primarySubscriptionKey: Scalars['String']['output']
  secondarySubscriptionKey: Scalars['String']['output']
  settingId?: Maybe<Scalars['ID']['output']>
}

export type RaiserEdgeIntegrationSettingInput = {
  callbackUrl: Scalars['String']['input']
  clientId: Scalars['String']['input']
  clientSecret: Scalars['String']['input']
  primarySubscriptionKey: Scalars['String']['input']
  secondarySubscriptionKey: Scalars['String']['input']
}

export type ReceiptOptionSetting = {
  __typename?: 'ReceiptOptionSetting'
  givingReceiptOption?: Maybe<GivingReceiptOptionSetting>
  sendFundraiserWelcomeEmail?: Maybe<Scalars['Boolean']['output']>
  sendPdfReceipt?: Maybe<Scalars['Boolean']['output']>
  subscriptionReceiptOption?: Maybe<SubscriptionReceiptOptionSetting>
}

export type RefundTransactionDetail = {
  __typename?: 'RefundTransactionDetail'
  donationFormAmount: Scalars['Float']['output']
  transactionAmount: Scalars['Float']['output']
}

export type RegisterDonorEmailResponse = {
  __typename?: 'RegisterDonorEmailResponse'
  token: Scalars['String']['output']
}

export type RegisterEmailResponse = {
  __typename?: 'RegisterEmailResponse'
  hasProfileInCampaign: Scalars['Boolean']['output']
  isExistingUser: Scalars['Boolean']['output']
  token: Scalars['String']['output']
}

export type RegisterForm = Component & {
  __typename?: 'RegisterForm'
  extraFields?: Maybe<Array<ExtraField>>
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
}

export type RegisterFormInput = {
  componentId: Scalars['ID']['input']
  extraFields?: InputMaybe<Array<ExtraFieldInput>>
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  subComponents: Scalars['JSON']['input']
  type: ComponentTypeInput
}

export type RegisterFormSubcomponents = {
  __typename?: 'RegisterFormSubcomponents'
  title?: Maybe<Scalars['ID']['output']>
}

export type RegisterProfileInput = {
  campaignId: Scalars['ID']['input']
  charityId: Scalars['ID']['input']
  description?: InputMaybe<Scalars['String']['input']>
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  goal?: InputMaybe<Scalars['Int']['input']>
  isGivingNotificationEnabled: Scalars['Boolean']['input']
  lastName: Scalars['String']['input']
  profileCategoryId: Scalars['ID']['input']
  profileName: Scalars['String']['input']
}

export type RegisterProfileResult = {
  __typename?: 'RegisterProfileResult'
  profileId: Scalars['ID']['output']
  redirectUrl: Scalars['String']['output']
}

export type ResendReceiptInput = {
  email: Scalars['String']['input']
  firstName?: InputMaybe<Scalars['String']['input']>
  givingId: Scalars['ID']['input']
  lastName?: InputMaybe<Scalars['String']['input']>
}

export type ResumeSubscriptionInput = {
  externalSubscriptionId: Scalars['String']['input']
  paymentSubscriptionId: Scalars['ID']['input']
}

export type Role = {
  __typename?: 'Role'
  roleId: Scalars['ID']['output']
  roleName: Scalars['String']['output']
}

export enum Roles {
  Agency = 'Agency',
  CharityAdmin = 'CharityAdmin',
  CharityUser = 'CharityUser',
  GiveEasyAdmin = 'GiveEasyAdmin',
}

export type Row = Component & {
  __typename?: 'Row'
  components: Array<PageComponent>
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
}

export type RowInput = {
  componentId: Scalars['ID']['input']
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  type: ComponentTypeInput
}

export type SalesforceContact = {
  __typename?: 'SalesforceContact'
  donationAmounts: Array<SalesforceDonationAmount>
  email?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  lastName?: Maybe<Scalars['String']['output']>
}

export type SalesforceDonationAmount = {
  __typename?: 'SalesforceDonationAmount'
  amount?: Maybe<Scalars['Float']['output']>
  field: Scalars['String']['output']
}

export type SaveDetailsInput = {
  id: Scalars['ID']['input']
  pageName?: InputMaybe<Scalars['String']['input']>
  pageSlug?: InputMaybe<Scalars['String']['input']>
  pageType: PageType
  screenshotImageUrl?: InputMaybe<Scalars['String']['input']>
}

export type SaveDraftInput = {
  charityPageTemplateId?: InputMaybe<Scalars['ID']['input']>
  charityPageTemplateVersion?: InputMaybe<Scalars['Int']['input']>
  htmlLayout?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  name: Scalars['String']['input']
  pageLayout: PageLayoutInput
  pageName?: InputMaybe<Scalars['String']['input']>
  pageType: PageType
  screenshotImageUrl?: InputMaybe<Scalars['String']['input']>
}

export type SavePageMetadataInput = {
  campaignId: Scalars['ID']['input']
  ogDescription?: InputMaybe<Scalars['String']['input']>
  ogImage?: InputMaybe<Scalars['String']['input']>
  ogTitle?: InputMaybe<Scalars['String']['input']>
  pageId: Scalars['ID']['input']
}

export type SelectCharityInput = {
  auth0Id: Scalars['String']['input']
  charityId: Scalars['String']['input']
}

export type SendCharityTaxSummaryInput = {
  financialYear: Scalars['Int']['input']
  isLiveMode: Scalars['Boolean']['input']
  taxSummarySetting: CharityTaxSummaryMessageType
}

export type SendTestReceiptInput = {
  campaignId: Scalars['ID']['input']
  receiptPageId: Scalars['ID']['input']
  to: Scalars['String']['input']
}

export type SetCampaignEmailSettingInput = {
  campaignId: Scalars['ID']['input']
  givingReceiptOption?: InputMaybe<GivingReceiptOptionSetting>
  receiptSubjects?: InputMaybe<Array<SetEmailSettingSubjectItemInput>>
  sendPdfReceipt?: InputMaybe<Scalars['Boolean']['input']>
  subscriptionReceiptOption?: InputMaybe<SubscriptionReceiptOptionSetting>
}

export type SetCampaignPaymentProviderSettingsInput = {
  campaignId: Scalars['ID']['input']
  paymentProviderId: Scalars['String']['input']
}

export type SetCampaignPaymentProviderSettingsResponse = {
  __typename?: 'SetCampaignPaymentProviderSettingsResponse'
  campaignId: Scalars['ID']['output']
}

export type SetCampaignPlatformFeeTypeInput = {
  campaignId: Scalars['ID']['input']
  platformFeeType: PlatformFeeType
}

export type SetDefaultCampaignPageInput = {
  campaignId: Scalars['ID']['input']
  pageId: Scalars['ID']['input']
}

export type SetEmailReceiptOptionsInput = {
  campaignId: Scalars['ID']['input']
  givingReceiptOption: GivingReceiptOptionSetting
  subscriptionReceiptOption: SubscriptionReceiptOptionSetting
}

export type SetEmailSettingItemInput = {
  campaignId: Scalars['ID']['input']
  receiptPageId: Scalars['ID']['input']
  subject?: InputMaybe<Scalars['String']['input']>
}

export type SetEmailSettingSubjectItemInput = {
  receiptPageId: Scalars['ID']['input']
  subject?: InputMaybe<Scalars['String']['input']>
}

export type SetFundraiserRegistrationNotificationsForProfileInput = {
  campaignId: Scalars['ID']['input']
  emailValues?: InputMaybe<Array<FundraiserRegistrationEmailInput>>
  isEnabled: Scalars['Boolean']['input']
}

export type SetPageReferencesInput = {
  campaignId: Scalars['ID']['input']
  pageIdsForReceipt: Array<Scalars['ID']['input']>
  pageIdsForThankYou: Array<Scalars['ID']['input']>
  receiptPageId: Scalars['ID']['input']
  thankYouPageId: Scalars['ID']['input']
}

export type SetPaymentProviderSettingsResponse = {
  __typename?: 'SetPaymentProviderSettingsResponse'
  label: Scalars['String']['output']
}

export type SetReceiptPageReferencesInput = {
  campaignId: Scalars['ID']['input']
  pageIds: Array<Scalars['ID']['input']>
  receiptPageId: Scalars['ID']['input']
}

export type SetThankYouPageReferencesInput = {
  campaignId: Scalars['ID']['input']
  pageIds: Array<Scalars['ID']['input']>
  thankYouPageId: Scalars['ID']['input']
}

export type SlugResponse = {
  __typename?: 'SlugResponse'
  campaignId: Scalars['ID']['output']
  campaignSettings?: Maybe<CampaignSettings>
  charityId: Scalars['ID']['output']
  layout: Page
  pageBucketId?: Maybe<Scalars['ID']['output']>
  pageId?: Maybe<Scalars['ID']['output']>
  profileData?: Maybe<ProfileData>
  profileId?: Maybe<Scalars['ID']['output']>
  redirectUrl?: Maybe<Scalars['String']['output']>
}

export type SocialShare = Component & {
  __typename?: 'SocialShare'
  hasEmail?: Maybe<Scalars['Boolean']['output']>
  hasFacebook?: Maybe<Scalars['Boolean']['output']>
  hasLink?: Maybe<Scalars['Boolean']['output']>
  hasLinkedIn?: Maybe<Scalars['Boolean']['output']>
  hasTwitter?: Maybe<Scalars['Boolean']['output']>
  hasWhatsApp?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
}

export type SocialShareInput = {
  componentId: Scalars['ID']['input']
  hasEmail?: InputMaybe<Scalars['Boolean']['input']>
  hasFacebook?: InputMaybe<Scalars['Boolean']['input']>
  hasLink?: InputMaybe<Scalars['Boolean']['input']>
  hasLinkedIn?: InputMaybe<Scalars['Boolean']['input']>
  hasTwitter?: InputMaybe<Scalars['Boolean']['input']>
  hasWhatsApp?: InputMaybe<Scalars['Boolean']['input']>
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  type: ComponentTypeInput
}

export type StripePaymentSettings = {
  __typename?: 'StripePaymentSettings'
  connectAccountId?: Maybe<Scalars['String']['output']>
  isConnectAccountLive?: Maybe<Scalars['Boolean']['output']>
  paymentChargeType?: Maybe<PaymentChargeType>
  paymentProviderType?: Maybe<PaymentProviderType>
  platformAccountId?: Maybe<Scalars['String']['output']>
  publishableKey?: Maybe<Scalars['String']['output']>
}

export type StripeSubscriptionDonorPortalLink = {
  __typename?: 'StripeSubscriptionDonorPortalLink'
  url: Scalars['String']['output']
}

export type StripeSubscriptionDonorPortalLinkInput = {
  externalSubscriptionId: Scalars['String']['input']
  paymentSubscriptionId: Scalars['ID']['input']
}

export type StripeTransactionExternalData = {
  __typename?: 'StripeTransactionExternalData'
  connectId: Scalars['String']['output']
  paymentIntentId: Scalars['String']['output']
}

export type SubmitFormValuesInput = {
  charityId: Scalars['ID']['input']
  formId: Scalars['ID']['input']
  formValues?: InputMaybe<Array<FormCustomFieldInput>>
}

export type SubmitPostDonationFormValuesInput = {
  address?: InputMaybe<AddressInput>
  charityId: Scalars['ID']['input']
  customFields?: InputMaybe<Array<FormCustomFieldInput>>
  mobile?: InputMaybe<Scalars['String']['input']>
  paymentSubscriptionId?: InputMaybe<Scalars['ID']['input']>
  transactionId?: InputMaybe<Scalars['ID']['input']>
}

export type SubscriptionInvoice = {
  __typename?: 'SubscriptionInvoice'
  invoiceDate: Scalars['DateTime']['output']
  invoiceStatus: SubscriptionInvoiceStatus
}

export enum SubscriptionInvoiceStatus {
  Draft = 'Draft',
  NeedsEnrichment = 'NeedsEnrichment',
  Open = 'Open',
  Paid = 'Paid',
  PartiallyRefunded = 'PartiallyRefunded',
  Refunded = 'Refunded',
  Uncollectible = 'Uncollectible',
  Void = 'Void',
}

export enum SubscriptionReceiptOptionSetting {
  Always = 'Always',
  InitialOnly = 'InitialOnly',
  None = 'None',
}

export type SubscriptionRecord = {
  __typename?: 'SubscriptionRecord'
  campaign: Scalars['String']['output']
  currencyCode: Scalars['String']['output']
  donationFormAmount: Scalars['Float']['output']
  donationFrequencyType: GivingDonationFrequency
  email: Scalars['String']['output']
  endAt?: Maybe<Scalars['DateTime']['output']>
  externalSubscriptionId: Scalars['String']['output']
  firstName?: Maybe<Scalars['String']['output']>
  lastGiving?: Maybe<SubscriptionRegularGiving>
  lastInvoice?: Maybe<SubscriptionInvoice>
  lastName?: Maybe<Scalars['String']['output']>
  nextPaymentDate?: Maybe<Scalars['DateTime']['output']>
  page: Scalars['String']['output']
  paymentMethodType: PaymentMethodType
  resumeAt?: Maybe<Scalars['DateTime']['output']>
  scheduledUpdate?: Maybe<SubscriptionScheduledUpdate>
  startAt: Scalars['DateTime']['output']
  status: SubscriptionStatus
  subscriptionId: Scalars['ID']['output']
  subscriptionStartAt: Scalars['DateTime']['output']
  totalGivingTransactionAmount: Scalars['Float']['output']
  transactionAmount: Scalars['Float']['output']
}

export type SubscriptionRegularGiving = {
  __typename?: 'SubscriptionRegularGiving'
  givingDate: Scalars['DateTime']['output']
  givingStatus: GivingStatus
}

export type SubscriptionScheduledUpdate = {
  __typename?: 'SubscriptionScheduledUpdate'
  amount?: Maybe<Scalars['Float']['output']>
  donationFrequencyType?: Maybe<GivingDonationFrequency>
  externalSubscriptionScheduleId: Scalars['String']['output']
  startAt?: Maybe<Scalars['DateTime']['output']>
  subscriptionScheduleId: Scalars['ID']['output']
}

export enum SubscriptionStatus {
  Active = 'Active',
  Cancelled = 'Cancelled',
  Incomplete = 'Incomplete',
  IncompleteExpired = 'IncompleteExpired',
  PastDue = 'PastDue',
  Paused = 'Paused',
  Trialing = 'Trialing',
  Unpaid = 'Unpaid',
}

export type SubscriptionsFilterInput = {
  donationFrequency?: InputMaybe<GivingDonationFrequency>
  mode?: InputMaybe<Mode>
  search?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<SubscriptionStatus>
}

export type SubscriptionsQueryInput = {
  endDate?: InputMaybe<Scalars['String']['input']>
  filter?: InputMaybe<SubscriptionsFilterInput>
  pageNumber: Scalars['Int']['input']
  pageSize?: InputMaybe<Scalars['Int']['input']>
  startDate?: InputMaybe<Scalars['String']['input']>
}

export type SubscriptionsQueryResult = {
  __typename?: 'SubscriptionsQueryResult'
  items: Array<SubscriptionRecord>
  totalRecords: Scalars['Int']['output']
}

export type Tax = {
  __typename?: 'Tax'
  countryCodeIso2: Scalars['String']['output']
  label?: Maybe<Scalars['String']['output']>
  percentage: Scalars['Float']['output']
}

export enum TemplateType {
  Charity = 'Charity',
  Fed = 'FED',
  GiveEasy = 'GiveEasy',
}

export type Text = Component & {
  __typename?: 'Text'
  htmlText?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  textValue: Scalars['String']['output']
  type: ComponentType
}

export type TextInput = {
  componentId: Scalars['ID']['input']
  htmlText?: InputMaybe<Scalars['String']['input']>
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  textValue: Scalars['String']['input']
  type: ComponentTypeInput
}

export type TransactionExternalData = {
  __typename?: 'TransactionExternalData'
  offlineData?: Maybe<OfflineTransactionExternalData>
  payPalData?: Maybe<PayPalTransactionExternalData>
  paymentServiceTransactionId: Scalars['ID']['output']
  stripeData?: Maybe<StripeTransactionExternalData>
}

export type TransactionFees = {
  __typename?: 'TransactionFees'
  internalManagedAdminFee?: Maybe<Scalars['Float']['output']>
  paymentGatewayFee?: Maybe<Scalars['Float']['output']>
  platformFee?: Maybe<Scalars['Float']['output']>
  totalFee: Scalars['Float']['output']
  totalTax?: Maybe<Scalars['Float']['output']>
}

export enum TriggerType {
  Amount = 'Amount',
  DateTime = 'DateTime',
}

export type UpdateBrandingInput = {
  brandingId: Scalars['ID']['input']
  saveAsDefault?: InputMaybe<Scalars['Boolean']['input']>
  value: Scalars['String']['input']
}

export type UpdateBrandingResponse = {
  __typename?: 'UpdateBrandingResponse'
  brandingId: Scalars['ID']['output']
}

export type UpdateGa4IntegrationSettingInput = {
  name?: InputMaybe<Scalars['String']['input']>
  settingId: Scalars['String']['input']
}

export type UpdateGtmIntegrationSettingInput = {
  name?: InputMaybe<Scalars['String']['input']>
  settingId: Scalars['String']['input']
}

export type UpdateMediaLibraryAssetInput = {
  altText?: InputMaybe<Scalars['String']['input']>
  assetId: Scalars['ID']['input']
  description?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  title?: InputMaybe<Scalars['String']['input']>
}

export type UpdatePaymentDetailsInput = {
  address?: InputMaybe<AddressInput>
  customFields?: InputMaybe<Array<FormCustomFieldInput>>
  donationFormAmount?: InputMaybe<Scalars['Float']['input']>
  donorPaysAmount?: InputMaybe<Scalars['Float']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  fullAddress?: InputMaybe<Scalars['String']['input']>
  givingFrequency?: InputMaybe<DonationFrequency>
  isDonorChooseToPayFee?: InputMaybe<Scalars['Boolean']['input']>
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  mobile?: InputMaybe<Scalars['String']['input']>
  organisation?: InputMaybe<Scalars['String']['input']>
  paymentCardType?: InputMaybe<Scalars['String']['input']>
  paymentIntentId?: InputMaybe<Scalars['ID']['input']>
  paymentMethodId?: InputMaybe<Scalars['String']['input']>
  paymentMethodType?: InputMaybe<PaymentMethodType>
  subscriptionId?: InputMaybe<Scalars['ID']['input']>
}

export type UpdatePaymentInput = {
  campaignId: Scalars['ID']['input']
  charityId: Scalars['ID']['input']
  customFields?: InputMaybe<Array<FormCustomFieldInput>>
  donationFormAmount?: InputMaybe<Scalars['Float']['input']>
  donorPaysAmount?: InputMaybe<Scalars['Float']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  givingFrequency?: InputMaybe<DonationFrequency>
  isDonorChooseToPayFee?: InputMaybe<Scalars['Boolean']['input']>
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
  pageId: Scalars['ID']['input']
  paymentIntentId?: InputMaybe<Scalars['ID']['input']>
  paymentMethodType?: InputMaybe<PaymentMethodType>
  subscriptionId?: InputMaybe<Scalars['ID']['input']>
}

export type UpdatePaymentIntentResponse = {
  __typename?: 'UpdatePaymentIntentResponse'
  clientSecret?: Maybe<Scalars['String']['output']>
  paymentIntentId?: Maybe<Scalars['ID']['output']>
}

export enum UpdatePaymentMethodPermission {
  Anytime = 'Anytime',
  None = 'None',
  WhenPaymentFailed = 'WhenPaymentFailed',
}

export type UpdatePixelConversionsApiIntegrationSettingInput = {
  name?: InputMaybe<Scalars['String']['input']>
  settingId: Scalars['String']['input']
  testEventCode?: InputMaybe<Scalars['String']['input']>
}

export type UpdateProfileInput = {
  campaignId: Scalars['ID']['input']
  description?: InputMaybe<Scalars['String']['input']>
  goal?: InputMaybe<Scalars['Int']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  isApproved?: InputMaybe<Scalars['Boolean']['input']>
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>
  isGivingNotificationEnabled?: InputMaybe<Scalars['Boolean']['input']>
  logoUrl?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  profileId: Scalars['ID']['input']
  slug?: InputMaybe<Scalars['String']['input']>
}

export type UpdateSubscriptionAdminInput = {
  donationDetails?: InputMaybe<UpdateSubscriptionDonationDetailAdminInput>
  externalSubscriptionId: Scalars['String']['input']
  paymentSubscriptionId: Scalars['ID']['input']
  personalDetails?: InputMaybe<UpdateSubscriptionPersonalDetailAdminInput>
}

export type UpdateSubscriptionAdminResponse = {
  __typename?: 'UpdateSubscriptionAdminResponse'
  externalSubscriptionScheduleId?: Maybe<Scalars['String']['output']>
  paymentSubscriptionScheduleId?: Maybe<Scalars['ID']['output']>
}

export type UpdateSubscriptionDonationDetailAdminInput = {
  amount: Scalars['Float']['input']
  externalSubscriptionScheduleId?: InputMaybe<Scalars['String']['input']>
  frequency: GivingDonationFrequency
  startDate: Scalars['DateTime']['input']
}

export type UpdateSubscriptionPersonalDetailAdminInput = {
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
}

export type UpdateSubscriptionResponse = {
  __typename?: 'UpdateSubscriptionResponse'
  clientSecret?: Maybe<Scalars['String']['output']>
  subscriptionId?: Maybe<Scalars['ID']['output']>
}

export type UpdateTemplateInput = {
  htmlLayout?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  layout?: InputMaybe<PageLayoutInput>
  name?: InputMaybe<Scalars['String']['input']>
  screenshotImageUrl?: InputMaybe<Scalars['String']['input']>
}

export type Video = Component & {
  __typename?: 'Video'
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  title?: Maybe<Scalars['String']['output']>
  type: ComponentType
  url?: Maybe<Scalars['String']['output']>
}

export type VideoInput = {
  componentId: Scalars['ID']['input']
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  position?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  styles?: InputMaybe<Scalars['JSON']['input']>
  text?: InputMaybe<TextInput>
  title?: InputMaybe<Scalars['String']['input']>
  type: ComponentTypeInput
  url?: InputMaybe<Scalars['String']['input']>
}

export type VirtualGiftSection = Component & {
  __typename?: 'VirtualGiftSection'
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
}

export type VirtualGiftSectionInput = {
  componentId: Scalars['ID']['input']
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  subComponents: Scalars['JSON']['input']
  type: ComponentTypeInput
}

export type ClaimsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationQuery>
}>

export type ClaimsQuery = {
  __typename?: 'Query'
  claims: Array<{ __typename?: 'CharityClaim'; id: string; name: string; logoUrl?: string | null }>
}

export type SelectCharityMutationVariables = Exact<{
  input: SelectCharityInput
}>

export type SelectCharityMutation = { __typename?: 'Mutation'; selectCharity?: boolean | null }

export type CreateCharityMutationVariables = Exact<{
  charityInput: CreateCharityInput
}>

export type CreateCharityMutation = {
  __typename?: 'Mutation'
  createCharity: { __typename?: 'CreateCharityResult'; charityId: string }
}

export type CampaignPerformanceQueryVariables = Exact<{
  campaignId: Scalars['ID']['input']
  startDate: Scalars['DateTime']['input']
  endDate: Scalars['DateTime']['input']
  timezoneOffsetInMinutes: Scalars['Int']['input']
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
}>

export type CampaignPerformanceQuery = {
  __typename?: 'Query'
  campaignPerformance: {
    __typename?: 'GetCampaignPerformanceStatsQueryResult'
    donationCount: number
    averageDonationAmount: number
    totalAmount: number
    pageDonationAmounts: Array<{
      __typename?: 'CampaignPageDonationAmountStat'
      pageName: string
      amount: number
      count: number
    }>
    utmTagDonationAmounts: Array<{
      __typename?: 'CampaignUtmTagDonationAmountStat'
      tagName: string
      tagValue: string
      amount: number
      count: number
    }>
    donationAmounts: Array<{ __typename?: 'CampaignDonorAmountStat'; donorName: string; amount: number }>
    donationsByDates: Array<{
      __typename?: 'CampaignDonationByDateStat'
      date: string
      donationCount: number
      donationAmount: number
    }>
  }
}

export type CampaignAggregateGivingStatsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input']
  startDate: Scalars['DateTime']['input']
  endDate: Scalars['DateTime']['input']
  timezoneOffsetInMinutes: Scalars['Int']['input']
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
}>

export type CampaignAggregateGivingStatsQuery = {
  __typename?: 'Query'
  campaignAggregateGivingStats: {
    __typename?: 'GetCampaignPerformanceStatsQueryResult'
    donationCount: number
    averageDonationAmount: number
    totalAmount: number
  }
}

export type CampaignPageDonationAmountStatsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input']
  startDate: Scalars['DateTime']['input']
  endDate: Scalars['DateTime']['input']
  timezoneOffsetInMinutes: Scalars['Int']['input']
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
}>

export type CampaignPageDonationAmountStatsQuery = {
  __typename?: 'Query'
  campaignPageDonationAmounts: Array<{
    __typename?: 'CampaignPageDonationAmountStat'
    pageName: string
    amount: number
    count: number
  }>
}

export type CampaignUtmTagDonationAmountStatsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input']
  startDate: Scalars['DateTime']['input']
  endDate: Scalars['DateTime']['input']
  timezoneOffsetInMinutes: Scalars['Int']['input']
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
}>

export type CampaignUtmTagDonationAmountStatsQuery = {
  __typename?: 'Query'
  campaignUtmTagDonationAmounts: Array<{
    __typename?: 'CampaignUtmTagDonationAmountStat'
    tagName: string
    tagValue: string
    amount: number
    count: number
  }>
}

export type CampaignTopAmountStatsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input']
  startDate: Scalars['DateTime']['input']
  endDate: Scalars['DateTime']['input']
  timezoneOffsetInMinutes: Scalars['Int']['input']
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
}>

export type CampaignTopAmountStatsQuery = {
  __typename?: 'Query'
  campaignTopDonationAmounts: Array<{ __typename?: 'CampaignDonorAmountStat'; donorName: string; amount: number }>
}

export type CampaignAmountsByDateQueryVariables = Exact<{
  campaignId: Scalars['ID']['input']
  startDate: Scalars['DateTime']['input']
  endDate: Scalars['DateTime']['input']
  timezoneOffsetInMinutes: Scalars['Int']['input']
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
}>

export type CampaignAmountsByDateQuery = {
  __typename?: 'Query'
  campaignAmountsByDate: Array<{
    __typename?: 'CampaignDonationByDateStat'
    date: string
    donationCount: number
    donationAmount: number
  }>
}

export type CampaignsQueryVariables = Exact<{
  pagination: PaginationQuery
}>

export type CampaignsQuery = {
  __typename?: 'Query'
  campaigns: Array<{
    __typename?: 'Campaign'
    id: string
    title: string
    campaignDomain?: string | null
    type?: CampaignType | null
    isP2PEnabled: boolean
  }>
}

export type CampaignsOverviewQueryVariables = Exact<{
  campaignIds: Array<Scalars['ID']['input']> | Scalars['ID']['input']
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
}>

export type CampaignsOverviewQuery = {
  __typename?: 'Query'
  campaignsOverview: Array<{
    __typename?: 'CampaignOverview'
    id: string
    totalDonors: number
    totalAmount: number
    campaignSettings?: {
      __typename?: 'CampaignSettings'
      aggregationSettings?: {
        __typename?: 'AggregationSettings'
        progressBarSetting?: {
          __typename?: 'ProgressBarAggregationSetting'
          groupSettings?: Array<{
            __typename?: 'ProgressBarAggregationSettingItem'
            progressBarGoals?: Array<{ __typename?: 'ProgressBarGoal'; goal: number }> | null
          }> | null
        } | null
      } | null
      pageReferences?: Array<{
        __typename?: 'PageReference'
        thankYouPageIds: Array<string>
        receiptPageIds: Array<string>
        pageId: string
      }> | null
      paymentSettings?: {
        __typename?: 'PreviewCampaignPaymentSettings'
        platformFeeType?: PlatformFeeType | null
      } | null
    } | null
    pages?: Array<{
      __typename?: 'PageDetail'
      id: string
      name?: string | null
      screenshotImageUrl?: string | null
      status: PageStatusType
      slug?: string | null
      index: number
      publishedAt?: any | null
      pageBucketId?: string | null
      type?: PageType | null
    }> | null
    buckets?: Array<{ __typename?: 'PageBucketDetail'; id: string; name?: string | null; slug?: string | null }> | null
  }>
}

export type BrandingsQueryVariables = Exact<{ [key: string]: never }>

export type BrandingsQuery = {
  __typename?: 'Query'
  brandings: Array<{
    __typename?: 'Branding'
    id: string
    name: string
    isDefault: boolean
    value: string
    logoURL?: string | null
  }>
}

export type CreateBrandingMutationVariables = Exact<{
  brandingInput: CreateBrandingInput
}>

export type CreateBrandingMutation = {
  __typename?: 'Mutation'
  createBranding: { __typename?: 'CreateBrandingResponse'; id: string }
}

export type CreateCampaignMutationVariables = Exact<{
  campaignInput: CreateCampaignInput
}>

export type CreateCampaignMutation = {
  __typename?: 'Mutation'
  createCampaign: {
    __typename?: 'Campaign'
    id: string
    title: string
    goal?: number | null
    type?: CampaignType | null
    startDate?: string | null
    endDate?: string | null
  }
}

export type UpdateCampaignTitleMutationVariables = Exact<{
  campaignId: Scalars['ID']['input']
  campaignTitle: Scalars['String']['input']
}>

export type UpdateCampaignTitleMutation = { __typename?: 'Mutation'; updateCampaignTitle: string }

export type InitCampaignMutationVariables = Exact<{
  initCampaignInput: InitCampaignInput
}>

export type InitCampaignMutation = {
  __typename?: 'Mutation'
  initCampaign: { __typename?: 'PageResponse'; id: string }
}

export type DuplicateCampaignMutationVariables = Exact<{
  duplicateCampaignInput: DuplicateCampaignInput
}>

export type DuplicateCampaignMutation = { __typename?: 'Mutation'; duplicateCampaign: string }

export type CampaignQueryVariables = Exact<{
  campaignId: Scalars['ID']['input']
}>

export type CampaignQuery = {
  __typename?: 'Query'
  campaign: {
    __typename?: 'Campaign'
    type?: CampaignType | null
    endDate?: string | null
    goal?: number | null
    startDate?: string | null
    title: string
  }
}

export type DeleteCampaignMutationVariables = Exact<{
  deleteCampaignInput: DeleteCampaignInput
}>

export type DeleteCampaignMutation = { __typename?: 'Mutation'; deleteCampaign: string }

export type CampaignDetailsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input']
}>

export type CampaignDetailsQuery = {
  __typename?: 'Query'
  campaign: { __typename?: 'Campaign'; title: string }
  charity: { __typename?: 'Charity'; name: string }
  pages: Array<{
    __typename?: 'PageDetail'
    id: string
    name?: string | null
    status: PageStatusType
    slug?: string | null
    index: number
    hasBeenPublished?: boolean | null
  }>
}

export type CreateManualDonationMutationVariables = Exact<{
  input: CreateManualDonationInput
}>

export type CreateManualDonationMutation = { __typename?: 'Mutation'; createManualDonation?: string | null }

export type CreateManualSubscriptionMutationVariables = Exact<{
  input: CreateManualSubscriptionInput
}>

export type CreateManualSubscriptionMutation = { __typename?: 'Mutation'; createManualSubscription?: string | null }

export type CreateOfflineDonationMutationVariables = Exact<{
  input: CreateOfflineDonationInput
}>

export type CreateOfflineDonationMutation = { __typename?: 'Mutation'; createOfflineDonation?: string | null }

export type ApproveIdentityPartnerSettingsMutationVariables = Exact<{
  input: IdentityPartnerSettingInput
}>

export type ApproveIdentityPartnerSettingsMutation = {
  __typename?: 'Mutation'
  approveIdentityPartnerSettings?: boolean | null
}

export type ApproveRaiserEdgeIntegrationSettingMutationVariables = Exact<{
  state: Scalars['String']['input']
  code: Scalars['String']['input']
}>

export type ApproveRaiserEdgeIntegrationSettingMutation = {
  __typename?: 'Mutation'
  approveRaiserEdgeIntegrationSetting?: boolean | null
}

export type AddRaiserEdgeIntegrationSettingMutationVariables = Exact<{
  input: RaiserEdgeIntegrationSettingInput
}>

export type AddRaiserEdgeIntegrationSettingMutation = {
  __typename?: 'Mutation'
  addRaiserEdgeIntegrationSetting?: string | null
}

export type AnalyticsIntegrationSettingsQueryVariables = Exact<{ [key: string]: never }>

export type AnalyticsIntegrationSettingsQuery = {
  __typename?: 'Query'
  analyticsIntegrationSettings: {
    __typename?: 'AnalyticsIntegrationSettings'
    pixelConversionsApiSettings: Array<{
      __typename?: 'PixelConversionsApiIntegrationSetting'
      pixelId: string
      settingId: string
      isConversionsApi: boolean
      name: string
      testEventCode?: string | null
    }>
    gtmSettings: Array<{ __typename?: 'GtmIntegrationSetting'; tagId: string; settingId: string; name: string }>
    ga4Settings: Array<{ __typename?: 'Ga4IntegrationSetting'; measurementId: string; settingId: string; name: string }>
    identityPartnerSettings?: {
      __typename?: 'IdentityPartnerSetting'
      items: Array<{ __typename?: 'MoveDataIntegrationSetting'; settingId?: string | null; webhookUrl: string }>
    } | null
    raiserEdgeIntegrationSettings?: Array<{
      __typename?: 'RaiserEdgeIntegrationSetting'
      settingId?: string | null
      clientId: string
      callbackUrl: string
    }> | null
  }
}

export type AddPixelConversionsApiSettingMutationVariables = Exact<{
  input: PixelConversionsApiIntegrationSettingInput
}>

export type AddPixelConversionsApiSettingMutation = {
  __typename?: 'Mutation'
  addPixelConversionsApiSetting?: string | null
}

export type AddGtmSettingMutationVariables = Exact<{
  input: GtmIntegrationSettingInput
}>

export type AddGtmSettingMutation = { __typename?: 'Mutation'; addGtmSetting?: string | null }

export type AddGa4SettingMutationVariables = Exact<{
  input: Ga4IntegrationSettingInput
}>

export type AddGa4SettingMutation = { __typename?: 'Mutation'; addGa4Setting?: string | null }

export type UpdatePixelConversionsApiSettingMutationVariables = Exact<{
  input: Array<UpdatePixelConversionsApiIntegrationSettingInput> | UpdatePixelConversionsApiIntegrationSettingInput
}>

export type UpdatePixelConversionsApiSettingMutation = {
  __typename?: 'Mutation'
  updatePixelConversionsApiSetting?: string | null
}

export type UpdateGtmSettingMutationVariables = Exact<{
  input: Array<UpdateGtmIntegrationSettingInput> | UpdateGtmIntegrationSettingInput
}>

export type UpdateGtmSettingMutation = { __typename?: 'Mutation'; updateGtmSetting?: string | null }

export type UpdateGa4SettingMutationVariables = Exact<{
  input: Array<UpdateGa4IntegrationSettingInput> | UpdateGa4IntegrationSettingInput
}>

export type UpdateGa4SettingMutation = { __typename?: 'Mutation'; updateGa4Setting?: string | null }

export type DeleteAnalyticsSettingMutationVariables = Exact<{
  input: DeleteAnalyticsSettingInput
}>

export type DeleteAnalyticsSettingMutation = { __typename?: 'Mutation'; deleteAnalyticsSetting?: string | null }

export type SendCharityTaxSummaryMutationVariables = Exact<{
  input: SendCharityTaxSummaryInput
}>

export type SendCharityTaxSummaryMutation = { __typename?: 'Mutation'; sendCharityTaxSummary: boolean }

export type CharityTaxSummaryStatusQueryVariables = Exact<{
  financialYear: Scalars['Int']['input']
  isLiveMode: Scalars['Boolean']['input']
}>

export type CharityTaxSummaryStatusQuery = {
  __typename?: 'Query'
  charityTaxSummaryStatus: {
    __typename?: 'CharityTaxSummaryStatus'
    isSendLogExists: boolean
    status?: CharityTaxSummarySendLogStatus | null
    totalEmailCount?: number | null
  }
}

export type CharityTaxSummaryTotalEmailCountQueryVariables = Exact<{
  financialYear: Scalars['Int']['input']
  taxSummarySettingType: CharityTaxSummaryMessageType
  isLiveMode: Scalars['Boolean']['input']
}>

export type CharityTaxSummaryTotalEmailCountQuery = { __typename?: 'Query'; charityTaxSummaryTotalEmailCount: number }

export type ChangeUserRoleMutationVariables = Exact<{
  userId: Scalars['String']['input']
  roleId: Scalars['String']['input']
  mfaJwt: Scalars['String']['input']
}>

export type ChangeUserRoleMutation = { __typename?: 'Mutation'; changeRole?: boolean | null }

export type CharityUserRolesQueryVariables = Exact<{ [key: string]: never }>

export type CharityUserRolesQuery = {
  __typename?: 'Query'
  charityUserRoles: Array<{ __typename?: 'Role'; roleId: string; roleName: string }>
}

export type CharityUsersQueryVariables = Exact<{
  pagination: PaginationQuery
}>

export type CharityUsersQuery = {
  __typename?: 'Query'
  charityUsers?: {
    __typename?: 'CharityUserWithPagination'
    totalRecords: number
    items: Array<{
      __typename?: 'CharityUser'
      userId: string
      email: string
      name?: string | null
      role?: { __typename?: 'Role'; roleId: string; roleName: string } | null
    }>
  } | null
}

export type CreateUserForCharityMutationVariables = Exact<{
  input: CreateUserForCharityInput
  mfaJwt: Scalars['String']['input']
}>

export type CreateUserForCharityMutation = { __typename?: 'Mutation'; createUserForCharity?: boolean | null }

export type DeleteUserForCharityMutationVariables = Exact<{
  userId: Scalars['String']['input']
  mfaJwt: Scalars['String']['input']
}>

export type DeleteUserForCharityMutation = { __typename?: 'Mutation'; deleteUserFromCharity?: boolean | null }

export type AddPayPalByReferralMutationVariables = Exact<{
  input: AddPayPalByReferralInput
}>

export type AddPayPalByReferralMutation = { __typename?: 'Mutation'; addPayPalByReferral?: string | null }

export type CreatePaypalReferralLinkMutationVariables = Exact<{
  input: CreatePaypalReferralLinkInput
}>

export type CreatePaypalReferralLinkMutation = {
  __typename?: 'Mutation'
  createPaypalReferralLink: {
    __typename?: 'CreatePaypalReferralLinkResponse'
    referralLink: string
    referralToken: string
    merchantEmail: string
  }
}

export type ConnectStripeStandardAccountOAuthMutationVariables = Exact<{
  isLiveMode: Scalars['Boolean']['input']
}>

export type ConnectStripeStandardAccountOAuthMutation = {
  __typename?: 'Mutation'
  connectStripeStandardAccountOAuth?: string | null
}

export type SetCharityPlatformFeeMutationVariables = Exact<{
  platformFeeType: PlatformFeeType
}>

export type SetCharityPlatformFeeMutation = { __typename?: 'Mutation'; setCharityPlatformFee?: string | null }

export type CharityPageRedirectionSettingQueryVariables = Exact<{ [key: string]: never }>

export type CharityPageRedirectionSettingQuery = {
  __typename?: 'Query'
  charityPageRedirectionSetting: Array<{
    __typename?: 'CharityPageRedirectionSetting'
    id: string
    externalTo?: string | null
    to?: {
      __typename?: 'CharityPageRedirectionSettingItem'
      id: string
      type: PageRedirectType
      name: string
      campaignId: string
      campaignName?: string | null
    } | null
    from: Array<{
      __typename?: 'CharityPageRedirectionSettingItem'
      id: string
      type: PageRedirectType
      name: string
      campaignId: string
      campaignName?: string | null
    }>
  }>
}

export type SetCharityPageRedirectionSettingsMutationVariables = Exact<{
  input: Array<CharityPageRedirectionSettingsInput> | CharityPageRedirectionSettingsInput
}>

export type SetCharityPageRedirectionSettingsMutation = {
  __typename?: 'Mutation'
  setCharityPageRedirectionSettings?: boolean | null
}

export type PageRedirectCampaignsQueryVariables = Exact<{
  pagination: PaginationQuery
}>

export type PageRedirectCampaignsQuery = {
  __typename?: 'Query'
  campaigns: Array<{ __typename?: 'Campaign'; id: string; title: string }>
}

export type ExchangeStripeOAuthCodeMutationVariables = Exact<{
  input: ExchangeStripeOAuthInput
}>

export type ExchangeStripeOAuthCodeMutation = { __typename?: 'Mutation'; exchangeStripeOAuthCode?: string | null }

export type CharitySettingsQueryVariables = Exact<{ [key: string]: never }>

export type CharitySettingsQuery = {
  __typename?: 'Query'
  charityPaymentSettings: {
    __typename?: 'CharityPaymentSettings'
    platformFeeType?: PlatformFeeType | null
    stripe?: Array<{
      __typename?: 'CharityStripeSettings'
      id: string
      label?: string | null
      accountId: string
      isDefault?: boolean | null
    }> | null
    payPal?: Array<{
      __typename?: 'CharityPayPalSettings'
      id: string
      label?: string | null
      merchantEmail?: string | null
      isDefault?: boolean | null
    }> | null
  }
  customFieldSettings: Array<{
    __typename?: 'CustomFieldSetting'
    id: string
    name: string
    description?: string | null
    type: CustomFieldType
    elementType: CustomFieldElementType
    defaultValue?: string | null
    acceptedValues?: Array<{ __typename?: 'CustomFieldValue'; key: string; value: string }> | null
  }>
}

export type SetCharityPayPalSettingsMutationVariables = Exact<{
  input: CharityPayPalSettingsInput
}>

export type SetCharityPayPalSettingsMutation = {
  __typename?: 'Mutation'
  setCharityPayPalSettings: { __typename?: 'SetPaymentProviderSettingsResponse'; label: string }
}

export type SetCharityStripeSettingsMutationVariables = Exact<{
  input: CharityStripeSettingsInput
}>

export type SetCharityStripeSettingsMutation = {
  __typename?: 'Mutation'
  setCharityStripeSettings: { __typename?: 'SetPaymentProviderSettingsResponse'; label: string }
}

export type AddCustomFieldMutationVariables = Exact<{
  input: CustomFieldSettingInput
}>

export type AddCustomFieldMutation = {
  __typename?: 'Mutation'
  addCustomFieldSetting: {
    __typename?: 'CustomFieldSetting'
    id: string
    name: string
    description?: string | null
    type: CustomFieldType
    elementType: CustomFieldElementType
    acceptedValues?: Array<{ __typename?: 'CustomFieldValue'; key: string; value: string }> | null
  }
}

export type UpdateCustomFieldMutationVariables = Exact<{
  input: CustomFieldSettingInput
}>

export type UpdateCustomFieldMutation = { __typename?: 'Mutation'; updateCustomFieldSetting: string }

export type CharityDetailQueryVariables = Exact<{ [key: string]: never }>

export type CharityDetailQuery = {
  __typename?: 'Query'
  charityDetail: {
    __typename?: 'CharityDetail'
    name?: string | null
    description?: string | null
    phone?: string | null
    email?: string | null
    abn?: string | null
    faviconUrl?: string | null
    logoUrl?: string | null
    reversedLogoUrl?: string | null
    fromName?: string | null
    fromEmail?: string | null
    isDgrEndorsed?: boolean | null
    sendPdfReceipt?: boolean | null
    autoSendTaxSummaryEmailDate?: string | null
    branding?: string | null
    domain?: string | null
  }
}

export type SetCharityDetailMutationVariables = Exact<{
  input: CharityDetailInput
}>

export type SetCharityDetailMutation = { __typename?: 'Mutation'; setCharityDetail: string }

export type SetCharityBrandingMutationVariables = Exact<{
  brandingId: Scalars['ID']['input']
}>

export type SetCharityBrandingMutation = { __typename?: 'Mutation'; setCharityBranding: boolean }

export type AggregatedGivingsQueryVariables = Exact<{
  input: AggregatedGivingsInput
}>

export type AggregatedGivingsQuery = {
  __typename?: 'Query'
  aggregatedGivings?: {
    __typename?: 'AggregatedGivings'
    total?: number | null
    amounts: Array<{ __typename?: 'AggregatedGiving'; date: any; amount: number }>
  } | null
}

export type CharityDonorPortalSettingsQueryVariables = Exact<{ [key: string]: never }>

export type CharityDonorPortalSettingsQuery = {
  __typename?: 'Query'
  charityDonorPortalSettings?: {
    __typename?: 'CharityDonorPortalSettings'
    regularGivingPermissions?: {
      __typename?: 'CharityDonorPortalRegularGivingPermissions'
      canEditName: boolean
      canEditAmount: boolean
      canEditFrequency: boolean
      canEditDonationEndDate: boolean
      canEditNextPaymentDate: boolean
      canCancelDonation: boolean
      canPauseDonation: boolean
      canResumeDonation: boolean
      updatePaymentDetails: UpdatePaymentMethodPermission
    } | null
  } | null
}

export type SetCharityDonorPortalPermissionsMutationVariables = Exact<{
  input: CharityDonorPortalPermissionsInput
}>

export type SetCharityDonorPortalPermissionsMutation = {
  __typename?: 'Mutation'
  setCharityDonorPortalPermissions?: boolean | null
}

export type UpdateBrandingMutationVariables = Exact<{
  brandingInput: UpdateBrandingInput
}>

export type UpdateBrandingMutation = {
  __typename?: 'Mutation'
  updateBranding: { __typename?: 'UpdateBrandingResponse'; brandingId: string }
}

export type CampaignAssetsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input']
  pagination: PaginationQuery
}>

export type CampaignAssetsQuery = {
  __typename?: 'Query'
  campaignAssets: Array<{ __typename?: 'CampaignAsset'; id: string; url: string; fileName: string }>
}

export type DeleteCampaignAssetMutationVariables = Exact<{
  assetId: Scalars['ID']['input']
  campaignId: Scalars['ID']['input']
}>

export type DeleteCampaignAssetMutation = { __typename?: 'Mutation'; deleteCampaignAsset?: boolean | null }

export type SetThankYouPageReferencesMutationVariables = Exact<{
  input: SetThankYouPageReferencesInput
}>

export type SetThankYouPageReferencesMutation = { __typename?: 'Mutation'; setThankYouPageReferences: boolean }

export type SetReceiptPageReferencesMutationVariables = Exact<{
  input: SetReceiptPageReferencesInput
}>

export type SetReceiptPageReferencesMutation = { __typename?: 'Mutation'; setReceiptPageReferences: boolean }

export type CreatePageBucketMutationVariables = Exact<{
  createPageBucketInput: CreatePageBucketInput
}>

export type CreatePageBucketMutation = {
  __typename?: 'Mutation'
  createPageBucket: { __typename?: 'PageResponse'; id: string }
}

export type SendTestEmailMutationVariables = Exact<{
  sendTestReceiptInput: SendTestReceiptInput
}>

export type SendTestEmailMutation = { __typename?: 'Mutation'; sendTestEmail?: string | null }

export type SectionTemplatesQueryVariables = Exact<{
  pageType: PageType
}>

export type SectionTemplatesQuery = { __typename?: 'Query'; sectionTemplates: any }

export type CampaignInformationQueryVariables = Exact<{
  campaignId: Scalars['ID']['input']
}>

export type CampaignInformationQuery = {
  __typename?: 'Query'
  campaign: {
    __typename?: 'Campaign'
    title: string
    platformFeeType?: PlatformFeeType | null
    type?: CampaignType | null
  }
  charity: { __typename?: 'Charity'; name: string }
}

export type CampaignSettingsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input']
}>

export type CampaignSettingsQuery = {
  __typename?: 'Query'
  campaignSettings: {
    __typename?: 'CampaignSettings'
    defaultCampaignPageId?: string | null
    isPeerToPeerGivingNotificationEnabled?: boolean | null
    pageReferences?: Array<{
      __typename?: 'PageReference'
      pageId: string
      thankYouPageIds: Array<string>
      receiptPageIds: Array<string>
    }> | null
    peerToPeerPageMapSettings?: {
      __typename?: 'PeerToPeerPageMapSettings'
      singleFundraiserPageIds?: Array<{
        __typename?: 'PeerToPeerPageMapItem'
        pageId?: string | null
        categoryId?: string | null
      }> | null
      multipleFundraiserPageIds?: Array<{
        __typename?: 'PeerToPeerPageMapItem'
        pageId?: string | null
        categoryId?: string | null
      }> | null
    } | null
    emailReceiptSettings?: {
      __typename?: 'EmailReceiptSettings'
      profileRegisteredNotificationEmailsEnabled?: boolean | null
      receiptOptionSetting?: {
        __typename?: 'ReceiptOptionSetting'
        givingReceiptOption?: GivingReceiptOptionSetting | null
        subscriptionReceiptOption?: SubscriptionReceiptOptionSetting | null
        sendPdfReceipt?: boolean | null
        sendFundraiserWelcomeEmail?: boolean | null
      } | null
      items?: Array<{
        __typename?: 'EmailReceiptSettingItem'
        receiptPageId: string
        subject?: string | null
        from?: string | null
        replyTo?: string | null
      }> | null
      profileRegisteredNotificationEmails?: Array<{
        __typename?: 'PeerToPeerFundraiserRegistrationNotificationSettingValue'
        displayName: string
        email: string
      }> | null
    } | null
  }
}

export type CharityProfileCategoriesQueryVariables = Exact<{ [key: string]: never }>

export type CharityProfileCategoriesQuery = {
  __typename?: 'Query'
  charityProfileCategories: Array<{ __typename?: 'ProfileCategory'; id: string; name: string }>
}

export type CampaignUrlsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input']
}>

export type CampaignUrlsQuery = {
  __typename?: 'Query'
  campaignDomain: { __typename?: 'CampaignDomain'; slug?: string | null; domain: string; origin: string }
}

export type CreateTemplateMutationVariables = Exact<{
  input: CreateTemplateInput
}>

export type CreateTemplateMutation = { __typename?: 'Mutation'; createTemplate: string }

export type UpdateTemplateMutationVariables = Exact<{
  input: UpdateTemplateInput
}>

export type UpdateTemplateMutation = { __typename?: 'Mutation'; updateTemplate: string }

export type DeleteTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DeleteTemplateMutation = { __typename?: 'Mutation'; deleteTemplate: string }

export type MergeTagsQueryVariables = Exact<{ [key: string]: never }>

export type MergeTagsQuery = {
  __typename?: 'Query'
  charityMergeTags: Array<{
    __typename?: 'MergeFieldSetting'
    MergeFieldSettingId: string
    MergeTag: string
    MergeFieldName: string
    QueryParameter: string
  }>
}

export type InitFundraiserPagesMutationVariables = Exact<{
  campaignId: Scalars['ID']['input']
}>

export type InitFundraiserPagesMutation = { __typename?: 'Mutation'; initFundraiserPages?: boolean | null }

export type CampaignPagesQueryVariables = Exact<{
  campaignId: Scalars['ID']['input']
  pageTypes: Array<PageType> | PageType
}>

export type CampaignPagesQuery = {
  __typename?: 'Query'
  pageBuckets: Array<{ __typename?: 'PageBucketDetail'; id: string; name?: string | null; slug?: string | null }>
  pages: Array<{
    __typename?: 'PageDetail'
    id: string
    type?: PageType | null
    name?: string | null
    status: PageStatusType
    slug?: string | null
    index: number
    hasBeenPublished?: boolean | null
    screenshotImageUrl?: string | null
    pageBucketId?: string | null
  }>
}

export type PageBucketsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input']
}>

export type PageBucketsQuery = {
  __typename?: 'Query'
  pageBuckets: Array<{
    __typename?: 'PageBucketDetail'
    id: string
    name?: string | null
    slug?: string | null
    pageIds?: Array<string> | null
  }>
}

export type CharityPageTemplatesQueryVariables = Exact<{
  type: CharityTemplateType
  pageType: PageType
}>

export type CharityPageTemplatesQuery = {
  __typename?: 'Query'
  charityTemplates: Array<{
    __typename?: 'CharityTemplateDetail'
    id: string
    name?: string | null
    screenshotImageUrl?: string | null
  }>
}

export type PageLayoutQueryVariables = Exact<{
  pageId: Scalars['ID']['input']
  pageType: PageType
}>

export type PageLayoutQuery = {
  __typename?: 'Query'
  pageLayout: { __typename?: 'Page' } & { ' $fragmentRefs'?: { EditorPageLayoutFragment: EditorPageLayoutFragment } }
}

export type TemplateLayoutQueryVariables = Exact<{
  templateId: Scalars['ID']['input']
  templateType: TemplateType
}>

export type TemplateLayoutQuery = {
  __typename?: 'Query'
  templatePage?:
    | ({ __typename?: 'Page' } & { ' $fragmentRefs'?: { EditorPageLayoutFragment: EditorPageLayoutFragment } })
    | null
}

export type PreviewLayoutQueryVariables = Exact<{
  previewId: Scalars['ID']['input']
}>

export type PreviewLayoutQuery = {
  __typename?: 'Query'
  previewLayout: {
    __typename?: 'PreviewQueryResult'
    page: { __typename?: 'Page' } & { ' $fragmentRefs'?: { EditorPageLayoutFragment: EditorPageLayoutFragment } }
    campaignSettings?: {
      __typename?: 'CampaignSettings'
      pageReferences?: Array<{ __typename?: 'PageReference'; pageId: string; thankYouPageIds: Array<string> }> | null
      paymentSettings?: {
        __typename?: 'PreviewCampaignPaymentSettings'
        hasStripe?: boolean | null
        hasPaypal?: boolean | null
        platformFeeType?: PlatformFeeType | null
      } | null
      matchedGivingSettings?: Array<{
        __typename?: 'CampaignMatchedGivingSetting'
        id: string
        startAt: string
        endAt?: string | null
        rounds: Array<{
          __typename?: 'CampaignMatchedGivingSettingItem'
          startFundRange: number
          endFundRange: number
          multiplier: number
        }>
      }> | null
      aggregationSettings?: {
        __typename?: 'AggregationSettings'
        progressBarSetting?: {
          __typename?: 'ProgressBarAggregationSetting'
          groupSettings?: Array<{
            __typename?: 'ProgressBarAggregationSettingItem'
            startVisibleTime?: any | null
            endVisibleTime?: any | null
            isGoalHidden?: boolean | null
            pageIds: Array<string>
            hideWhenMatchedGivingActive?: boolean | null
            progressBarGoals?: Array<{ __typename?: 'ProgressBarGoal'; goal: number }> | null
          }> | null
        } | null
        commentSetting?: {
          __typename?: 'CommentAggregationSetting'
          groupSettings?: Array<{
            __typename?: 'CommentAggregationSettingItem'
            startVisibleTime?: any | null
            endVisibleTime?: any | null
            pageIds: Array<string>
          }> | null
        } | null
        matchedGivingSetting?: {
          __typename?: 'MatchedGivingAggregationSetting'
          groupSettings?: Array<{
            __typename?: 'MatchedGivingAggregationSettingItem'
            pageIds: Array<string>
            matchedGivingSettingIds: Array<string>
          }> | null
        } | null
        countdownTimerSetting?: {
          __typename?: 'CountdownTimerAggregationSetting'
          groupSettings?: Array<{
            __typename?: 'CountdownTimerAggregationSettingItem'
            finishTime?: any | null
            startVisibleTime?: any | null
            endVisibleTime?: any | null
            pageIds: Array<string>
            bonusFinishTimes?: Array<any> | null
          }> | null
        } | null
      } | null
    } | null
    metadata?: {
      __typename?: 'Metadata'
      charity?: {
        __typename?: 'CharityMetadata'
        CharityName?: string | null
        Phone?: string | null
        Email?: string | null
        ABN?: string | null
        CustomFields?: string | null
        FaviconUrl?: string | null
      } | null
      campaign?: {
        __typename?: 'CampaignMetadata'
        CampaignName?: string | null
        CampaignGoal?: string | null
        ogImage?: string | null
        ogTitle?: string | null
        gtmScriptId?: string | null
        ga4ScriptId?: string | null
        fbPixelId?: string | null
        isConversionsApi?: boolean | null
      } | null
      page?: {
        __typename?: 'PageMetadata'
        OgImage?: string | null
        OgTitle?: string | null
        OgDescription?: string | null
      } | null
    } | null
    profiles?: Array<{
      __typename?: 'ProfileData'
      id: string
      name: string
      logoUrl?: string | null
      description?: string | null
      goal?: number | null
      progressAmount?: number | null
    }> | null
  }
}

export type EditorPageLayoutFragment = {
  __typename?: 'Page'
  id: string
  name?: string | null
  branding?: string | null
  versionNumber?: number | null
  charityPageTemplateId?: string | null
  charityPageTemplateVersion?: number | null
  header?: {
    __typename?: 'Header'
    id: string
    type: ComponentType
    hasDonateButton: boolean
    styles?: any | null
    mobileStyles?: any | null
  } | null
  footer?: {
    __typename?: 'Footer'
    id: string
    type: ComponentType
    taxDeductibleText?: string | null
    keyInformationText?: string | null
    styles?: any | null
    mobileStyles?: any | null
  } | null
  components: Array<
    | {
        __typename?: 'Button'
        id: string
        type: ComponentType
        buttonText: string
        url?: string | null
        target?: string | null
        buttonType: string
        styles?: any | null
        mobileStyles?: any | null
      }
    | { __typename?: 'Column'; id: string; type: ComponentType; styles?: any | null; mobileStyles?: any | null }
    | {
        __typename?: 'Comments'
        id: string
        type: ComponentType
        showAmount: boolean
        showMessage: boolean
        showTotal: boolean
        showViewAll: boolean
        layout: CommentsLayout
        styles?: any | null
        mobileStyles?: any | null
        start?: any | null
        end?: any | null
        hideBeforeStart?: boolean | null
        hideOnEnd?: boolean | null
        isAllPagesLinked?: boolean | null
        linkedPageIds?: Array<string> | null
        amountToShowOver?: number | null
      }
    | {
        __typename?: 'CountdownTimer'
        id: string
        type: ComponentType
        start?: any | null
        end?: any | null
        hideOnEnd?: boolean | null
        hideBeforeStart?: boolean | null
        finish?: any | null
        styles?: any | null
        mobileStyles?: any | null
      }
    | {
        __typename?: 'DollarHandles'
        id: string
        type: ComponentType
        styles?: any | null
        mobileStyles?: any | null
        dollarHandles: Array<{
          __typename?: 'DollarHandle'
          amount: number
          description?: string | null
          imageUrl?: string | null
          hasImage?: boolean | null
          hasDescription?: boolean | null
        }>
      }
    | {
        __typename?: 'DonationForm'
        id: string
        type: ComponentType
        title?: string | null
        donationFrequency: Array<DonationFrequency>
        donationFrequencyDefault?: number | null
        dollarHandlesDefault?: number | null
        legalUrl?: string | null
        styles?: any | null
        mobileStyles?: any | null
        minimumAmount?: number | null
        matchedGivings?: Array<{
          __typename?: 'CampaignMatchedGivingSetting'
          id: string
          startAt: string
          endAt?: string | null
          rounds: Array<{ __typename?: 'CampaignMatchedGivingSettingItem'; endFundRange: number; multiplier: number }>
        }> | null
        dollarHandles: Array<{
          __typename?: 'DollarHandle'
          amount: number
          description?: string | null
          imageUrl?: string | null
          isPersonalised?: boolean | null
          hasImage?: boolean | null
          hasDescription?: boolean | null
        }>
        extraFields: Array<{
          __typename?: 'ExtraField'
          type: ExtraFieldType
          name: string
          label: string
          isRequired: boolean
          order?: number | null
          defaultValue?: string | null
          placeholder?: string | null
          conditionalFields?: Array<{
            __typename?: 'ExtraField'
            type: ExtraFieldType
            name: string
            label: string
            isRequired: boolean
            order?: number | null
            defaultValue?: string | null
            placeholder?: string | null
            customField?: {
              __typename?: 'CustomField'
              id: string
              name: string
              elementType: CustomFieldElementType
              fieldDescription?: string | null
              acceptedValues?: Array<{ __typename?: 'CustomFieldValue'; key: string; value: string }> | null
            } | null
          }> | null
          customField?: {
            __typename?: 'CustomField'
            id: string
            name: string
            elementType: CustomFieldElementType
            fieldDescription?: string | null
            acceptedValues?: Array<{ __typename?: 'CustomFieldValue'; key: string; value: string }> | null
          } | null
        }>
      }
    | { __typename?: 'Empty'; id: string; type: ComponentType; styles?: any | null; mobileStyles?: any | null }
    | { __typename?: 'Footer'; id: string; type: ComponentType }
    | {
        __typename?: 'FundraiserButton'
        id: string
        type: ComponentType
        styles?: any | null
        mobileStyles?: any | null
        loginForm: { __typename?: 'LoginForm'; id: string }
        registerForm: {
          __typename?: 'RegisterForm'
          id: string
          extraFields?: Array<{
            __typename?: 'ExtraField'
            type: ExtraFieldType
            name: string
            label: string
            isRequired: boolean
            order?: number | null
            defaultValue?: string | null
            placeholder?: string | null
            conditionalFields?: Array<{
              __typename?: 'ExtraField'
              type: ExtraFieldType
              name: string
              label: string
              isRequired: boolean
              order?: number | null
              defaultValue?: string | null
              placeholder?: string | null
              customField?: {
                __typename?: 'CustomField'
                id: string
                name: string
                elementType: CustomFieldElementType
                fieldDescription?: string | null
                acceptedValues?: Array<{ __typename?: 'CustomFieldValue'; key: string; value: string }> | null
              } | null
            }> | null
            customField?: {
              __typename?: 'CustomField'
              id: string
              name: string
              elementType: CustomFieldElementType
              fieldDescription?: string | null
              acceptedValues?: Array<{ __typename?: 'CustomFieldValue'; key: string; value: string }> | null
            } | null
          }> | null
        }
      }
    | {
        __typename?: 'FundraiserProfile'
        id: string
        type: ComponentType
        subComponents?: any | null
        styles?: any | null
        mobileStyles?: any | null
      }
    | { __typename?: 'Header'; id: string; type: ComponentType }
    | {
        __typename?: 'Image'
        id: string
        type: ComponentType
        url?: string | null
        alt?: string | null
        mergeFieldId?: string | null
        styles?: any | null
        mobileStyles?: any | null
      }
    | {
        __typename?: 'Leaderboard'
        id: string
        type: ComponentType
        subComponents?: any | null
        styles?: any | null
        mobileStyles?: any | null
      }
    | {
        __typename?: 'LoginForm'
        id: string
        type: ComponentType
        subComponents?: any | null
        styles?: any | null
        mobileStyles?: any | null
      }
    | {
        __typename?: 'PageOptions'
        id: string
        type: ComponentType
        styles?: any | null
        mobileStyles?: any | null
        siteTitle?: string | null
        faviconUrl?: string | null
      }
    | {
        __typename?: 'PostDonationForm'
        id: string
        type: ComponentType
        buttonText: string
        subComponents?: any | null
        styles?: any | null
        mobileStyles?: any | null
        extraFields: Array<{
          __typename?: 'ExtraField'
          type: ExtraFieldType
          name: string
          label: string
          isRequired: boolean
          isHidden?: boolean | null
          order?: number | null
          defaultValue?: string | null
          placeholder?: string | null
          conditionalFields?: Array<{
            __typename?: 'ExtraField'
            type: ExtraFieldType
            name: string
            label: string
            isRequired: boolean
            isHidden?: boolean | null
            order?: number | null
            defaultValue?: string | null
            placeholder?: string | null
            customField?: {
              __typename?: 'CustomField'
              id: string
              name: string
              elementType: CustomFieldElementType
              fieldDescription?: string | null
              acceptedValues?: Array<{ __typename?: 'CustomFieldValue'; key: string; value: string }> | null
            } | null
          }> | null
          customField?: {
            __typename?: 'CustomField'
            id: string
            name: string
            elementType: CustomFieldElementType
            fieldDescription?: string | null
            acceptedValues?: Array<{ __typename?: 'CustomFieldValue'; key: string; value: string }> | null
          } | null
        }>
      }
    | {
        __typename?: 'ProgressBar'
        id: string
        type: ComponentType
        goals?: Array<number> | null
        start?: any | null
        end?: any | null
        title?: string | null
        hideOnEnd?: boolean | null
        hideBeforeStart?: boolean | null
        hideOnGoalReached?: boolean | null
        styles?: any | null
        mobileStyles?: any | null
        isAllPagesLinked?: boolean | null
        linkedPageIds?: Array<string> | null
        offset?: number | null
        bonusGoals?: Array<{
          __typename?: 'BonusGoal'
          text?: { __typename?: 'Text'; textValue: string; htmlText?: string | null } | null
        }> | null
        text?: { __typename?: 'Text'; textValue: string; htmlText?: string | null } | null
      }
    | {
        __typename?: 'ProgressImage'
        id: string
        type: ComponentType
        styles?: any | null
        mobileStyles?: any | null
        subComponents?: any | null
      }
    | {
        __typename?: 'RegisterForm'
        id: string
        type: ComponentType
        subComponents?: any | null
        styles?: any | null
        mobileStyles?: any | null
      }
    | { __typename?: 'Row'; id: string; type: ComponentType; styles?: any | null; mobileStyles?: any | null }
    | {
        __typename?: 'SocialShare'
        id: string
        type: ComponentType
        hasLink?: boolean | null
        hasTwitter?: boolean | null
        hasFacebook?: boolean | null
        hasEmail?: boolean | null
        hasWhatsApp?: boolean | null
        hasLinkedIn?: boolean | null
        styles?: any | null
        mobileStyles?: any | null
      }
    | {
        __typename?: 'Text'
        id: string
        type: ComponentType
        textValue: string
        htmlText?: string | null
        styles?: any | null
        mobileStyles?: any | null
      }
    | {
        __typename?: 'Video'
        id: string
        type: ComponentType
        styles?: any | null
        mobileStyles?: any | null
        url?: string | null
        title?: string | null
      }
    | {
        __typename?: 'VirtualGiftSection'
        id: string
        type: ComponentType
        styles?: any | null
        mobileStyles?: any | null
        subComponents?: any | null
      }
  >
  desktop: Array<{
    __typename?: 'OrderComponent'
    id: string
    childComponents?: Array<{
      __typename?: 'OrderComponent'
      id: string
      childComponents?: Array<{ __typename?: 'OrderComponent'; id: string }> | null
    }> | null
  }>
  mobile?: Array<{
    __typename?: 'OrderComponent'
    id: string
    childComponents?: Array<{
      __typename?: 'OrderComponent'
      id: string
      childComponents?: Array<{ __typename?: 'OrderComponent'; id: string }> | null
    }> | null
  }> | null
} & { ' $fragmentName'?: 'EditorPageLayoutFragment' }

export type SaveDraftMutationVariables = Exact<{
  saveDraftInput: SaveDraftInput
}>

export type SaveDraftMutation = { __typename?: 'Mutation'; saveDraft: { __typename?: 'PageResponse'; id: string } }

export type PublishPageMutationVariables = Exact<{
  publishPageInput: PublishPageInput
}>

export type PublishPageMutation = {
  __typename?: 'Mutation'
  publishPage: Array<{
    __typename?: 'PageDetail'
    id: string
    type?: PageType | null
    status: PageStatusType
    slug?: string | null
    index: number
    pageBucketId?: string | null
  }>
}

export type CreatePageMutationVariables = Exact<{
  createPageInput: CreatePageInput
}>

export type CreatePageMutation = { __typename?: 'Mutation'; createPage: { __typename?: 'PageResponse'; id: string } }

export type CreatePageStateMutationVariables = Exact<{
  createPageStateInput: CreatePageStateInput
}>

export type CreatePageStateMutation = {
  __typename?: 'Mutation'
  createPageState: { __typename?: 'PageResponse'; id: string }
}

export type DuplicatePageMutationVariables = Exact<{
  duplicatePageInput: DuplicatePageInput
}>

export type DuplicatePageMutation = {
  __typename?: 'Mutation'
  duplicatePage: { __typename?: 'PageResponse'; id: string }
}

export type DuplicatePageStateMutationVariables = Exact<{
  duplicatePageStateInput: DuplicatePageStateInput
}>

export type DuplicatePageStateMutation = {
  __typename?: 'Mutation'
  duplicatePageState: { __typename?: 'PageResponse'; id: string }
}

export type DeletePageMutationVariables = Exact<{
  deletePageInput: DeletePageInput
}>

export type DeletePageMutation = { __typename?: 'Mutation'; deletePage: string }

export type MergeFieldsQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>
}>

export type MergeFieldsQuery = {
  __typename?: 'Query'
  mergeFields: Array<{ __typename?: 'MergeField'; id: string; name: string; tag: string }>
}

export type CustomFieldSettingsQueryVariables = Exact<{ [key: string]: never }>

export type CustomFieldSettingsQuery = {
  __typename?: 'Query'
  customFieldSettings: Array<{
    __typename?: 'CustomFieldSetting'
    id: string
    name: string
    description?: string | null
    type: CustomFieldType
    elementType: CustomFieldElementType
    defaultValue?: string | null
    acceptedValues?: Array<{ __typename?: 'CustomFieldValue'; key: string; value: string }> | null
  }>
}

export type SaveDetailsMutationVariables = Exact<{
  saveDetailsInput: SaveDetailsInput
}>

export type SaveDetailsMutation = { __typename?: 'Mutation'; saveDetails: { __typename?: 'PageResponse'; id: string } }

export type SavePageBucketDetailsMutationVariables = Exact<{
  campaignId: Scalars['ID']['input']
  pageBucketId: Scalars['ID']['input']
  name?: InputMaybe<Scalars['String']['input']>
}>

export type SavePageBucketDetailsMutation = { __typename?: 'Mutation'; savePageBucketDetails?: boolean | null }

export type FormDataQueryVariables = Exact<{
  formId: Scalars['ID']['input']
}>

export type FormDataQuery = {
  __typename?: 'Query'
  formData: {
    __typename?: 'FormDataQueryResult'
    headers: Array<string>
    formData: Array<{
      __typename?: 'FormData'
      id: string
      formId: string
      formValues: Array<{ __typename?: 'FormValue'; name?: string | null; values?: Array<string | null> | null }>
    }>
  }
}

export type GivingsQueryVariables = Exact<{
  input: GivingsQueryInput
}>

export type GivingsQuery = {
  __typename?: 'Query'
  givings: {
    __typename?: 'GivingsQueryResult'
    totalRecords: number
    items: Array<{
      __typename?: 'Giving'
      givingId: string
      donatedAmount: number
      refundedAmount: number
      currencyCode: string
      donorPaysAmount?: number | null
      platformFeesAmount?: number | null
      createdAt: any
      transactionId?: string | null
      paymentMethodType: PaymentMethodType
      status: GivingStatus
      donationFrequency: GivingDonationFrequency
      stripe?: { __typename?: 'GivingStripeTransactionDetail'; paymentIntentId?: string | null } | null
      paypal?: { __typename?: 'GivingPaypalTransactionDetail'; orderId: string; captureId?: string | null } | null
      donor?: {
        __typename?: 'GivingDonorDetail'
        donationFormFirstName?: string | null
        donationFormLastName?: string | null
        externalFirstName?: string | null
        externalLastName?: string | null
        fullName?: string | null
        email?: string | null
      } | null
      page: { __typename?: 'GivingPageDetail'; pageId: string; pageName?: string | null }
      campaign: { __typename?: 'GivingCampaignDetail'; campaignId: string; campaignTitle?: string | null }
      comment?: { __typename?: 'GivingCommentDetail'; commentId: string; message?: string | null } | null
    }>
  }
}

export type ResendReceiptMutationVariables = Exact<{
  input: ResendReceiptInput
}>

export type ResendReceiptMutation = { __typename?: 'Mutation'; resendReceipt?: string | null }

export type MatchedGivingRecordsQueryVariables = Exact<{
  pageSize: Scalars['Int']['input']
  pageNumber: Scalars['Int']['input']
  mode: Mode
}>

export type MatchedGivingRecordsQuery = {
  __typename?: 'Query'
  matchedGivingRecords: {
    __typename?: 'MatchedGivingQueryResult'
    totalRecords: number
    items: Array<{
      __typename?: 'MatchedGivingRecord'
      createdAt: any
      matchedGivingSettingName: string
      givingAmount: number
      matchedDonationAmount: number
      matchedAmount: number
      multiplier: number
      totalAmount: number
      donorEmail: string
      donorName: string
      campaignTitle: string
      pageName: string
      matchedGivingId: string
      givingId: string
    }>
  }
}

export type MediaLibraryAssetsQueryVariables = Exact<{
  input?: InputMaybe<MediaLibraryAssetsInput>
}>

export type MediaLibraryAssetsQuery = {
  __typename?: 'Query'
  mediaLibraryAssets: {
    __typename?: 'MediaLibraryAssetsResult'
    totalCount: number
    items: Array<{
      __typename?: 'MediaLibraryAsset'
      id: string
      name: string
      title?: string | null
      description?: string | null
      altText?: string | null
      sizeInBytes?: number | null
      uploadedAt: any
      uploadedBy?: string | null
      url: string
    }>
  }
}

export type UpdateMediaLibraryAssetMutationVariables = Exact<{
  input: UpdateMediaLibraryAssetInput
}>

export type UpdateMediaLibraryAssetMutation = { __typename?: 'Mutation'; updateMediaLibraryAsset: boolean }

export type DeleteMediaLibraryAssetMutationVariables = Exact<{
  assetId: Scalars['ID']['input']
}>

export type DeleteMediaLibraryAssetMutation = { __typename?: 'Mutation'; deleteMediaLibraryAsset: boolean }

export type PayoutTransactionsQueryVariables = Exact<{
  payoutId: Scalars['ID']['input']
}>

export type PayoutTransactionsQuery = {
  __typename?: 'Query'
  payoutTransactions: Array<{
    __typename?: 'PaymentTransaction'
    givingId: string
    createdAt: any
    netPaymentTransactionAmount: number
    transactionExternalData: {
      __typename?: 'TransactionExternalData'
      stripeData?: { __typename?: 'StripeTransactionExternalData'; paymentIntentId: string } | null
    }
    paymentTransaction?: {
      __typename?: 'PaymentTransactionDetail'
      transactionAmount: number
      donationFormAmount: number
      charityTipAmount?: number | null
      transactionFees: {
        __typename?: 'TransactionFees'
        totalFee: number
        platformFee?: number | null
        internalManagedAdminFee?: number | null
        paymentGatewayFee?: number | null
        totalTax?: number | null
      }
    } | null
    refundTransaction?: {
      __typename?: 'RefundTransactionDetail'
      transactionAmount: number
      donationFormAmount: number
    } | null
    applicationFeeTransaction?: {
      __typename?: 'ApplicationFeeRefundTransactionDetail'
      applicationFeeAmount: number
    } | null
  }>
  payout: {
    __typename?: 'Payout'
    id: string
    transferAmount: number
    payoutDate: any
    startAt: any
    endAt: any
    paymentTransaction?: {
      __typename?: 'PaymentTransactionDetail'
      transactionAmount: number
      donationFormAmount: number
      transactionFees: {
        __typename?: 'TransactionFees'
        totalFee: number
        platformFee?: number | null
        internalManagedAdminFee?: number | null
        paymentGatewayFee?: number | null
        totalTax?: number | null
      }
    } | null
    refundTransaction?: {
      __typename?: 'RefundTransactionDetail'
      transactionAmount: number
      donationFormAmount: number
    } | null
    applicationFeeTransaction?: {
      __typename?: 'ApplicationFeeRefundTransactionDetail'
      applicationFeeAmount: number
    } | null
  }
}

export type PayoutsQueryVariables = Exact<{
  pageNumber: Scalars['Int']['input']
  pageSize: Scalars['Int']['input']
  mode: Mode
  paymentProviderId?: InputMaybe<Scalars['ID']['input']>
}>

export type PayoutsQuery = {
  __typename?: 'Query'
  payouts: {
    __typename?: 'PayoutQueryResult'
    totalRecords: number
    items: Array<{
      __typename?: 'Payout'
      id: string
      transferAmount: number
      payoutDate: any
      startAt: any
      endAt: any
      status?: PayoutStatus | null
      paymentTransaction?: {
        __typename?: 'PaymentTransactionDetail'
        transactionAmount: number
        donationFormAmount: number
        transactionFees: {
          __typename?: 'TransactionFees'
          totalFee: number
          platformFee?: number | null
          internalManagedAdminFee?: number | null
          paymentGatewayFee?: number | null
          totalTax?: number | null
        }
      } | null
      refundTransaction?: {
        __typename?: 'RefundTransactionDetail'
        transactionAmount: number
        donationFormAmount: number
      } | null
      applicationFeeTransaction?: {
        __typename?: 'ApplicationFeeRefundTransactionDetail'
        applicationFeeAmount: number
      } | null
    }>
  }
}

export type UnpaidTransactionsQueryVariables = Exact<{
  mode: Mode
  paymentProviderId?: InputMaybe<Scalars['ID']['input']>
}>

export type UnpaidTransactionsQuery = {
  __typename?: 'Query'
  unpaidTransactions: Array<{
    __typename?: 'PaymentTransaction'
    givingId: string
    createdAt: any
    netPaymentTransactionAmount: number
    transactionExternalData: {
      __typename?: 'TransactionExternalData'
      stripeData?: { __typename?: 'StripeTransactionExternalData'; paymentIntentId: string } | null
    }
    paymentTransaction?: {
      __typename?: 'PaymentTransactionDetail'
      transactionAmount: number
      donationFormAmount: number
      charityTipAmount?: number | null
      transactionFees: {
        __typename?: 'TransactionFees'
        totalFee: number
        platformFee?: number | null
        internalManagedAdminFee?: number | null
        paymentGatewayFee?: number | null
        totalTax?: number | null
      }
    } | null
    refundTransaction?: {
      __typename?: 'RefundTransactionDetail'
      transactionAmount: number
      donationFormAmount: number
    } | null
    applicationFeeTransaction?: {
      __typename?: 'ApplicationFeeRefundTransactionDetail'
      applicationFeeAmount: number
    } | null
  }>
}

export type UnpaidBalanceQueryVariables = Exact<{
  mode: Mode
  paymentProviderId?: InputMaybe<Scalars['ID']['input']>
}>

export type UnpaidBalanceQuery = {
  __typename?: 'Query'
  unpaidBalance: { __typename?: 'Balance'; count: number; totalAmount: number }
}

export type CharityAnalyticsSettingsQueryVariables = Exact<{ [key: string]: never }>

export type CharityAnalyticsSettingsQuery = {
  __typename?: 'Query'
  analyticsIntegrationSettings: {
    __typename?: 'AnalyticsIntegrationSettings'
    pixelConversionsApiSettings: Array<{
      __typename?: 'PixelConversionsApiIntegrationSetting'
      settingId: string
      name: string
    }>
    gtmSettings: Array<{ __typename?: 'GtmIntegrationSetting'; settingId: string; name: string }>
    ga4Settings: Array<{ __typename?: 'Ga4IntegrationSetting'; settingId: string; name: string }>
  }
}

export type CampaignAnalyticsSettingsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input']
}>

export type CampaignAnalyticsSettingsQuery = {
  __typename?: 'Query'
  campaignAnalyticsSettings: {
    __typename?: 'CampaignAnalyticsSettings'
    pixelConversionsApi?: {
      __typename?: 'CampaignPixelSetting'
      pixelSettingId?: string | null
      isDisabled?: boolean | null
    } | null
    gtm?: { __typename?: 'CamaignGtmSetting'; gtmSettingId?: string | null; isDisabled?: boolean | null } | null
    ga4?: { __typename?: 'CamaignGa4Setting'; ga4SettingId?: string | null; isDisabled?: boolean | null } | null
  }
}

export type SetCampaignAnalyticsSettingsMutationVariables = Exact<{
  input: CampaignAnalyticsSettingsInput
}>

export type SetCampaignAnalyticsSettingsMutation = { __typename?: 'Mutation'; setCampaignAnalyticsSettings: string }

export type SetEmailSettingsMutationVariables = Exact<{
  input: SetCampaignEmailSettingInput
}>

export type SetEmailSettingsMutation = { __typename?: 'Mutation'; setEmailSettings: boolean }

export type ProfilesQueryVariables = Exact<{
  campaignId: Scalars['ID']['input']
  isLiveMode: Scalars['Boolean']['input']
  orderBy: ProfileQueryOrderType
  isApprovedOnly?: InputMaybe<Scalars['Boolean']['input']>
}>

export type ProfilesQuery = {
  __typename?: 'Query'
  profiles: Array<{
    __typename?: 'ProfileData'
    id: string
    name: string
    logoUrl?: string | null
    description?: string | null
    goal?: number | null
    progressAmount?: number | null
    profileUrl?: string | null
    status?: ProfileStatus | null
    category?: string | null
    isGivingNotificationEnabled?: boolean | null
    owner?: { __typename?: 'ProfileOwnerData'; firstName: string; lastName: string; email: string } | null
  }>
}

export type UpdateProfileAdminMutationVariables = Exact<{
  input: UpdateProfileInput
}>

export type UpdateProfileAdminMutation = { __typename?: 'Mutation'; updateProfileAdmin: boolean }

export type SetCampaignPlatformFeeTypeMutationVariables = Exact<{
  input: SetCampaignPlatformFeeTypeInput
}>

export type SetCampaignPlatformFeeTypeMutation = { __typename?: 'Mutation'; setCampaignPlatformFeeType?: string | null }

export type SetCampaignStripeSettingsMutationVariables = Exact<{
  input: SetCampaignPaymentProviderSettingsInput
}>

export type SetCampaignStripeSettingsMutation = {
  __typename?: 'Mutation'
  setCampaignStripeSettings: { __typename?: 'SetCampaignPaymentProviderSettingsResponse'; campaignId: string }
}

export type SetCampaignPayPalSettingsMutationVariables = Exact<{
  input: SetCampaignPaymentProviderSettingsInput
}>

export type SetCampaignPayPalSettingsMutation = {
  __typename?: 'Mutation'
  setCampaignPayPalSettings: { __typename?: 'SetCampaignPaymentProviderSettingsResponse'; campaignId: string }
}

export type SetFundraiserRegistrationNotificationsForProfileMutationVariables = Exact<{
  input: SetFundraiserRegistrationNotificationsForProfileInput
}>

export type SetFundraiserRegistrationNotificationsForProfileMutation = {
  __typename?: 'Mutation'
  setFundraiserRegistrationNotificationsForProfile: boolean
}

export type CreateProfileCategoryMutationVariables = Exact<{
  input: CreateProfileCategoryInput
}>

export type CreateProfileCategoryMutation = { __typename?: 'Mutation'; createProfileCategory: string }

export type ToggleWelcomeEmailForProfileMutationVariables = Exact<{
  campaignId: Scalars['ID']['input']
  isEnabled: Scalars['Boolean']['input']
}>

export type ToggleWelcomeEmailForProfileMutation = { __typename?: 'Mutation'; toggleWelcomeEmailForProfile: boolean }

export type ToggleDonationNotificationForProfileMutationVariables = Exact<{
  campaignId: Scalars['ID']['input']
  isEnabled: Scalars['Boolean']['input']
}>

export type ToggleDonationNotificationForProfileMutation = {
  __typename?: 'Mutation'
  toggleDonationNotificationForProfile: boolean
}

export type SetEmailReceiptSettingMutationVariables = Exact<{
  input: SetEmailSettingItemInput
}>

export type SetEmailReceiptSettingMutation = { __typename?: 'Mutation'; setEmailReceiptSetting: boolean }

export type CampaignTriggersQueryVariables = Exact<{
  campaignId: Scalars['ID']['input']
  pageBucketId: Scalars['ID']['input']
}>

export type CampaignTriggersQuery = {
  __typename?: 'Query'
  campaignTriggers?: {
    __typename?: 'CampaignTrigger'
    campaignTriggerId?: string | null
    dateTimeTriggers: Array<{
      __typename?: 'DateTimeTrigger'
      dateTimeStart: any
      pageId: string
      amountTriggers: Array<{ __typename?: 'AmountTrigger'; amountStart: number; pageId: string }>
    }>
  } | null
}

export type SetCampaignTriggersMutationVariables = Exact<{
  input: CampaignTriggerInput
}>

export type SetCampaignTriggersMutation = { __typename?: 'Mutation'; setCampaignTriggers?: string | null }

export type AddCampaignDomainMutationVariables = Exact<{
  addCampaignDomainInput: AddCampaignDomainInput
}>

export type AddCampaignDomainMutation = { __typename?: 'Mutation'; addCampaignDomain: string }

export type AddPageSlugsForCampaignMutationVariables = Exact<{
  addPageSlugsForCampaignInput: AddPageSlugsForCampaignInput
}>

export type AddPageSlugsForCampaignMutation = {
  __typename?: 'Mutation'
  addPageSlugsForCampaign?: Array<string> | null
}

export type AddPageBucketSlugsForCampaignMutationVariables = Exact<{
  addPageBucketSlugsForCampaignInput: AddPageBucketSlugsForCampaignInput
}>

export type AddPageBucketSlugsForCampaignMutation = {
  __typename?: 'Mutation'
  addPageBucketSlugsForCampaign?: Array<string> | null
}

export type SetDefaultCampaignPageMutationVariables = Exact<{
  input: SetDefaultCampaignPageInput
}>

export type SetDefaultCampaignPageMutation = { __typename?: 'Mutation'; setDefaultCampaignPage: boolean }

export type SetCommentAggregationSettingMutationVariables = Exact<{
  campaignId: Scalars['ID']['input']
  input: Array<CommentAggregationSettingItemInput> | CommentAggregationSettingItemInput
}>

export type SetCommentAggregationSettingMutation = { __typename?: 'Mutation'; setCommentAggregationSetting: boolean }

export type SetCountdownTimerAggregationSettingMutationVariables = Exact<{
  campaignId: Scalars['ID']['input']
  input: Array<CountdownTimerAggregationSettingItemInput> | CountdownTimerAggregationSettingItemInput
}>

export type SetCountdownTimerAggregationSettingMutation = {
  __typename?: 'Mutation'
  setCountdownTimerAggregationSetting: boolean
}

export type SetProgressBarAggregationSettingMutationVariables = Exact<{
  campaignId: Scalars['ID']['input']
  input: Array<ProgressBarAggregationSettingItemInput> | ProgressBarAggregationSettingItemInput
}>

export type SetProgressBarAggregationSettingMutation = {
  __typename?: 'Mutation'
  setProgressBarAggregationSetting: boolean
}

export type AddCampaignMatchedGivingMutationVariables = Exact<{
  input: CampaignMatchedGivingSettingInput
}>

export type AddCampaignMatchedGivingMutation = {
  __typename?: 'Mutation'
  addCampaignMatchedGivingSetting: { __typename?: 'AddCampaignMatchedGivingSettingResult'; id: string }
}

export type SetMatchedGivingAggregationSettingMutationVariables = Exact<{
  campaignId: Scalars['ID']['input']
  input: Array<MatchedGivingAggregationSettingItemInput> | MatchedGivingAggregationSettingItemInput
}>

export type SetMatchedGivingAggregationSettingMutation = {
  __typename?: 'Mutation'
  setMatchedGivingAggregationSetting: boolean
}

export type MatchedGivingProgressQueryVariables = Exact<{
  campaignId: Scalars['ID']['input']
  matchedGivingId: Scalars['ID']['input']
  isLiveMode: Scalars['Boolean']['input']
}>

export type MatchedGivingProgressQuery = {
  __typename?: 'Query'
  matchedGivingProgress: { __typename?: 'MatchedGivingProgressResult'; amount: number }
}

export type CampaignPageMetadataQueryVariables = Exact<{
  campaignId: Scalars['ID']['input']
  pageId: Scalars['ID']['input']
}>

export type CampaignPageMetadataQuery = {
  __typename?: 'Query'
  campaignPageMetadata?: {
    __typename?: 'PageMetadata'
    OgTitle?: string | null
    OgDescription?: string | null
    OgImage?: string | null
  } | null
}

export type SavePageMetadataMutationVariables = Exact<{
  input: SavePageMetadataInput
}>

export type SavePageMetadataMutation = { __typename?: 'Mutation'; savePageMetadata?: boolean | null }

export type CharityPaymentSettingsQueryVariables = Exact<{ [key: string]: never }>

export type CharityPaymentSettingsQuery = {
  __typename?: 'Query'
  charityPaymentSettings: {
    __typename?: 'CharityPaymentSettings'
    stripe?: Array<{
      __typename?: 'CharityStripeSettings'
      id: string
      label?: string | null
      accountId: string
      providerType?: PaymentProviderType | null
    }> | null
    payPal?: Array<{
      __typename?: 'CharityPayPalSettings'
      id: string
      label?: string | null
      merchantEmail?: string | null
      providerType?: PaymentProviderType | null
    }> | null
    offline?: Array<{
      __typename?: 'CharityOfflineSettings'
      id: string
      label?: string | null
      accountId: string
      providerType?: PaymentProviderType | null
    }> | null
  }
}

export type SubscriptionsQueryVariables = Exact<{
  input: SubscriptionsQueryInput
}>

export type SubscriptionsQuery = {
  __typename?: 'Query'
  subscriptions: {
    __typename?: 'SubscriptionsQueryResult'
    totalRecords: number
    items: Array<{
      __typename?: 'SubscriptionRecord'
      subscriptionId: string
      firstName?: string | null
      lastName?: string | null
      email: string
      donationFormAmount: number
      transactionAmount: number
      externalSubscriptionId: string
      paymentMethodType: PaymentMethodType
      startAt: any
      endAt?: any | null
      totalGivingTransactionAmount: number
      donationFrequencyType: GivingDonationFrequency
      status: SubscriptionStatus
      page: string
      campaign: string
      subscriptionStartAt: any
      resumeAt?: any | null
      nextPaymentDate?: any | null
      lastInvoice?: {
        __typename?: 'SubscriptionInvoice'
        invoiceDate: any
        invoiceStatus: SubscriptionInvoiceStatus
      } | null
      lastGiving?: { __typename?: 'SubscriptionRegularGiving'; givingDate: any; givingStatus: GivingStatus } | null
      scheduledUpdate?: {
        __typename?: 'SubscriptionScheduledUpdate'
        subscriptionScheduleId: string
        externalSubscriptionScheduleId: string
        startAt?: any | null
        amount?: number | null
        donationFrequencyType?: GivingDonationFrequency | null
      } | null
    }>
  }
}

export type UpdateSubscriptionAdminMutationVariables = Exact<{
  input: UpdateSubscriptionAdminInput
}>

export type UpdateSubscriptionAdminMutation = {
  __typename?: 'Mutation'
  updateSubscriptionAdmin?: {
    __typename?: 'UpdateSubscriptionAdminResponse'
    externalSubscriptionScheduleId?: string | null
    paymentSubscriptionScheduleId?: string | null
  } | null
}

export type CancelSubscriptionMutationVariables = Exact<{
  input: CancelSubscriptionInput
}>

export type CancelSubscriptionMutation = { __typename?: 'Mutation'; cancelSubscription?: boolean | null }

export type PauseSubscriptionMutationVariables = Exact<{
  input: PauseSubscriptionInput
}>

export type PauseSubscriptionMutation = { __typename?: 'Mutation'; pauseSubscription?: boolean | null }

export type ResumeSubscriptionMutationVariables = Exact<{
  input: ResumeSubscriptionInput
}>

export type ResumeSubscriptionMutation = { __typename?: 'Mutation'; resumeSubscription?: SubscriptionStatus | null }

export type CreateStripeSubscriptionDonorPortalLinkMutationVariables = Exact<{
  input: StripeSubscriptionDonorPortalLinkInput
}>

export type CreateStripeSubscriptionDonorPortalLinkMutation = {
  __typename?: 'Mutation'
  createStripeSubscriptionDonorPortalLink: { __typename?: 'StripeSubscriptionDonorPortalLink'; url: string }
}

export type PaymentTransactionsQueryVariables = Exact<{
  pageSize: Scalars['Int']['input']
  pageNumber: Scalars['Int']['input']
  mode: Mode
  startDate: Scalars['String']['input']
  endDate: Scalars['String']['input']
  paymentProviderId?: InputMaybe<Scalars['ID']['input']>
}>

export type PaymentTransactionsQuery = {
  __typename?: 'Query'
  paymentTransactions: {
    __typename?: 'PaymentTransactionQueryResult'
    totalRecords: number
    items: Array<{
      __typename?: 'PaymentTransaction'
      givingId: string
      createdAt: any
      netPaymentTransactionAmount: number
      transactionExternalData: {
        __typename?: 'TransactionExternalData'
        stripeData?: { __typename?: 'StripeTransactionExternalData'; paymentIntentId: string } | null
        payPalData?: { __typename?: 'PayPalTransactionExternalData'; captureId: string } | null
        offlineData?: { __typename?: 'OfflineTransactionExternalData'; offlineTransactionId: string } | null
      }
      paymentTransaction?: {
        __typename?: 'PaymentTransactionDetail'
        transactionAmount: number
        donationFormAmount: number
        charityTipAmount?: number | null
        transactionFees: {
          __typename?: 'TransactionFees'
          totalFee: number
          platformFee?: number | null
          internalManagedAdminFee?: number | null
          paymentGatewayFee?: number | null
          totalTax?: number | null
        }
      } | null
      refundTransaction?: {
        __typename?: 'RefundTransactionDetail'
        transactionAmount: number
        donationFormAmount: number
      } | null
      applicationFeeTransaction?: {
        __typename?: 'ApplicationFeeRefundTransactionDetail'
        applicationFeeAmount: number
      } | null
    }>
  }
}

export type CampaignProgressBarAggregationSettingsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input']
}>

export type CampaignProgressBarAggregationSettingsQuery = {
  __typename?: 'Query'
  aggregationSettings: {
    __typename?: 'AggregationSettings'
    progressBarSetting?: {
      __typename?: 'ProgressBarAggregationSetting'
      groupSettings?: Array<{
        __typename?: 'ProgressBarAggregationSettingItem'
        groupName?: string | null
        startVisibleTime?: any | null
        endVisibleTime?: any | null
        isGoalHidden?: boolean | null
        offset?: number | null
        pageIds: Array<string>
        pageBucketIds?: Array<string> | null
        dataSources?: Array<string> | null
        isAllPagesLinked?: boolean | null
        hideWhenMatchedGivingActive?: boolean | null
        progressBarGoals?: Array<{ __typename?: 'ProgressBarGoal'; goal: number; index: number }> | null
      }> | null
    } | null
  }
}

export type CampaignCommentAggregationSettingsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input']
}>

export type CampaignCommentAggregationSettingsQuery = {
  __typename?: 'Query'
  aggregationSettings: {
    __typename?: 'AggregationSettings'
    commentSetting?: {
      __typename?: 'CommentAggregationSetting'
      groupSettings?: Array<{
        __typename?: 'CommentAggregationSettingItem'
        groupName?: string | null
        startVisibleTime?: any | null
        endVisibleTime?: any | null
        amountToShowOver?: number | null
        pageIds: Array<string>
        pageBucketIds?: Array<string> | null
        dataSources?: Array<string> | null
        isAllPagesLinked?: boolean | null
      }> | null
    } | null
  }
}

export type CampaignCountdownTimerAggregationSettingsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input']
}>

export type CampaignCountdownTimerAggregationSettingsQuery = {
  __typename?: 'Query'
  aggregationSettings: {
    __typename?: 'AggregationSettings'
    countdownTimerSetting?: {
      __typename?: 'CountdownTimerAggregationSetting'
      groupSettings?: Array<{
        __typename?: 'CountdownTimerAggregationSettingItem'
        groupName?: string | null
        finishTime?: any | null
        startVisibleTime?: any | null
        endVisibleTime?: any | null
        pageIds: Array<string>
        pageBucketIds?: Array<string> | null
        bonusFinishTimes?: Array<any> | null
      }> | null
    } | null
  }
}

export type CampaignPaymentSettingsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input']
}>

export type CampaignPaymentSettingsQuery = {
  __typename?: 'Query'
  campaignPaymentSettings: {
    __typename?: 'CampaignPaymentSettings'
    platformFeeType?: PlatformFeeType | null
    stripe?: { __typename?: 'CharityStripeSettings'; id: string; label?: string | null } | null
    paypal?: { __typename?: 'CharityPayPalSettings'; id: string; label?: string | null } | null
  }
}

export type CampaignMatchedGivingAggregationSettingsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input']
}>

export type CampaignMatchedGivingAggregationSettingsQuery = {
  __typename?: 'Query'
  aggregationSettings: {
    __typename?: 'AggregationSettings'
    matchedGivingSetting?: {
      __typename?: 'MatchedGivingAggregationSetting'
      groupSettings?: Array<{
        __typename?: 'MatchedGivingAggregationSettingItem'
        groupName?: string | null
        matchedGivingSettingIds: Array<string>
        pageIds: Array<string>
        pageBucketIds?: Array<string> | null
      }> | null
    } | null
  }
  campaignMatchedGivingSettings: Array<{
    __typename?: 'CampaignMatchedGivingSetting'
    id: string
    name: string
    startAt: string
    endAt?: string | null
    rounds: Array<{
      __typename?: 'CampaignMatchedGivingSettingItem'
      startFundRange: number
      endFundRange: number
      multiplier: number
    }>
  }>
}

export type FeatureFlagQueryVariables = Exact<{
  flags: Array<Scalars['String']['input']> | Scalars['String']['input']
}>

export type FeatureFlagQuery = { __typename?: 'Query'; featureFlag: any }

export type AuthenticateProfileMutationVariables = Exact<{
  charityId: Scalars['ID']['input']
  campaignId: Scalars['ID']['input']
  encodedToken: Scalars['String']['input']
}>

export type AuthenticateProfileMutation = {
  __typename?: 'Mutation'
  authenticateProfile: { __typename?: 'AuthenticateProfileResponse'; token: string; profileUrl: string }
}

export type LoginProfileMutationVariables = Exact<{
  charityId: Scalars['ID']['input']
  email: Scalars['String']['input']
  campaignId: Scalars['ID']['input']
}>

export type LoginProfileMutation = { __typename?: 'Mutation'; loginProfile: string }

export type ValidateTokenQueryVariables = Exact<{
  token: Scalars['String']['input']
  charityId: Scalars['ID']['input']
  profileId?: InputMaybe<Scalars['ID']['input']>
}>

export type ValidateTokenQuery = { __typename?: 'Query'; validateToken: boolean }

export type RegisterEmailMutationVariables = Exact<{
  charityId: Scalars['ID']['input']
  campaignId: Scalars['ID']['input']
  email: Scalars['String']['input']
}>

export type RegisterEmailMutation = {
  __typename?: 'Mutation'
  registerEmail: {
    __typename?: 'RegisterEmailResponse'
    token: string
    hasProfileInCampaign: boolean
    isExistingUser: boolean
  }
}

export type RegisterProfileMutationVariables = Exact<{
  token: Scalars['String']['input']
  input: RegisterProfileInput
}>

export type RegisterProfileMutation = {
  __typename?: 'Mutation'
  registerProfile: { __typename?: 'RegisterProfileResult'; profileId: string; redirectUrl: string }
}

export type UpdateProfileMutationVariables = Exact<{
  token: Scalars['String']['input']
  input: UpdateProfileInput
}>

export type UpdateProfileMutation = { __typename?: 'Mutation'; updateProfile: boolean }

export type CommentsQueryVariables = Exact<{
  query: CommentsQueryInput
}>

export type CommentsQuery = {
  __typename?: 'Query'
  comments: {
    __typename?: 'CommentsQueryResult'
    totalRecords: number
    comments: Array<{
      __typename?: 'Comment'
      id: string
      message?: string | null
      amount: number
      donatedBy: string
      donatedAt: any
      matchedAmount?: number | null
      matchedDonationAmount?: number | null
      dedicateeName?: string | null
      organisationName?: string | null
      donatedTo?: { __typename?: 'DonatedTo'; name: string; slug: string } | null
    }>
  }
}

export type PostCommentMutationVariables = Exact<{
  input: CommentInput
}>

export type PostCommentMutation = { __typename?: 'Mutation'; postComment: boolean }

export type CreateOrderMutationVariables = Exact<{
  input: CreateOrderInput
}>

export type CreateOrderMutation = {
  __typename?: 'Mutation'
  createOrder: { __typename?: 'CreateOrderResponse'; id?: string | null; aggregateId: string }
}

export type ProfileCategoriesQueryVariables = Exact<{
  campaignId: Scalars['ID']['input']
}>

export type ProfileCategoriesQuery = {
  __typename?: 'Query'
  profileCategories: Array<{ __typename?: 'ProfileCategory'; id: string; name: string }>
}

export type CreatePaymentIntentMutationVariables = Exact<{
  input: CreatePaymentIntentInput
}>

export type CreatePaymentIntentMutation = {
  __typename?: 'Mutation'
  createPaymentIntent: {
    __typename?: 'CreatePaymentIntentResponse'
    clientSecret: string
    paymentTransactionId: string
    paymentIntentId?: string | null
  }
}

export type CreateSubscriptionMutationVariables = Exact<{
  input: CreateSubscriptionInput
}>

export type CreateSubscriptionMutation = {
  __typename?: 'Mutation'
  createSubscription: {
    __typename?: 'CreateSubscriptionResponse'
    clientSecret: string
    subscriptionId: string
    paymentSubscriptionId: string
  }
}

export type UpdatePaymentIntentMutationVariables = Exact<{
  input: UpdatePaymentInput
}>

export type UpdatePaymentIntentMutation = {
  __typename?: 'Mutation'
  updatePaymentIntent: {
    __typename?: 'UpdatePaymentIntentResponse'
    clientSecret?: string | null
    paymentIntentId?: string | null
  }
}

export type UpdateSubscriptionMutationVariables = Exact<{
  input: UpdatePaymentInput
}>

export type UpdateSubscriptionMutation = {
  __typename?: 'Mutation'
  updateSubscription: {
    __typename?: 'UpdateSubscriptionResponse'
    clientSecret?: string | null
    subscriptionId?: string | null
  }
}

export type UpdatePaymentIntentDetailsMutationVariables = Exact<{
  input: UpdatePaymentDetailsInput
}>

export type UpdatePaymentIntentDetailsMutation = {
  __typename?: 'Mutation'
  updatePaymentIntentDetails: {
    __typename?: 'UpdatePaymentIntentResponse'
    paymentIntentId?: string | null
    clientSecret?: string | null
  }
}

export type UpdateSubscriptionDetailsMutationVariables = Exact<{
  input: UpdatePaymentDetailsInput
}>

export type UpdateSubscriptionDetailsMutation = {
  __typename?: 'Mutation'
  updateSubscriptionDetails: {
    __typename?: 'UpdateSubscriptionResponse'
    subscriptionId?: string | null
    clientSecret?: string | null
  }
}

export type PageQueryVariables = Exact<{
  pageId: Scalars['ID']['input']
  campaignId?: InputMaybe<Scalars['ID']['input']>
  profileId?: InputMaybe<Scalars['ID']['input']>
}>

export type PageQuery = {
  __typename?: 'Query'
  page: { __typename?: 'Page' } & { ' $fragmentRefs'?: { DonationPageLayoutFragment: DonationPageLayoutFragment } }
}

export type CampaignLandingPageIdQueryVariables = Exact<{
  campaignId: Scalars['ID']['input']
  isLiveMode: Scalars['Boolean']['input']
  pageBucketId: Scalars['ID']['input']
}>

export type CampaignLandingPageIdQuery = { __typename?: 'Query'; campaignLandingPageId?: string | null }

export type SearchBySlugQueryVariables = Exact<{
  url: Scalars['String']['input']
  isLiveMode: Scalars['Boolean']['input']
}>

export type SearchBySlugQuery = {
  __typename?: 'Query'
  searchBySlug: {
    __typename?: 'SlugResponse'
    charityId: string
    campaignId: string
    pageId?: string | null
    pageBucketId?: string | null
    profileId?: string | null
    redirectUrl?: string | null
    profileData?: { __typename?: 'ProfileData'; name: string; goal?: number | null; logoUrl?: string | null } | null
    campaignSettings?: {
      __typename?: 'CampaignSettings'
      campaignDomain?: string | null
      isPeerToPeerGivingNotificationEnabled?: boolean | null
    } | null
    layout: { __typename?: 'Page' } & { ' $fragmentRefs'?: { DonationPageLayoutFragment: DonationPageLayoutFragment } }
  }
}

export type DonationPageLayoutFragment = {
  __typename?: 'Page'
  id: string
  branding?: string | null
  header?: {
    __typename?: 'Header'
    id: string
    type: ComponentType
    hasDonateButton: boolean
    styles?: any | null
    mobileStyles?: any | null
  } | null
  footer?: {
    __typename?: 'Footer'
    id: string
    type: ComponentType
    taxDeductibleText?: string | null
    keyInformationText?: string | null
    styles?: any | null
    mobileStyles?: any | null
  } | null
  components: Array<
    | {
        __typename?: 'Button'
        id: string
        type: ComponentType
        buttonText: string
        url?: string | null
        target?: string | null
        buttonType: string
        styles?: any | null
        mobileStyles?: any | null
      }
    | { __typename?: 'Column'; id: string; type: ComponentType; styles?: any | null; mobileStyles?: any | null }
    | {
        __typename?: 'Comments'
        id: string
        type: ComponentType
        showAmount: boolean
        showMessage: boolean
        showTotal: boolean
        showViewAll: boolean
        layout: CommentsLayout
        styles?: any | null
        mobileStyles?: any | null
        start?: any | null
        end?: any | null
        hideBeforeStart?: boolean | null
        hideOnEnd?: boolean | null
        isAllPagesLinked?: boolean | null
        linkedPageIds?: Array<string> | null
        amountToShowOver?: number | null
      }
    | {
        __typename?: 'CountdownTimer'
        id: string
        type: ComponentType
        start?: any | null
        end?: any | null
        hideOnEnd?: boolean | null
        hideBeforeStart?: boolean | null
        finish?: any | null
        styles?: any | null
        mobileStyles?: any | null
        bonusFinishTimes?: Array<any> | null
      }
    | {
        __typename?: 'DollarHandles'
        id: string
        type: ComponentType
        styles?: any | null
        mobileStyles?: any | null
        dollarHandles: Array<{
          __typename?: 'DollarHandle'
          amount: number
          description?: string | null
          imageUrl?: string | null
          hasImage?: boolean | null
          hasDescription?: boolean | null
        }>
      }
    | {
        __typename?: 'DonationForm'
        id: string
        type: ComponentType
        title?: string | null
        donationFrequency: Array<DonationFrequency>
        donationFrequencyDefault?: number | null
        dollarHandlesDefault?: number | null
        legalUrl?: string | null
        styles?: any | null
        mobileStyles?: any | null
        minimumAmount?: number | null
        matchedGivings?: Array<{
          __typename?: 'CampaignMatchedGivingSetting'
          id: string
          startAt: string
          endAt?: string | null
          rounds: Array<{ __typename?: 'CampaignMatchedGivingSettingItem'; endFundRange: number; multiplier: number }>
        }> | null
        dollarHandles: Array<{
          __typename?: 'DollarHandle'
          amount: number
          description?: string | null
          imageUrl?: string | null
          isPersonalised?: boolean | null
          hasImage?: boolean | null
          hasDescription?: boolean | null
        }>
        extraFields: Array<{
          __typename?: 'ExtraField'
          type: ExtraFieldType
          name: string
          label: string
          isRequired: boolean
          order?: number | null
          defaultValue?: string | null
          placeholder?: string | null
          conditionalFields?: Array<{
            __typename?: 'ExtraField'
            type: ExtraFieldType
            name: string
            label: string
            isRequired: boolean
            order?: number | null
            defaultValue?: string | null
            placeholder?: string | null
            customField?: {
              __typename?: 'CustomField'
              id: string
              name: string
              elementType: CustomFieldElementType
              fieldDescription?: string | null
              acceptedValues?: Array<{ __typename?: 'CustomFieldValue'; key: string; value: string }> | null
            } | null
          }> | null
          customField?: {
            __typename?: 'CustomField'
            id: string
            name: string
            elementType: CustomFieldElementType
            fieldDescription?: string | null
            acceptedValues?: Array<{ __typename?: 'CustomFieldValue'; key: string; value: string }> | null
          } | null
        }>
      }
    | { __typename?: 'Empty'; id: string; type: ComponentType; styles?: any | null; mobileStyles?: any | null }
    | { __typename?: 'Footer'; id: string; type: ComponentType }
    | { __typename?: 'FundraiserButton'; id: string; type: ComponentType }
    | {
        __typename?: 'FundraiserProfile'
        id: string
        type: ComponentType
        subComponents?: any | null
        styles?: any | null
        mobileStyles?: any | null
      }
    | { __typename?: 'Header'; id: string; type: ComponentType }
    | {
        __typename?: 'Image'
        id: string
        type: ComponentType
        url?: string | null
        alt?: string | null
        mergeFieldId?: string | null
        styles?: any | null
        mobileStyles?: any | null
      }
    | {
        __typename?: 'Leaderboard'
        id: string
        type: ComponentType
        subComponents?: any | null
        styles?: any | null
        mobileStyles?: any | null
      }
    | {
        __typename?: 'LoginForm'
        id: string
        type: ComponentType
        subComponents?: any | null
        styles?: any | null
        mobileStyles?: any | null
      }
    | {
        __typename?: 'PageOptions'
        id: string
        type: ComponentType
        styles?: any | null
        mobileStyles?: any | null
        siteTitle?: string | null
        faviconUrl?: string | null
      }
    | {
        __typename?: 'PostDonationForm'
        id: string
        type: ComponentType
        buttonText: string
        subComponents?: any | null
        styles?: any | null
        mobileStyles?: any | null
        extraFields: Array<{
          __typename?: 'ExtraField'
          type: ExtraFieldType
          name: string
          label: string
          isRequired: boolean
          isHidden?: boolean | null
          order?: number | null
          defaultValue?: string | null
          placeholder?: string | null
          conditionalFields?: Array<{
            __typename?: 'ExtraField'
            type: ExtraFieldType
            name: string
            label: string
            isRequired: boolean
            isHidden?: boolean | null
            order?: number | null
            defaultValue?: string | null
            placeholder?: string | null
            customField?: {
              __typename?: 'CustomField'
              id: string
              name: string
              elementType: CustomFieldElementType
              fieldDescription?: string | null
              acceptedValues?: Array<{ __typename?: 'CustomFieldValue'; key: string; value: string }> | null
            } | null
          }> | null
          customField?: {
            __typename?: 'CustomField'
            id: string
            name: string
            elementType: CustomFieldElementType
            fieldDescription?: string | null
            acceptedValues?: Array<{ __typename?: 'CustomFieldValue'; key: string; value: string }> | null
          } | null
        }>
      }
    | {
        __typename?: 'ProgressBar'
        id: string
        type: ComponentType
        goals?: Array<number> | null
        start?: any | null
        end?: any | null
        title?: string | null
        hideOnEnd?: boolean | null
        hideBeforeStart?: boolean | null
        hideOnGoalReached?: boolean | null
        styles?: any | null
        mobileStyles?: any | null
        isAllPagesLinked?: boolean | null
        linkedPageIds?: Array<string> | null
        offset?: number | null
        hideWhenMatchedGivingActive?: boolean | null
        bonusGoals?: Array<{
          __typename?: 'BonusGoal'
          text?: { __typename?: 'Text'; textValue: string; htmlText?: string | null } | null
        }> | null
        text?: { __typename?: 'Text'; textValue: string; htmlText?: string | null } | null
      }
    | {
        __typename?: 'ProgressImage'
        id: string
        type: ComponentType
        styles?: any | null
        mobileStyles?: any | null
        subComponents?: any | null
      }
    | {
        __typename?: 'RegisterForm'
        id: string
        type: ComponentType
        subComponents?: any | null
        styles?: any | null
        mobileStyles?: any | null
      }
    | { __typename?: 'Row'; id: string; type: ComponentType; styles?: any | null; mobileStyles?: any | null }
    | {
        __typename?: 'SocialShare'
        id: string
        type: ComponentType
        hasLink?: boolean | null
        hasTwitter?: boolean | null
        hasFacebook?: boolean | null
        hasEmail?: boolean | null
        hasWhatsApp?: boolean | null
        hasLinkedIn?: boolean | null
        styles?: any | null
        mobileStyles?: any | null
      }
    | {
        __typename?: 'Text'
        id: string
        type: ComponentType
        textValue: string
        htmlText?: string | null
        styles?: any | null
        mobileStyles?: any | null
      }
    | {
        __typename?: 'Video'
        id: string
        type: ComponentType
        styles?: any | null
        mobileStyles?: any | null
        url?: string | null
        title?: string | null
      }
    | {
        __typename?: 'VirtualGiftSection'
        id: string
        type: ComponentType
        styles?: any | null
        mobileStyles?: any | null
        subComponents?: any | null
      }
  >
  desktop: Array<{
    __typename?: 'OrderComponent'
    id: string
    childComponents?: Array<{
      __typename?: 'OrderComponent'
      id: string
      childComponents?: Array<{ __typename?: 'OrderComponent'; id: string }> | null
    }> | null
  }>
  mobile?: Array<{
    __typename?: 'OrderComponent'
    id: string
    childComponents?: Array<{
      __typename?: 'OrderComponent'
      id: string
      childComponents?: Array<{ __typename?: 'OrderComponent'; id: string }> | null
    }> | null
  }> | null
  elementSettings?: {
    __typename?: 'ElementSettings'
    progressBar?: {
      __typename?: 'ProgressBarAggregationSettingItem'
      pageIds: Array<string>
      progressBarGoals?: Array<{ __typename?: 'ProgressBarGoal'; goal: number }> | null
    } | null
    matchedGivings?: Array<{
      __typename?: 'CampaignMatchedGivingSetting'
      id: string
      startAt: string
      endAt?: string | null
      rounds: Array<{
        __typename?: 'CampaignMatchedGivingSettingItem'
        endFundRange: number
        multiplier: number
        startFundRange: number
      }>
    }> | null
  } | null
} & { ' $fragmentName'?: 'DonationPageLayoutFragment' }

export type GetThankYouPageIdFromPageIdQueryVariables = Exact<{
  campaignId: Scalars['ID']['input']
  pageId: Scalars['ID']['input']
}>

export type GetThankYouPageIdFromPageIdQuery = { __typename?: 'Query'; thankYouPageIdFromId: string }

export type SubmitQuickPayValuesMutationVariables = Exact<{
  input: QuickPayValuesInput
}>

export type SubmitQuickPayValuesMutation = { __typename?: 'Mutation'; submitQuickPayValues: boolean }

export type SubmitFormValuesMutationVariables = Exact<{
  input: SubmitFormValuesInput
}>

export type SubmitFormValuesMutation = { __typename?: 'Mutation'; submitFormValues: boolean }

export type SubmitPostDonationFormValuesMutationVariables = Exact<{
  input: SubmitPostDonationFormValuesInput
}>

export type SubmitPostDonationFormValuesMutation = { __typename?: 'Mutation'; submitPostDonationFormValues: boolean }

export type ProgressBarAmountQueryVariables = Exact<{
  campaignId: Scalars['ID']['input']
  isAllPagesLinked: Scalars['Boolean']['input']
  pageIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
  profileId?: InputMaybe<Scalars['ID']['input']>
}>

export type ProgressBarAmountQuery = {
  __typename?: 'Query'
  progressBarAmount?: { __typename?: 'ProgressBarAmount'; amount?: number | null } | null
}

export type ProfileDataQueryVariables = Exact<{
  charityId: Scalars['ID']['input']
  campaignId: Scalars['ID']['input']
  profileId: Scalars['ID']['input']
}>

export type ProfileDataQuery = {
  __typename?: 'Query'
  profileData: {
    __typename?: 'ProfileData'
    name: string
    logoUrl?: string | null
    description?: string | null
    goal?: number | null
    isGivingNotificationEnabled?: boolean | null
  }
}

export type LeaderboardQueryVariables = Exact<{
  charityId: Scalars['ID']['input']
  campaignId: Scalars['ID']['input']
  isLiveMode: Scalars['Boolean']['input']
  orderBy: ProfileQueryOrderType
  isApprovedOnly: Scalars['Boolean']['input']
}>

export type LeaderboardQuery = {
  __typename?: 'Query'
  leaderboard: Array<{
    __typename?: 'ProfileData'
    id: string
    name: string
    logoUrl?: string | null
    goal?: number | null
    progressAmount?: number | null
    profileUrl?: string | null
  }>
}

export type FullMatchedGivingProgressQueryVariables = Exact<{
  campaignId: Scalars['ID']['input']
  matchedGivingId: Scalars['ID']['input']
  isLiveMode: Scalars['Boolean']['input']
}>

export type FullMatchedGivingProgressQuery = {
  __typename?: 'Query'
  fullMatchedGivingProgress: { __typename?: 'MatchedGivingProgressResult'; amount: number }
}

export type PurlQueryVariables = Exact<{
  charityId: Scalars['ID']['input']
  campaignId: Scalars['ID']['input']
  id?: InputMaybe<Scalars['String']['input']>
  params?: InputMaybe<Scalars['String']['input']>
}>

export type PurlQuery = { __typename?: 'Query'; purl: any }

export type PurlParamsQueryVariables = Exact<{
  charityId: Scalars['ID']['input']
  campaignId: Scalars['ID']['input']
  params?: InputMaybe<Scalars['String']['input']>
}>

export type PurlParamsQuery = { __typename?: 'Query'; purlParams: any }

export type SalesforceContactQueryVariables = Exact<{
  charityId: Scalars['ID']['input']
  contactId: Scalars['String']['input']
  donorId: Scalars['String']['input']
}>

export type SalesforceContactQuery = {
  __typename?: 'Query'
  salesforceContact?: {
    __typename?: 'SalesforceContact'
    firstName?: string | null
    lastName?: string | null
    email?: string | null
    donationAmounts: Array<{ __typename?: 'SalesforceDonationAmount'; field: string; amount?: number | null }>
  } | null
}

export type RecordStatsMutationVariables = Exact<{
  input: AnalyticsInput
}>

export type RecordStatsMutation = { __typename?: 'Mutation'; recordStats?: boolean | null }

export type PageMetadataQueryVariables = Exact<{
  charityId: Scalars['ID']['input']
  campaignId: Scalars['ID']['input']
  pageId: Scalars['ID']['input']
}>

export type PageMetadataQuery = {
  __typename?: 'Query'
  pageMetadata?: {
    __typename?: 'Metadata'
    charity?: {
      __typename?: 'CharityMetadata'
      CharityName?: string | null
      Phone?: string | null
      Email?: string | null
      ABN?: string | null
      CustomFields?: string | null
      FaviconUrl?: string | null
    } | null
    campaign?: {
      __typename?: 'CampaignMetadata'
      CampaignName?: string | null
      CampaignGoal?: string | null
      ogImage?: string | null
      ogTitle?: string | null
      gtmScriptId?: string | null
      ga4ScriptId?: string | null
      fbPixelId?: string | null
      isConversionsApi?: boolean | null
    } | null
    page?: {
      __typename?: 'PageMetadata'
      OgImage?: string | null
      OgTitle?: string | null
      OgDescription?: string | null
    } | null
  } | null
}

export type PaymentSettingsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input']
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
}>

export type PaymentSettingsQuery = {
  __typename?: 'Query'
  paymentSettings?: {
    __typename?: 'PaymentSettings'
    platformFeeType: PlatformFeeType
    donorPaysPlatformFees?: Array<{
      __typename?: 'PlatformFee'
      platformFeeType: PlatformFeeType
      givingType: GivingType
      givingFrequencyType: GivingFrequencyType
      paymentProviderType: PaymentProviderType
      feeRanges?: Array<{
        __typename?: 'FeeRange'
        startRange?: number | null
        endRange?: number | null
        fixFee?: number | null
        percentageFee?: number | null
      }> | null
    } | null> | null
    tax?: { __typename?: 'Tax'; percentage: number; countryCodeIso2: string; label?: string | null } | null
    donationPagePaymentProviderSettings: {
      __typename?: 'DonationPagePaymentProviderSettings'
      stripePaymentSettings?: {
        __typename?: 'StripePaymentSettings'
        publishableKey?: string | null
        connectAccountId?: string | null
        paymentProviderType?: PaymentProviderType | null
        paymentChargeType?: PaymentChargeType | null
      } | null
      payPalMerchantSetting?: {
        __typename?: 'PayPalMerchantSetting'
        merchantId?: string | null
        merchantEmail?: string | null
        clientId?: string | null
      } | null
    }
  } | null
}

export type GetDonorProfileQueryQueryVariables = Exact<{ [key: string]: never }>

export type GetDonorProfileQueryQuery = {
  __typename?: 'Query'
  donorProfile: { __typename?: 'DonorProfile'; firstName?: string | null; lastName?: string | null }
}

export type DonorGivingsQueryVariables = Exact<{
  input: GivingsQueryInput
}>

export type DonorGivingsQuery = {
  __typename?: 'Query'
  donorGivings: {
    __typename?: 'DonorGivingsQueryResult'
    totalRecords: number
    items: Array<{
      __typename?: 'DonorGiving'
      givingId: string
      amount: number
      createdAt: any
      paymentMethodType: PaymentMethodType
      status: GivingStatus
      campaignTitle?: string | null
      donationFrequencyType: GivingDonationFrequency
    }>
  }
}

export type DonorSubscriptionsQueryVariables = Exact<{
  token: Scalars['String']['input']
  input: GivingsQueryInput
}>

export type DonorSubscriptionsQuery = {
  __typename?: 'Query'
  donorSubscriptions: {
    __typename?: 'DonorSubscriptionsQueryResult'
    totalRecords: number
    items: Array<{
      __typename?: 'DonorSubscription'
      subscriptionId: string
      amount: number
      createdAt: any
      name?: string | null
      status: SubscriptionStatus
      campaignTitle?: string | null
      paymentMethodType: PaymentMethodType
      nextPaymentDate?: any | null
      subscriptionStartDate: any
      subscriptionEndDate?: any | null
      frequency: GivingDonationFrequency
      resumeAt?: any | null
      externalSubscriptionId: string
      lastInvoice?: {
        __typename?: 'SubscriptionInvoice'
        invoiceDate: any
        invoiceStatus: SubscriptionInvoiceStatus
      } | null
      scheduledUpdate?: {
        __typename?: 'SubscriptionScheduledUpdate'
        subscriptionScheduleId: string
        externalSubscriptionScheduleId: string
        startAt?: any | null
        amount?: number | null
        donationFrequencyType?: GivingDonationFrequency | null
      } | null
      regularGivings: Array<{
        __typename?: 'DonorSubscriptionRegularGiving'
        regularGivingId: string
        amount: number
        createdAt: any
        name?: string | null
        status: GivingStatus
        paymentMethodType: PaymentMethodType
      }>
    }>
  }
}

export type LoginDonorMutationVariables = Exact<{
  email: Scalars['String']['input']
}>

export type LoginDonorMutation = { __typename?: 'Mutation'; loginDonor: string }

export type AuthenticateDonorTokenMutationVariables = Exact<{
  token: Scalars['String']['input']
}>

export type AuthenticateDonorTokenMutation = { __typename?: 'Mutation'; authenticateDonorToken: string }

export type DonorPortalSettingsQueryVariables = Exact<{
  url: Scalars['String']['input']
}>

export type DonorPortalSettingsQuery = {
  __typename?: 'Query'
  donorPortalSettings: {
    __typename?: 'DonorPortalSlugResponse'
    charityId: string
    branding?: string | null
    donorPortalRegularGivingPermissions: {
      __typename?: 'CharityDonorPortalRegularGivingPermissions'
      canEditName: boolean
      canEditAmount: boolean
      canEditFrequency: boolean
      canEditDonationEndDate: boolean
      canEditNextPaymentDate: boolean
      canCancelDonation: boolean
      canPauseDonation: boolean
      canResumeDonation: boolean
      updatePaymentDetails: UpdatePaymentMethodPermission
    }
  }
}

export type CharityMetadataQueryVariables = Exact<{
  charityId: Scalars['ID']['input']
}>

export type CharityMetadataQuery = {
  __typename?: 'Query'
  charityMetadata?: {
    __typename?: 'CharityMetadata'
    LogoUrl?: string | null
    ReversedLogoUrl?: string | null
    FaviconUrl?: string | null
    CharityName?: string | null
  } | null
}

export type RegenerateCustomerPortalSessionMutationVariables = Exact<{
  externalSubscriptionId: Scalars['String']['input']
}>

export type RegenerateCustomerPortalSessionMutation = {
  __typename?: 'Mutation'
  regenerateCustomerPortalSession: boolean
}

export type ValidateAndCreateCustomerPortalSessionMutationVariables = Exact<{
  tenantId: Scalars['ID']['input']
  token: Scalars['ID']['input']
  subscriptionId: Scalars['String']['input']
}>

export type ValidateAndCreateCustomerPortalSessionMutation = {
  __typename?: 'Mutation'
  validateAndCreateCustomerPortalSession: string
}

export type DonorSummaryMutationVariables = Exact<{
  input: DonorSummaryInput
}>

export type DonorSummaryMutation = { __typename?: 'Mutation'; submitDonorSummary?: boolean | null }

export const EditorPageLayoutFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'editorPageLayout' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Page' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'branding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'versionNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charityPageTemplateId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charityPageTemplateVersion' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'header' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasDonateButton' } },
                { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'taxDeductibleText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'keyInformationText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'components' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PageOptions' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'siteTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'faviconUrl' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Row' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Column' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Button' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buttonText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'target' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buttonType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DollarHandles' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dollarHandles' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasImage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasDescription' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProgressBar' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'goals' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bonusGoals' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'text' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'textValue' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'htmlText' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'text' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'textValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'htmlText' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideOnEnd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideBeforeStart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideOnGoalReached' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isAllPagesLinked' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'linkedPageIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'offset' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Image' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mergeFieldId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Text' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'textValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'htmlText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Empty' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DonationForm' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'donationFrequency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'donationFrequencyDefault' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dollarHandlesDefault' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'matchedGivings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'rounds' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'endFundRange' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'multiplier' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dollarHandles' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isPersonalised' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasImage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasDescription' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'extraFields' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'conditionalFields' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'customField' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'fieldDescription' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'acceptedValues' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'customField' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fieldDescription' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'acceptedValues' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'legalUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'minimumAmount' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Video' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CountdownTimer' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideOnEnd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideBeforeStart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'finish' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Comments' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showTotal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showViewAll' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'layout' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideBeforeStart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideOnEnd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isAllPagesLinked' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'linkedPageIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amountToShowOver' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Footer' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Header' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SocialShare' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasLink' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasTwitter' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasFacebook' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasEmail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasWhatsApp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasLinkedIn' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FundraiserButton' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'loginForm' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'registerForm' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'extraFields' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'conditionalFields' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'customField' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'fieldDescription' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'acceptedValues' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'customField' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'fieldDescription' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'acceptedValues' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'LoginForm' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RegisterForm' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FundraiserProfile' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Leaderboard' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProgressImage' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'VirtualGiftSection' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PostDonationForm' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buttonText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'extraFields' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isHidden' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'conditionalFields' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isHidden' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'customField' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'fieldDescription' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'acceptedValues' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'customField' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fieldDescription' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'acceptedValues' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'desktop' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'childComponents' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'childComponents' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobile' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'childComponents' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'childComponents' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EditorPageLayoutFragment, unknown>
export const DonationPageLayoutFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'donationPageLayout' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Page' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'branding' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'header' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasDonateButton' } },
                { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'taxDeductibleText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'keyInformationText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'components' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PageOptions' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'siteTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'faviconUrl' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Row' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Column' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Button' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buttonText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'target' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buttonType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DollarHandles' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dollarHandles' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasImage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasDescription' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProgressBar' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'goals' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bonusGoals' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'text' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'textValue' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'htmlText' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'text' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'textValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'htmlText' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideOnEnd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideBeforeStart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideOnGoalReached' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isAllPagesLinked' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'linkedPageIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'offset' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideWhenMatchedGivingActive' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Image' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mergeFieldId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Text' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'textValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'htmlText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Empty' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DonationForm' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'donationFrequency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'donationFrequencyDefault' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dollarHandlesDefault' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'matchedGivings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'rounds' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'endFundRange' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'multiplier' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dollarHandles' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isPersonalised' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasImage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasDescription' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'extraFields' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'conditionalFields' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'customField' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'fieldDescription' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'acceptedValues' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'customField' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fieldDescription' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'acceptedValues' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'legalUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'minimumAmount' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Video' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CountdownTimer' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideOnEnd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideBeforeStart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'finish' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bonusFinishTimes' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Comments' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showTotal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showViewAll' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'layout' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideBeforeStart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideOnEnd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isAllPagesLinked' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'linkedPageIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amountToShowOver' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Footer' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Header' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SocialShare' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasLink' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasTwitter' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasFacebook' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasEmail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasWhatsApp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasLinkedIn' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FundraiserButton' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'LoginForm' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RegisterForm' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FundraiserProfile' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Leaderboard' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProgressImage' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'VirtualGiftSection' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PostDonationForm' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buttonText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'extraFields' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isHidden' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'conditionalFields' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isHidden' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'customField' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'fieldDescription' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'acceptedValues' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'customField' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fieldDescription' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'acceptedValues' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'desktop' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'childComponents' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'childComponents' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobile' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'childComponents' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'childComponents' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'elementSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'progressBar' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'pageIds' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'progressBarGoals' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'goal' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'matchedGivings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rounds' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'endFundRange' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'multiplier' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startFundRange' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DonationPageLayoutFragment, unknown>
export const ClaimsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Claims' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationQuery' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'claims' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClaimsQuery, ClaimsQueryVariables>
export const SelectCharityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SelectCharity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SelectCharityInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectCharity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SelectCharityMutation, SelectCharityMutationVariables>
export const CreateCharityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateCharity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'charityInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateCharityInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCharity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'charityInput' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'charityInput' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'charityId' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCharityMutation, CreateCharityMutationVariables>
export const CampaignPerformanceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CampaignPerformance' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'timezoneOffsetInMinutes' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isLiveMode' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'campaignPerformance' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isLiveMode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isLiveMode' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'timezoneOffsetInMinutes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'timezoneOffsetInMinutes' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'donationCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'averageDonationAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalAmount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageDonationAmounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'pageName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'utmTagDonationAmounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'tagName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tagValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'donationAmounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'donorName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'donationsByDates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'donationCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'donationAmount' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CampaignPerformanceQuery, CampaignPerformanceQueryVariables>
export const CampaignAggregateGivingStatsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CampaignAggregateGivingStats' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'timezoneOffsetInMinutes' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isLiveMode' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'campaignAggregateGivingStats' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isLiveMode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isLiveMode' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'timezoneOffsetInMinutes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'timezoneOffsetInMinutes' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'donationCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'averageDonationAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalAmount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CampaignAggregateGivingStatsQuery, CampaignAggregateGivingStatsQueryVariables>
export const CampaignPageDonationAmountStatsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CampaignPageDonationAmountStats' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'timezoneOffsetInMinutes' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isLiveMode' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'campaignPageDonationAmounts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isLiveMode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isLiveMode' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'timezoneOffsetInMinutes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'timezoneOffsetInMinutes' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'pageName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CampaignPageDonationAmountStatsQuery, CampaignPageDonationAmountStatsQueryVariables>
export const CampaignUtmTagDonationAmountStatsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CampaignUtmTagDonationAmountStats' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'timezoneOffsetInMinutes' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isLiveMode' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'campaignUtmTagDonationAmounts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isLiveMode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isLiveMode' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'timezoneOffsetInMinutes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'timezoneOffsetInMinutes' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'tagName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tagValue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CampaignUtmTagDonationAmountStatsQuery, CampaignUtmTagDonationAmountStatsQueryVariables>
export const CampaignTopAmountStatsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CampaignTopAmountStats' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'timezoneOffsetInMinutes' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isLiveMode' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'campaignTopDonationAmounts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isLiveMode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isLiveMode' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'timezoneOffsetInMinutes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'timezoneOffsetInMinutes' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'donorName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CampaignTopAmountStatsQuery, CampaignTopAmountStatsQueryVariables>
export const CampaignAmountsByDateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CampaignAmountsByDate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'timezoneOffsetInMinutes' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isLiveMode' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'campaignAmountsByDate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isLiveMode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isLiveMode' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'timezoneOffsetInMinutes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'timezoneOffsetInMinutes' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'donationCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'donationAmount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CampaignAmountsByDateQuery, CampaignAmountsByDateQueryVariables>
export const CampaignsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Campaigns' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationQuery' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'campaigns' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'campaignDomain' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isP2PEnabled' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CampaignsQuery, CampaignsQueryVariables>
export const CampaignsOverviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CampaignsOverview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isLiveMode' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'campaignsOverview' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isLiveMode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isLiveMode' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalDonors' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalAmount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'campaignSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'aggregationSettings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'progressBarSetting' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'groupSettings' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'progressBarGoals' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'goal' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageReferences' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'thankYouPageIds' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'receiptPageIds' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pageId' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentSettings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'platformFeeType' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pages' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'screenshotImageUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'index' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pageBucketId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buckets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CampaignsOverviewQuery, CampaignsOverviewQueryVariables>
export const BrandingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Brandings' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brandings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'logoURL' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BrandingsQuery, BrandingsQueryVariables>
export const CreateBrandingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateBranding' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'brandingInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateBrandingInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createBranding' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'brandingInput' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'brandingInput' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateBrandingMutation, CreateBrandingMutationVariables>
export const CreateCampaignDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateCampaign' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateCampaignInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCampaign' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignInput' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignInput' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCampaignMutation, CreateCampaignMutationVariables>
export const UpdateCampaignTitleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateCampaignTitle' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignTitle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCampaignTitle' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignTitle' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignTitle' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCampaignTitleMutation, UpdateCampaignTitleMutationVariables>
export const InitCampaignDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InitCampaign' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'initCampaignInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'InitCampaignInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'initCampaign' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'initCampaignInput' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'initCampaignInput' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InitCampaignMutation, InitCampaignMutationVariables>
export const DuplicateCampaignDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DuplicateCampaign' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'duplicateCampaignInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DuplicateCampaignInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'duplicateCampaign' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'duplicateCampaignInput' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'duplicateCampaignInput' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DuplicateCampaignMutation, DuplicateCampaignMutationVariables>
export const CampaignDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Campaign' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'campaign' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CampaignQuery, CampaignQueryVariables>
export const DeleteCampaignDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteCampaign' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deleteCampaignInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DeleteCampaignInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteCampaign' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'deleteCampaignInput' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'deleteCampaignInput' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteCampaignMutation, DeleteCampaignMutationVariables>
export const CampaignDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CampaignDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'campaign' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'charity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageTypes' },
                value: { kind: 'ListValue', values: [{ kind: 'EnumValue', value: 'DonationPage' }] },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'index' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasBeenPublished' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CampaignDetailsQuery, CampaignDetailsQueryVariables>
export const CreateManualDonationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateManualDonation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateManualDonationInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createManualDonation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateManualDonationMutation, CreateManualDonationMutationVariables>
export const CreateManualSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateManualSubscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateManualSubscriptionInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createManualSubscription' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateManualSubscriptionMutation, CreateManualSubscriptionMutationVariables>
export const CreateOfflineDonationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateOfflineDonation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateOfflineDonationInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createOfflineDonation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateOfflineDonationMutation, CreateOfflineDonationMutationVariables>
export const ApproveIdentityPartnerSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApproveIdentityPartnerSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityPartnerSettingInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approveIdentityPartnerSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ApproveIdentityPartnerSettingsMutation, ApproveIdentityPartnerSettingsMutationVariables>
export const ApproveRaiserEdgeIntegrationSettingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApproveRaiserEdgeIntegrationSetting' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'state' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approveRaiserEdgeIntegrationSetting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'state' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'state' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'code' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApproveRaiserEdgeIntegrationSettingMutation,
  ApproveRaiserEdgeIntegrationSettingMutationVariables
>
export const AddRaiserEdgeIntegrationSettingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddRaiserEdgeIntegrationSetting' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RaiserEdgeIntegrationSettingInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addRaiserEdgeIntegrationSetting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddRaiserEdgeIntegrationSettingMutation, AddRaiserEdgeIntegrationSettingMutationVariables>
export const AnalyticsIntegrationSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AnalyticsIntegrationSettings' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'analyticsIntegrationSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pixelConversionsApiSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'pixelId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'settingId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isConversionsApi' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'testEventCode' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'gtmSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'tagId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'settingId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ga4Settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'measurementId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'settingId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'identityPartnerSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'settingId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'webhookUrl' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'raiserEdgeIntegrationSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'settingId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'callbackUrl' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AnalyticsIntegrationSettingsQuery, AnalyticsIntegrationSettingsQueryVariables>
export const AddPixelConversionsApiSettingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddPixelConversionsApiSetting' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'PixelConversionsApiIntegrationSettingInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addPixelConversionsApiSetting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddPixelConversionsApiSettingMutation, AddPixelConversionsApiSettingMutationVariables>
export const AddGtmSettingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddGtmSetting' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GtmIntegrationSettingInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addGtmSetting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddGtmSettingMutation, AddGtmSettingMutationVariables>
export const AddGa4SettingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddGa4Setting' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Ga4IntegrationSettingInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addGa4Setting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddGa4SettingMutation, AddGa4SettingMutationVariables>
export const UpdatePixelConversionsApiSettingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePixelConversionsApiSetting' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'UpdatePixelConversionsApiIntegrationSettingInput' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePixelConversionsApiSetting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdatePixelConversionsApiSettingMutation,
  UpdatePixelConversionsApiSettingMutationVariables
>
export const UpdateGtmSettingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateGtmSetting' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateGtmIntegrationSettingInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateGtmSetting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateGtmSettingMutation, UpdateGtmSettingMutationVariables>
export const UpdateGa4SettingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateGa4Setting' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateGa4IntegrationSettingInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateGa4Setting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateGa4SettingMutation, UpdateGa4SettingMutationVariables>
export const DeleteAnalyticsSettingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteAnalyticsSetting' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DeleteAnalyticsSettingInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteAnalyticsSetting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteAnalyticsSettingMutation, DeleteAnalyticsSettingMutationVariables>
export const SendCharityTaxSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendCharityTaxSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SendCharityTaxSummaryInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendCharityTaxSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendCharityTaxSummaryMutation, SendCharityTaxSummaryMutationVariables>
export const CharityTaxSummaryStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CharityTaxSummaryStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'financialYear' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isLiveMode' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'charityTaxSummaryStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'financialYear' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'financialYear' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isLiveMode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isLiveMode' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isSendLogExists' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalEmailCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CharityTaxSummaryStatusQuery, CharityTaxSummaryStatusQueryVariables>
export const CharityTaxSummaryTotalEmailCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CharityTaxSummaryTotalEmailCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'financialYear' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'taxSummarySettingType' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CharityTaxSummaryMessageType' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isLiveMode' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'charityTaxSummaryTotalEmailCount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'financialYear' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'financialYear' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'taxSummarySettingType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'taxSummarySettingType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isLiveMode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isLiveMode' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CharityTaxSummaryTotalEmailCountQuery, CharityTaxSummaryTotalEmailCountQueryVariables>
export const ChangeUserRoleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ChangeUserRole' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'roleId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'mfaJwt' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changeRole' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'roleId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'roleId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'mfaJwt' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'mfaJwt' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChangeUserRoleMutation, ChangeUserRoleMutationVariables>
export const CharityUserRolesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CharityUserRoles' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'charityUserRoles' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'roleId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CharityUserRolesQuery, CharityUserRolesQueryVariables>
export const CharityUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CharityUsers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationQuery' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'charityUsers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'role' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'roleId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalRecords' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CharityUsersQuery, CharityUsersQueryVariables>
export const CreateUserForCharityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateUserForCharity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateUserForCharityInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'mfaJwt' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createUserForCharity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'mfaJwt' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'mfaJwt' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateUserForCharityMutation, CreateUserForCharityMutationVariables>
export const DeleteUserForCharityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteUserForCharity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'mfaJwt' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteUserFromCharity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'mfaJwt' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'mfaJwt' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteUserForCharityMutation, DeleteUserForCharityMutationVariables>
export const AddPayPalByReferralDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddPayPalByReferral' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AddPayPalByReferralInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addPayPalByReferral' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddPayPalByReferralMutation, AddPayPalByReferralMutationVariables>
export const CreatePaypalReferralLinkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreatePaypalReferralLink' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreatePaypalReferralLinkInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPaypalReferralLink' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'referralLink' } },
                { kind: 'Field', name: { kind: 'Name', value: 'referralToken' } },
                { kind: 'Field', name: { kind: 'Name', value: 'merchantEmail' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreatePaypalReferralLinkMutation, CreatePaypalReferralLinkMutationVariables>
export const ConnectStripeStandardAccountOAuthDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ConnectStripeStandardAccountOAuth' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isLiveMode' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'connectStripeStandardAccountOAuth' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isLiveMode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isLiveMode' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConnectStripeStandardAccountOAuthMutation,
  ConnectStripeStandardAccountOAuthMutationVariables
>
export const SetCharityPlatformFeeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetCharityPlatformFee' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'platformFeeType' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'PlatformFeeType' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setCharityPlatformFee' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'platformFeeType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'platformFeeType' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetCharityPlatformFeeMutation, SetCharityPlatformFeeMutationVariables>
export const CharityPageRedirectionSettingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CharityPageRedirectionSetting' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'charityPageRedirectionSetting' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'to' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'campaignId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'campaignName' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'externalTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'from' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'campaignId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'campaignName' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CharityPageRedirectionSettingQuery, CharityPageRedirectionSettingQueryVariables>
export const SetCharityPageRedirectionSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetCharityPageRedirectionSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'CharityPageRedirectionSettingsInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setCharityPageRedirectionSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetCharityPageRedirectionSettingsMutation,
  SetCharityPageRedirectionSettingsMutationVariables
>
export const PageRedirectCampaignsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PageRedirectCampaigns' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationQuery' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'campaigns' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PageRedirectCampaignsQuery, PageRedirectCampaignsQueryVariables>
export const ExchangeStripeOAuthCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ExchangeStripeOAuthCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ExchangeStripeOAuthInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exchangeStripeOAuthCode' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ExchangeStripeOAuthCodeMutation, ExchangeStripeOAuthCodeMutationVariables>
export const CharitySettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CharitySettings' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'charityPaymentSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stripe' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'payPal' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'merchantEmail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'platformFeeType' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customFieldSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'acceptedValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CharitySettingsQuery, CharitySettingsQueryVariables>
export const SetCharityPayPalSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetCharityPayPalSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CharityPayPalSettingsInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setCharityPayPalSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'label' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetCharityPayPalSettingsMutation, SetCharityPayPalSettingsMutationVariables>
export const SetCharityStripeSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetCharityStripeSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CharityStripeSettingsInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setCharityStripeSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'label' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetCharityStripeSettingsMutation, SetCharityStripeSettingsMutationVariables>
export const AddCustomFieldDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'addCustomField' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomFieldSettingInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addCustomFieldSetting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'acceptedValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddCustomFieldMutation, AddCustomFieldMutationVariables>
export const UpdateCustomFieldDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateCustomField' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomFieldSettingInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCustomFieldSetting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCustomFieldMutation, UpdateCustomFieldMutationVariables>
export const CharityDetailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CharityDetail' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'charityDetail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'abn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'faviconUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reversedLogoUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fromName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fromEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDgrEndorsed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sendPdfReceipt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoSendTaxSummaryEmailDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'branding' } },
                { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CharityDetailQuery, CharityDetailQueryVariables>
export const SetCharityDetailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetCharityDetail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CharityDetailInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setCharityDetail' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetCharityDetailMutation, SetCharityDetailMutationVariables>
export const SetCharityBrandingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetCharityBranding' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'brandingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setCharityBranding' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'brandingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'brandingId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetCharityBrandingMutation, SetCharityBrandingMutationVariables>
export const AggregatedGivingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AggregatedGivings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AggregatedGivingsInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'aggregatedGivings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'amounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AggregatedGivingsQuery, AggregatedGivingsQueryVariables>
export const CharityDonorPortalSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CharityDonorPortalSettings' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'charityDonorPortalSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'regularGivingPermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canEditName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canEditAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canEditFrequency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canEditDonationEndDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canEditNextPaymentDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canCancelDonation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canPauseDonation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canResumeDonation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatePaymentDetails' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CharityDonorPortalSettingsQuery, CharityDonorPortalSettingsQueryVariables>
export const SetCharityDonorPortalPermissionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetCharityDonorPortalPermissions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CharityDonorPortalPermissionsInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setCharityDonorPortalPermissions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetCharityDonorPortalPermissionsMutation,
  SetCharityDonorPortalPermissionsMutationVariables
>
export const UpdateBrandingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateBranding' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'brandingInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateBrandingInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBranding' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'brandingInput' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'brandingInput' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'brandingId' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateBrandingMutation, UpdateBrandingMutationVariables>
export const CampaignAssetsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CampaignAssets' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationQuery' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'campaignAssets' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CampaignAssetsQuery, CampaignAssetsQueryVariables>
export const DeleteCampaignAssetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteCampaignAsset' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'assetId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteCampaignAsset' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'assetId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'assetId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteCampaignAssetMutation, DeleteCampaignAssetMutationVariables>
export const SetThankYouPageReferencesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetThankYouPageReferences' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SetThankYouPageReferencesInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setThankYouPageReferences' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetThankYouPageReferencesMutation, SetThankYouPageReferencesMutationVariables>
export const SetReceiptPageReferencesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetReceiptPageReferences' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SetReceiptPageReferencesInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setReceiptPageReferences' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetReceiptPageReferencesMutation, SetReceiptPageReferencesMutationVariables>
export const CreatePageBucketDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreatePageBucket' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'createPageBucketInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreatePageBucketInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPageBucket' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'createPageBucketInput' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'createPageBucketInput' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreatePageBucketMutation, CreatePageBucketMutationVariables>
export const SendTestEmailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendTestEmail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sendTestReceiptInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SendTestReceiptInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendTestEmail' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sendTestReceiptInput' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sendTestReceiptInput' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendTestEmailMutation, SendTestEmailMutationVariables>
export const SectionTemplatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SectionTemplates' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pageType' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'PageType' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sectionTemplates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pageType' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SectionTemplatesQuery, SectionTemplatesQueryVariables>
export const CampaignInformationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CampaignInformation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'campaign' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'platformFeeType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'charity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CampaignInformationQuery, CampaignInformationQueryVariables>
export const CampaignSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CampaignSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'campaignSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageReferences' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'pageId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'thankYouPageIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'receiptPageIds' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'peerToPeerPageMapSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'singleFundraiserPageIds' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'pageId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'categoryId' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'multipleFundraiserPageIds' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'pageId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'categoryId' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultCampaignPageId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'emailReceiptSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'receiptOptionSetting' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'givingReceiptOption' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'subscriptionReceiptOption' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sendPdfReceipt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sendFundraiserWelcomeEmail' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'receiptPageId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'replyTo' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'profileRegisteredNotificationEmailsEnabled' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'profileRegisteredNotificationEmails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isPeerToPeerGivingNotificationEnabled' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CampaignSettingsQuery, CampaignSettingsQueryVariables>
export const CharityProfileCategoriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CharityProfileCategories' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'charityProfileCategories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CharityProfileCategoriesQuery, CharityProfileCategoriesQueryVariables>
export const CampaignUrlsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CampaignUrls' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'campaignDomain' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
                { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CampaignUrlsQuery, CampaignUrlsQueryVariables>
export const CreateTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateTemplateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateTemplateMutation, CreateTemplateMutationVariables>
export const UpdateTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateTemplateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateTemplateMutation, UpdateTemplateMutationVariables>
export const DeleteTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteTemplateMutation, DeleteTemplateMutationVariables>
export const MergeTagsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MergeTags' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'charityMergeTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'MergeFieldSettingId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'MergeTag' } },
                { kind: 'Field', name: { kind: 'Name', value: 'MergeFieldName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'QueryParameter' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MergeTagsQuery, MergeTagsQueryVariables>
export const InitFundraiserPagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InitFundraiserPages' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'initFundraiserPages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InitFundraiserPagesMutation, InitFundraiserPagesMutationVariables>
export const CampaignPagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CampaignPages' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pageTypes' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'PageType' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageBuckets' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageTypes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pageTypes' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'index' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasBeenPublished' } },
                { kind: 'Field', name: { kind: 'Name', value: 'screenshotImageUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pageBucketId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CampaignPagesQuery, CampaignPagesQueryVariables>
export const PageBucketsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PageBuckets' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageBuckets' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pageIds' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PageBucketsQuery, PageBucketsQueryVariables>
export const CharityPageTemplatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CharityPageTemplates' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CharityTemplateType' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pageType' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'PageType' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'charityTemplates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'type' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pageType' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'screenshotImageUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CharityPageTemplatesQuery, CharityPageTemplatesQueryVariables>
export const PageLayoutDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PageLayout' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pageId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pageType' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'PageType' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageLayout' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pageId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pageType' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'editorPageLayout' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'editorPageLayout' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Page' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'branding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'versionNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charityPageTemplateId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charityPageTemplateVersion' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'header' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasDonateButton' } },
                { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'taxDeductibleText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'keyInformationText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'components' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PageOptions' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'siteTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'faviconUrl' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Row' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Column' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Button' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buttonText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'target' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buttonType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DollarHandles' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dollarHandles' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasImage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasDescription' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProgressBar' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'goals' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bonusGoals' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'text' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'textValue' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'htmlText' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'text' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'textValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'htmlText' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideOnEnd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideBeforeStart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideOnGoalReached' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isAllPagesLinked' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'linkedPageIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'offset' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Image' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mergeFieldId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Text' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'textValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'htmlText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Empty' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DonationForm' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'donationFrequency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'donationFrequencyDefault' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dollarHandlesDefault' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'matchedGivings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'rounds' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'endFundRange' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'multiplier' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dollarHandles' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isPersonalised' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasImage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasDescription' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'extraFields' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'conditionalFields' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'customField' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'fieldDescription' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'acceptedValues' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'customField' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fieldDescription' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'acceptedValues' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'legalUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'minimumAmount' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Video' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CountdownTimer' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideOnEnd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideBeforeStart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'finish' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Comments' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showTotal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showViewAll' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'layout' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideBeforeStart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideOnEnd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isAllPagesLinked' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'linkedPageIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amountToShowOver' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Footer' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Header' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SocialShare' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasLink' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasTwitter' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasFacebook' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasEmail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasWhatsApp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasLinkedIn' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FundraiserButton' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'loginForm' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'registerForm' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'extraFields' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'conditionalFields' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'customField' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'fieldDescription' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'acceptedValues' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'customField' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'fieldDescription' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'acceptedValues' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'LoginForm' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RegisterForm' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FundraiserProfile' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Leaderboard' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProgressImage' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'VirtualGiftSection' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PostDonationForm' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buttonText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'extraFields' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isHidden' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'conditionalFields' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isHidden' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'customField' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'fieldDescription' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'acceptedValues' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'customField' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fieldDescription' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'acceptedValues' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'desktop' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'childComponents' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'childComponents' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobile' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'childComponents' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'childComponents' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PageLayoutQuery, PageLayoutQueryVariables>
export const TemplateLayoutDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TemplateLayout' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'templateId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'templateType' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'TemplateType' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'templatePage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'templateId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'templateId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'templateType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'templateType' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'editorPageLayout' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'editorPageLayout' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Page' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'branding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'versionNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charityPageTemplateId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charityPageTemplateVersion' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'header' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasDonateButton' } },
                { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'taxDeductibleText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'keyInformationText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'components' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PageOptions' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'siteTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'faviconUrl' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Row' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Column' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Button' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buttonText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'target' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buttonType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DollarHandles' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dollarHandles' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasImage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasDescription' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProgressBar' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'goals' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bonusGoals' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'text' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'textValue' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'htmlText' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'text' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'textValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'htmlText' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideOnEnd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideBeforeStart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideOnGoalReached' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isAllPagesLinked' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'linkedPageIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'offset' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Image' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mergeFieldId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Text' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'textValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'htmlText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Empty' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DonationForm' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'donationFrequency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'donationFrequencyDefault' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dollarHandlesDefault' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'matchedGivings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'rounds' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'endFundRange' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'multiplier' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dollarHandles' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isPersonalised' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasImage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasDescription' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'extraFields' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'conditionalFields' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'customField' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'fieldDescription' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'acceptedValues' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'customField' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fieldDescription' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'acceptedValues' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'legalUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'minimumAmount' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Video' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CountdownTimer' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideOnEnd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideBeforeStart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'finish' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Comments' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showTotal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showViewAll' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'layout' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideBeforeStart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideOnEnd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isAllPagesLinked' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'linkedPageIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amountToShowOver' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Footer' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Header' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SocialShare' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasLink' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasTwitter' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasFacebook' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasEmail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasWhatsApp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasLinkedIn' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FundraiserButton' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'loginForm' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'registerForm' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'extraFields' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'conditionalFields' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'customField' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'fieldDescription' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'acceptedValues' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'customField' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'fieldDescription' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'acceptedValues' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'LoginForm' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RegisterForm' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FundraiserProfile' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Leaderboard' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProgressImage' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'VirtualGiftSection' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PostDonationForm' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buttonText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'extraFields' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isHidden' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'conditionalFields' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isHidden' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'customField' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'fieldDescription' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'acceptedValues' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'customField' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fieldDescription' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'acceptedValues' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'desktop' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'childComponents' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'childComponents' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobile' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'childComponents' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'childComponents' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TemplateLayoutQuery, TemplateLayoutQueryVariables>
export const PreviewLayoutDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PreviewLayout' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'previewId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previewLayout' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'previewId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'previewId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'page' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'editorPageLayout' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'campaignSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageReferences' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'pageId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'thankYouPageIds' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentSettings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'hasStripe' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasPaypal' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'platformFeeType' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'matchedGivingSettings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'rounds' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'startFundRange' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'endFundRange' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'multiplier' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'aggregationSettings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'progressBarSetting' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'groupSettings' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'progressBarGoals' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'goal' } }],
                                          },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'startVisibleTime' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'endVisibleTime' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'isGoalHidden' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'pageIds' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'hideWhenMatchedGivingActive' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'commentSetting' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'groupSettings' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'startVisibleTime' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'endVisibleTime' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'pageIds' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'matchedGivingSetting' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'groupSettings' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'pageIds' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'matchedGivingSettingIds' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'countdownTimerSetting' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'groupSettings' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'finishTime' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'startVisibleTime' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'endVisibleTime' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'pageIds' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'bonusFinishTimes' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'charity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'CharityName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'Phone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'Email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ABN' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'CustomFields' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'FaviconUrl' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'campaign' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'CampaignName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'CampaignGoal' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ogImage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ogTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'gtmScriptId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ga4ScriptId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fbPixelId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isConversionsApi' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'page' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'OgImage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'OgTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'OgDescription' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'profiles' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'progressAmount' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'editorPageLayout' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Page' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'branding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'versionNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charityPageTemplateId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charityPageTemplateVersion' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'header' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasDonateButton' } },
                { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'taxDeductibleText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'keyInformationText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'components' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PageOptions' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'siteTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'faviconUrl' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Row' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Column' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Button' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buttonText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'target' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buttonType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DollarHandles' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dollarHandles' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasImage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasDescription' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProgressBar' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'goals' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bonusGoals' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'text' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'textValue' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'htmlText' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'text' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'textValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'htmlText' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideOnEnd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideBeforeStart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideOnGoalReached' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isAllPagesLinked' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'linkedPageIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'offset' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Image' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mergeFieldId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Text' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'textValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'htmlText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Empty' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DonationForm' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'donationFrequency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'donationFrequencyDefault' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dollarHandlesDefault' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'matchedGivings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'rounds' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'endFundRange' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'multiplier' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dollarHandles' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isPersonalised' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasImage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasDescription' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'extraFields' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'conditionalFields' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'customField' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'fieldDescription' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'acceptedValues' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'customField' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fieldDescription' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'acceptedValues' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'legalUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'minimumAmount' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Video' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CountdownTimer' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideOnEnd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideBeforeStart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'finish' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Comments' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showTotal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showViewAll' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'layout' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideBeforeStart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideOnEnd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isAllPagesLinked' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'linkedPageIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amountToShowOver' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Footer' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Header' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SocialShare' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasLink' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasTwitter' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasFacebook' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasEmail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasWhatsApp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasLinkedIn' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FundraiserButton' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'loginForm' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'registerForm' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'extraFields' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'conditionalFields' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'customField' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'fieldDescription' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'acceptedValues' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'customField' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'fieldDescription' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'acceptedValues' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'LoginForm' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RegisterForm' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FundraiserProfile' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Leaderboard' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProgressImage' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'VirtualGiftSection' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PostDonationForm' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buttonText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'extraFields' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isHidden' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'conditionalFields' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isHidden' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'customField' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'fieldDescription' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'acceptedValues' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'customField' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fieldDescription' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'acceptedValues' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'desktop' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'childComponents' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'childComponents' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobile' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'childComponents' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'childComponents' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PreviewLayoutQuery, PreviewLayoutQueryVariables>
export const SaveDraftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SaveDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'saveDraftInput' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SaveDraftInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'saveDraft' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'saveDraftInput' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'saveDraftInput' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveDraftMutation, SaveDraftMutationVariables>
export const PublishPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PublishPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'publishPageInput' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'PublishPageInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publishPage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'publishPageInput' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'publishPageInput' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'index' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pageBucketId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PublishPageMutation, PublishPageMutationVariables>
export const CreatePageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreatePage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'createPageInput' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreatePageInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'createPageInput' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'createPageInput' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreatePageMutation, CreatePageMutationVariables>
export const CreatePageStateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreatePageState' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'createPageStateInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreatePageStateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPageState' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'createPageStateInput' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'createPageStateInput' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreatePageStateMutation, CreatePageStateMutationVariables>
export const DuplicatePageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DuplicatePage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'duplicatePageInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DuplicatePageInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'duplicatePage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'duplicatePageInput' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'duplicatePageInput' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DuplicatePageMutation, DuplicatePageMutationVariables>
export const DuplicatePageStateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DuplicatePageState' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'duplicatePageStateInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DuplicatePageStateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'duplicatePageState' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'duplicatePageStateInput' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'duplicatePageStateInput' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DuplicatePageStateMutation, DuplicatePageStateMutationVariables>
export const DeletePageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeletePage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deletePageInput' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DeletePageInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deletePage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'deletePageInput' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'deletePageInput' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeletePageMutation, DeletePageMutationVariables>
export const MergeFieldsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MergeFields' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mergeFields' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MergeFieldsQuery, MergeFieldsQueryVariables>
export const CustomFieldSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CustomFieldSettings' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customFieldSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'acceptedValues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CustomFieldSettingsQuery, CustomFieldSettingsQueryVariables>
export const SaveDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SaveDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'saveDetailsInput' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SaveDetailsInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'saveDetails' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'saveDetailsInput' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'saveDetailsInput' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveDetailsMutation, SaveDetailsMutationVariables>
export const SavePageBucketDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SavePageBucketDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pageBucketId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'savePageBucketDetails' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageBucketId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pageBucketId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SavePageBucketDetailsMutation, SavePageBucketDetailsMutationVariables>
export const FormDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FormData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'formId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'formData' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'formId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'formId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'headers' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'formData' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'formId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'formValues' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'values' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FormDataQuery, FormDataQueryVariables>
export const GivingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Givings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GivingsQueryInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'givings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalRecords' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'givingId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'donatedAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'refundedAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'donorPaysAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'platformFeesAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'transactionId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'paymentMethodType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'donationFrequency' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stripe' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'paymentIntentId' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paypal' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'orderId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'captureId' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'donor' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'donationFormFirstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'donationFormLastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'externalFirstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'externalLastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'page' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'pageId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pageName' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'campaign' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'campaignId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'campaignTitle' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'comment' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'commentId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GivingsQuery, GivingsQueryVariables>
export const ResendReceiptDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResendReceipt' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ResendReceiptInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resendReceipt' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResendReceiptMutation, ResendReceiptMutationVariables>
export const MatchedGivingRecordsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MatchedGivingRecords' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pageSize' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pageNumber' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'mode' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Mode' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'matchedGivingRecords' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pageSize' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pageNumber' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'mode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'mode' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalRecords' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'matchedGivingSettingName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'givingAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'matchedDonationAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'matchedAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'multiplier' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'donorEmail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'donorName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'campaignTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pageName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'matchedGivingId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'givingId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MatchedGivingRecordsQuery, MatchedGivingRecordsQueryVariables>
export const MediaLibraryAssetsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MediaLibraryAssets' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'MediaLibraryAssetsInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaLibraryAssets' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'altText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sizeInBytes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uploadedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uploadedBy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MediaLibraryAssetsQuery, MediaLibraryAssetsQueryVariables>
export const UpdateMediaLibraryAssetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateMediaLibraryAsset' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateMediaLibraryAssetInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateMediaLibraryAsset' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateMediaLibraryAssetMutation, UpdateMediaLibraryAssetMutationVariables>
export const DeleteMediaLibraryAssetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteMediaLibraryAsset' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'assetId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteMediaLibraryAsset' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'assetId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'assetId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteMediaLibraryAssetMutation, DeleteMediaLibraryAssetMutationVariables>
export const PayoutTransactionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PayoutTransactions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payoutId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'payoutTransactions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'payoutId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'payoutId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'givingId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transactionExternalData' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stripeData' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'paymentIntentId' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentTransaction' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'transactionAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'donationFormAmount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionFees' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'totalFee' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'platformFee' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'internalManagedAdminFee' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'paymentGatewayFee' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalTax' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'charityTipAmount' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'refundTransaction' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'transactionAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'donationFormAmount' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'netPaymentTransactionAmount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationFeeTransaction' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'applicationFeeAmount' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'payout' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'payoutId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'payoutId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transferAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'payoutDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentTransaction' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'transactionAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'donationFormAmount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionFees' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'totalFee' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'platformFee' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'internalManagedAdminFee' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'paymentGatewayFee' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalTax' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'refundTransaction' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'transactionAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'donationFormAmount' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationFeeTransaction' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'applicationFeeAmount' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PayoutTransactionsQuery, PayoutTransactionsQueryVariables>
export const PayoutsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Payouts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pageNumber' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pageSize' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'mode' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Mode' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'paymentProviderId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'payouts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pageNumber' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pageSize' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'mode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'mode' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'paymentProviderId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'paymentProviderId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalRecords' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'transferAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'payoutDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentTransaction' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'transactionAmount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'donationFormAmount' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'transactionFees' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalFee' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'platformFee' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'internalManagedAdminFee' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'paymentGatewayFee' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalTax' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'refundTransaction' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'transactionAmount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'donationFormAmount' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'applicationFeeTransaction' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'applicationFeeAmount' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PayoutsQuery, PayoutsQueryVariables>
export const UnpaidTransactionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UnpaidTransactions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'mode' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Mode' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'paymentProviderId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unpaidTransactions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'mode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'mode' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'paymentProviderId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'paymentProviderId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'givingId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transactionExternalData' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stripeData' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'paymentIntentId' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentTransaction' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'transactionAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'donationFormAmount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionFees' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'totalFee' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'platformFee' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'internalManagedAdminFee' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'paymentGatewayFee' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalTax' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'charityTipAmount' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'refundTransaction' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'transactionAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'donationFormAmount' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'netPaymentTransactionAmount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationFeeTransaction' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'applicationFeeAmount' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UnpaidTransactionsQuery, UnpaidTransactionsQueryVariables>
export const UnpaidBalanceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UnpaidBalance' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'mode' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Mode' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'paymentProviderId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unpaidBalance' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'mode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'mode' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'paymentProviderId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'paymentProviderId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalAmount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UnpaidBalanceQuery, UnpaidBalanceQueryVariables>
export const CharityAnalyticsSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CharityAnalyticsSettings' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'analyticsIntegrationSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pixelConversionsApiSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'settingId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'gtmSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'settingId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ga4Settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'settingId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CharityAnalyticsSettingsQuery, CharityAnalyticsSettingsQueryVariables>
export const CampaignAnalyticsSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CampaignAnalyticsSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'campaignAnalyticsSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pixelConversionsApi' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'pixelSettingId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDisabled' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'gtm' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'gtmSettingId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDisabled' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ga4' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'ga4SettingId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDisabled' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CampaignAnalyticsSettingsQuery, CampaignAnalyticsSettingsQueryVariables>
export const SetCampaignAnalyticsSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'setCampaignAnalyticsSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CampaignAnalyticsSettingsInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setCampaignAnalyticsSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetCampaignAnalyticsSettingsMutation, SetCampaignAnalyticsSettingsMutationVariables>
export const SetEmailSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetEmailSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SetCampaignEmailSettingInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setEmailSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetEmailSettingsMutation, SetEmailSettingsMutationVariables>
export const ProfilesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Profiles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isLiveMode' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProfileQueryOrderType' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isApprovedOnly' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isLiveMode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isLiveMode' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isApprovedOnly' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isApprovedOnly' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'progressAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'profileUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isGivingNotificationEnabled' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProfilesQuery, ProfilesQueryVariables>
export const UpdateProfileAdminDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateProfileAdmin' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateProfileInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateProfileAdmin' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateProfileAdminMutation, UpdateProfileAdminMutationVariables>
export const SetCampaignPlatformFeeTypeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetCampaignPlatformFeeType' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SetCampaignPlatformFeeTypeInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setCampaignPlatformFeeType' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetCampaignPlatformFeeTypeMutation, SetCampaignPlatformFeeTypeMutationVariables>
export const SetCampaignStripeSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetCampaignStripeSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SetCampaignPaymentProviderSettingsInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setCampaignStripeSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'campaignId' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetCampaignStripeSettingsMutation, SetCampaignStripeSettingsMutationVariables>
export const SetCampaignPayPalSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetCampaignPayPalSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SetCampaignPaymentProviderSettingsInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setCampaignPayPalSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'campaignId' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetCampaignPayPalSettingsMutation, SetCampaignPayPalSettingsMutationVariables>
export const SetFundraiserRegistrationNotificationsForProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetFundraiserRegistrationNotificationsForProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SetFundraiserRegistrationNotificationsForProfileInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setFundraiserRegistrationNotificationsForProfile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetFundraiserRegistrationNotificationsForProfileMutation,
  SetFundraiserRegistrationNotificationsForProfileMutationVariables
>
export const CreateProfileCategoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateProfileCategory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateProfileCategoryInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createProfileCategory' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateProfileCategoryMutation, CreateProfileCategoryMutationVariables>
export const ToggleWelcomeEmailForProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ToggleWelcomeEmailForProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isEnabled' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'toggleWelcomeEmailForProfile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isEnabled' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isEnabled' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ToggleWelcomeEmailForProfileMutation, ToggleWelcomeEmailForProfileMutationVariables>
export const ToggleDonationNotificationForProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ToggleDonationNotificationForProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isEnabled' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'toggleDonationNotificationForProfile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isEnabled' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isEnabled' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ToggleDonationNotificationForProfileMutation,
  ToggleDonationNotificationForProfileMutationVariables
>
export const SetEmailReceiptSettingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'setEmailReceiptSetting' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SetEmailSettingItemInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setEmailReceiptSetting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetEmailReceiptSettingMutation, SetEmailReceiptSettingMutationVariables>
export const CampaignTriggersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CampaignTriggers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pageBucketId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'campaignTriggers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageBucketId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pageBucketId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'campaignTriggerId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dateTimeTriggers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'dateTimeStart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pageId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amountTriggers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'amountStart' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pageId' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CampaignTriggersQuery, CampaignTriggersQueryVariables>
export const SetCampaignTriggersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetCampaignTriggers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CampaignTriggerInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setCampaignTriggers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetCampaignTriggersMutation, SetCampaignTriggersMutationVariables>
export const AddCampaignDomainDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddCampaignDomain' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'addCampaignDomainInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AddCampaignDomainInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addCampaignDomain' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'addCampaignDomainInput' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'addCampaignDomainInput' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddCampaignDomainMutation, AddCampaignDomainMutationVariables>
export const AddPageSlugsForCampaignDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddPageSlugsForCampaign' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'addPageSlugsForCampaignInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AddPageSlugsForCampaignInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addPageSlugsForCampaign' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'addPageSlugsForCampaignInput' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'addPageSlugsForCampaignInput' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddPageSlugsForCampaignMutation, AddPageSlugsForCampaignMutationVariables>
export const AddPageBucketSlugsForCampaignDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddPageBucketSlugsForCampaign' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'addPageBucketSlugsForCampaignInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AddPageBucketSlugsForCampaignInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addPageBucketSlugsForCampaign' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'addPageBucketSlugsForCampaignInput' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'addPageBucketSlugsForCampaignInput' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddPageBucketSlugsForCampaignMutation, AddPageBucketSlugsForCampaignMutationVariables>
export const SetDefaultCampaignPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetDefaultCampaignPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SetDefaultCampaignPageInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setDefaultCampaignPage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetDefaultCampaignPageMutation, SetDefaultCampaignPageMutationVariables>
export const SetCommentAggregationSettingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetCommentAggregationSetting' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'CommentAggregationSettingItemInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setCommentAggregationSetting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetCommentAggregationSettingMutation, SetCommentAggregationSettingMutationVariables>
export const SetCountdownTimerAggregationSettingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetCountdownTimerAggregationSetting' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'CountdownTimerAggregationSettingItemInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setCountdownTimerAggregationSetting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetCountdownTimerAggregationSettingMutation,
  SetCountdownTimerAggregationSettingMutationVariables
>
export const SetProgressBarAggregationSettingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetProgressBarAggregationSetting' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProgressBarAggregationSettingItemInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setProgressBarAggregationSetting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetProgressBarAggregationSettingMutation,
  SetProgressBarAggregationSettingMutationVariables
>
export const AddCampaignMatchedGivingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddCampaignMatchedGiving' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CampaignMatchedGivingSettingInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addCampaignMatchedGivingSetting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddCampaignMatchedGivingMutation, AddCampaignMatchedGivingMutationVariables>
export const SetMatchedGivingAggregationSettingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetMatchedGivingAggregationSetting' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'MatchedGivingAggregationSettingItemInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setMatchedGivingAggregationSetting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetMatchedGivingAggregationSettingMutation,
  SetMatchedGivingAggregationSettingMutationVariables
>
export const MatchedGivingProgressDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MatchedGivingProgress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'matchedGivingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isLiveMode' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'matchedGivingProgress' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'matchedGivingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'matchedGivingId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isLiveMode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isLiveMode' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MatchedGivingProgressQuery, MatchedGivingProgressQueryVariables>
export const CampaignPageMetadataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CampaignPageMetadata' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pageId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'campaignPageMetadata' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pageId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'OgTitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'OgDescription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'OgImage' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CampaignPageMetadataQuery, CampaignPageMetadataQueryVariables>
export const SavePageMetadataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SavePageMetadata' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SavePageMetadataInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'savePageMetadata' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'savePageMetadataInput' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SavePageMetadataMutation, SavePageMetadataMutationVariables>
export const CharityPaymentSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CharityPaymentSettings' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'charityPaymentSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stripe' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'providerType' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'payPal' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'merchantEmail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'providerType' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'offline' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'providerType' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CharityPaymentSettingsQuery, CharityPaymentSettingsQueryVariables>
export const SubscriptionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Subscriptions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SubscriptionsQueryInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subscriptions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalRecords' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'subscriptionId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'donationFormAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'transactionAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'externalSubscriptionId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'paymentMethodType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalGivingTransactionAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'donationFrequencyType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'campaign' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subscriptionStartAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resumeAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nextPaymentDate' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastInvoice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'invoiceDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'invoiceStatus' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastGiving' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'givingDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'givingStatus' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scheduledUpdate' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'subscriptionScheduleId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'externalSubscriptionScheduleId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'donationFrequencyType' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SubscriptionsQuery, SubscriptionsQueryVariables>
export const UpdateSubscriptionAdminDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateSubscriptionAdmin' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateSubscriptionAdminInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSubscriptionAdmin' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'externalSubscriptionScheduleId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paymentSubscriptionScheduleId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateSubscriptionAdminMutation, UpdateSubscriptionAdminMutationVariables>
export const CancelSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CancelSubscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CancelSubscriptionInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancelSubscription' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>
export const PauseSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PauseSubscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'PauseSubscriptionInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pauseSubscription' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PauseSubscriptionMutation, PauseSubscriptionMutationVariables>
export const ResumeSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResumeSubscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ResumeSubscriptionInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resumeSubscription' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResumeSubscriptionMutation, ResumeSubscriptionMutationVariables>
export const CreateStripeSubscriptionDonorPortalLinkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateStripeSubscriptionDonorPortalLink' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'StripeSubscriptionDonorPortalLinkInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createStripeSubscriptionDonorPortalLink' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateStripeSubscriptionDonorPortalLinkMutation,
  CreateStripeSubscriptionDonorPortalLinkMutationVariables
>
export const PaymentTransactionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PaymentTransactions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pageSize' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pageNumber' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'mode' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Mode' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'paymentProviderId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentTransactions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pageSize' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pageNumber' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'mode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'mode' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'paymentProviderId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'paymentProviderId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalRecords' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'givingId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionExternalData' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stripeData' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'paymentIntentId' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'payPalData' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'captureId' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'offlineData' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'offlineTransactionId' } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentTransaction' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'transactionAmount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'donationFormAmount' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'transactionFees' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalFee' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'platformFee' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'internalManagedAdminFee' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'paymentGatewayFee' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalTax' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'charityTipAmount' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'refundTransaction' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'transactionAmount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'donationFormAmount' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'netPaymentTransactionAmount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'applicationFeeTransaction' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'applicationFeeAmount' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PaymentTransactionsQuery, PaymentTransactionsQueryVariables>
export const CampaignProgressBarAggregationSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CampaignProgressBarAggregationSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'aggregationSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'progressBarSetting' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'groupSettings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'groupName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startVisibleTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endVisibleTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isGoalHidden' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'progressBarGoals' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'index' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'offset' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pageIds' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pageBucketIds' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dataSources' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isAllPagesLinked' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hideWhenMatchedGivingActive' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CampaignProgressBarAggregationSettingsQuery,
  CampaignProgressBarAggregationSettingsQueryVariables
>
export const CampaignCommentAggregationSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CampaignCommentAggregationSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'aggregationSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'commentSetting' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'groupSettings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'groupName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startVisibleTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endVisibleTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'amountToShowOver' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pageIds' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pageBucketIds' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dataSources' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isAllPagesLinked' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CampaignCommentAggregationSettingsQuery, CampaignCommentAggregationSettingsQueryVariables>
export const CampaignCountdownTimerAggregationSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CampaignCountdownTimerAggregationSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'aggregationSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'countdownTimerSetting' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'groupSettings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'groupName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'finishTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startVisibleTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endVisibleTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pageIds' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pageBucketIds' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'bonusFinishTimes' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CampaignCountdownTimerAggregationSettingsQuery,
  CampaignCountdownTimerAggregationSettingsQueryVariables
>
export const CampaignPaymentSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CampaignPaymentSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'campaignPaymentSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'platformFeeType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stripe' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paypal' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CampaignPaymentSettingsQuery, CampaignPaymentSettingsQueryVariables>
export const CampaignMatchedGivingAggregationSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CampaignMatchedGivingAggregationSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'aggregationSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'matchedGivingSetting' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'groupSettings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'groupName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'matchedGivingSettingIds' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pageIds' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pageBucketIds' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'campaignMatchedGivingSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rounds' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'startFundRange' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endFundRange' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'multiplier' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CampaignMatchedGivingAggregationSettingsQuery,
  CampaignMatchedGivingAggregationSettingsQueryVariables
>
export const FeatureFlagDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FeatureFlag' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'flags' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureFlag' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'flags' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'flags' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FeatureFlagQuery, FeatureFlagQueryVariables>
export const AuthenticateProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AuthenticateProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'charityId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'encodedToken' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authenticateProfile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'charityId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'charityId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'encodedToken' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'encodedToken' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                { kind: 'Field', name: { kind: 'Name', value: 'profileUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AuthenticateProfileMutation, AuthenticateProfileMutationVariables>
export const LoginProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'LoginProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'charityId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loginProfile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'charityId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'charityId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LoginProfileMutation, LoginProfileMutationVariables>
export const ValidateTokenDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ValidateToken' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'charityId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profileId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'validateToken' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'token' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'charityId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'charityId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'profileId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'profileId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ValidateTokenQuery, ValidateTokenQueryVariables>
export const RegisterEmailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RegisterEmail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'charityId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'registerEmail' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'charityId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'charityId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasProfileInCampaign' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isExistingUser' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RegisterEmailMutation, RegisterEmailMutationVariables>
export const RegisterProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RegisterProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RegisterProfileInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'registerProfile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'token' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'profileId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'redirectUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RegisterProfileMutation, RegisterProfileMutationVariables>
export const UpdateProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateProfileInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateProfile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'token' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateProfileMutation, UpdateProfileMutationVariables>
export const CommentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Comments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CommentsQueryInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'comments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'comments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'donatedBy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'donatedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'donatedTo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'matchedAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'matchedDonationAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dedicateeName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'organisationName' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalRecords' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CommentsQuery, CommentsQueryVariables>
export const PostCommentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PostComment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CommentInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'postComment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'comment' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PostCommentMutation, PostCommentMutationVariables>
export const CreateOrderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateOrder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateOrderInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createOrder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'aggregateId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateOrderMutation, CreateOrderMutationVariables>
export const ProfileCategoriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ProfileCategories' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profileCategories' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProfileCategoriesQuery, ProfileCategoriesQueryVariables>
export const CreatePaymentIntentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreatePaymentIntent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreatePaymentIntentInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPaymentIntent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paymentTransactionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paymentIntentId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreatePaymentIntentMutation, CreatePaymentIntentMutationVariables>
export const CreateSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateSubscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateSubscriptionInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createSubscription' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subscriptionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paymentSubscriptionId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>
export const UpdatePaymentIntentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePaymentIntent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdatePaymentInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePaymentIntent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paymentIntentId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdatePaymentIntentMutation, UpdatePaymentIntentMutationVariables>
export const UpdateSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateSubscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdatePaymentInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSubscription' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subscriptionId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>
export const UpdatePaymentIntentDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePaymentIntentDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdatePaymentDetailsInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePaymentIntentDetails' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'paymentIntentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdatePaymentIntentDetailsMutation, UpdatePaymentIntentDetailsMutationVariables>
export const UpdateSubscriptionDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateSubscriptionDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdatePaymentDetailsInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSubscriptionDetails' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'subscriptionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateSubscriptionDetailsMutation, UpdateSubscriptionDetailsMutationVariables>
export const PageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Page' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pageId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profileId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'page' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pageId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'profileId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'profileId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'donationPageLayout' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'donationPageLayout' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Page' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'branding' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'header' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasDonateButton' } },
                { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'taxDeductibleText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'keyInformationText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'components' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PageOptions' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'siteTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'faviconUrl' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Row' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Column' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Button' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buttonText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'target' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buttonType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DollarHandles' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dollarHandles' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasImage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasDescription' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProgressBar' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'goals' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bonusGoals' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'text' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'textValue' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'htmlText' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'text' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'textValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'htmlText' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideOnEnd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideBeforeStart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideOnGoalReached' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isAllPagesLinked' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'linkedPageIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'offset' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideWhenMatchedGivingActive' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Image' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mergeFieldId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Text' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'textValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'htmlText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Empty' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DonationForm' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'donationFrequency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'donationFrequencyDefault' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dollarHandlesDefault' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'matchedGivings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'rounds' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'endFundRange' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'multiplier' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dollarHandles' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isPersonalised' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasImage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasDescription' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'extraFields' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'conditionalFields' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'customField' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'fieldDescription' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'acceptedValues' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'customField' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fieldDescription' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'acceptedValues' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'legalUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'minimumAmount' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Video' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CountdownTimer' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideOnEnd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideBeforeStart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'finish' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bonusFinishTimes' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Comments' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showTotal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showViewAll' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'layout' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideBeforeStart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideOnEnd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isAllPagesLinked' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'linkedPageIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amountToShowOver' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Footer' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Header' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SocialShare' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasLink' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasTwitter' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasFacebook' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasEmail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasWhatsApp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasLinkedIn' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FundraiserButton' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'LoginForm' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RegisterForm' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FundraiserProfile' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Leaderboard' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProgressImage' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'VirtualGiftSection' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PostDonationForm' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buttonText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'extraFields' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isHidden' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'conditionalFields' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isHidden' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'customField' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'fieldDescription' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'acceptedValues' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'customField' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fieldDescription' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'acceptedValues' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'desktop' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'childComponents' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'childComponents' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobile' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'childComponents' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'childComponents' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'elementSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'progressBar' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'pageIds' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'progressBarGoals' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'goal' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'matchedGivings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rounds' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'endFundRange' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'multiplier' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startFundRange' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PageQuery, PageQueryVariables>
export const CampaignLandingPageIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CampaignLandingPageId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isLiveMode' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pageBucketId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'campaignLandingPageId' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isLiveMode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isLiveMode' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageBucketId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pageBucketId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CampaignLandingPageIdQuery, CampaignLandingPageIdQueryVariables>
export const SearchBySlugDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SearchBySlug' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'url' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isLiveMode' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchBySlug' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'url' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'url' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isLiveMode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isLiveMode' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'charityId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'campaignId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pageId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pageBucketId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'profileId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'profileData' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'campaignSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'campaignDomain' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isPeerToPeerGivingNotificationEnabled' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'layout' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'donationPageLayout' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'redirectUrl' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'donationPageLayout' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Page' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'branding' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'header' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasDonateButton' } },
                { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'taxDeductibleText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'keyInformationText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'components' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PageOptions' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'siteTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'faviconUrl' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Row' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Column' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Button' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buttonText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'target' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buttonType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DollarHandles' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dollarHandles' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasImage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasDescription' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProgressBar' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'goals' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bonusGoals' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'text' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'textValue' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'htmlText' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'text' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'textValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'htmlText' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideOnEnd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideBeforeStart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideOnGoalReached' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isAllPagesLinked' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'linkedPageIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'offset' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideWhenMatchedGivingActive' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Image' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mergeFieldId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Text' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'textValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'htmlText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Empty' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DonationForm' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'donationFrequency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'donationFrequencyDefault' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dollarHandlesDefault' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'matchedGivings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'rounds' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'endFundRange' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'multiplier' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dollarHandles' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isPersonalised' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasImage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasDescription' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'extraFields' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'conditionalFields' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'customField' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'fieldDescription' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'acceptedValues' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'customField' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fieldDescription' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'acceptedValues' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'legalUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'minimumAmount' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Video' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CountdownTimer' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideOnEnd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideBeforeStart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'finish' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bonusFinishTimes' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Comments' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showTotal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showViewAll' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'layout' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideBeforeStart' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideOnEnd' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isAllPagesLinked' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'linkedPageIds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amountToShowOver' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Footer' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Header' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SocialShare' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasLink' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasTwitter' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasFacebook' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasEmail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasWhatsApp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasLinkedIn' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FundraiserButton' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'LoginForm' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RegisterForm' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FundraiserProfile' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Leaderboard' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProgressImage' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'VirtualGiftSection' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PostDonationForm' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buttonText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subComponents' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'extraFields' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isHidden' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'conditionalFields' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isRequired' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isHidden' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'customField' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'fieldDescription' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'acceptedValues' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'customField' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'elementType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fieldDescription' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'acceptedValues' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'styles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobileStyles' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'desktop' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'childComponents' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'childComponents' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobile' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'childComponents' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'childComponents' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'elementSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'progressBar' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'pageIds' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'progressBarGoals' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'goal' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'matchedGivings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rounds' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'endFundRange' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'multiplier' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startFundRange' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchBySlugQuery, SearchBySlugQueryVariables>
export const GetThankYouPageIdFromPageIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetThankYouPageIdFromPageId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pageId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'thankYouPageIdFromId' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pageId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetThankYouPageIdFromPageIdQuery, GetThankYouPageIdFromPageIdQueryVariables>
export const SubmitQuickPayValuesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SubmitQuickPayValues' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'QuickPayValuesInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submitQuickPayValues' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SubmitQuickPayValuesMutation, SubmitQuickPayValuesMutationVariables>
export const SubmitFormValuesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SubmitFormValues' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SubmitFormValuesInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submitFormValues' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SubmitFormValuesMutation, SubmitFormValuesMutationVariables>
export const SubmitPostDonationFormValuesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SubmitPostDonationFormValues' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SubmitPostDonationFormValuesInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submitPostDonationFormValues' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SubmitPostDonationFormValuesMutation, SubmitPostDonationFormValuesMutationVariables>
export const ProgressBarAmountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ProgressBarAmount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isAllPagesLinked' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pageIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isLiveMode' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profileId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'progressBarAmount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isAllPagesLinked' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isAllPagesLinked' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pageIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isLiveMode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isLiveMode' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'profileId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'profileId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProgressBarAmountQuery, ProgressBarAmountQueryVariables>
export const ProfileDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ProfileData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'charityId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profileId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profileData' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'charityId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'charityId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'profileId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'profileId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isGivingNotificationEnabled' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProfileDataQuery, ProfileDataQueryVariables>
export const LeaderboardDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Leaderboard' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'charityId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isLiveMode' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProfileQueryOrderType' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isApprovedOnly' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaderboard' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'charityId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'charityId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isLiveMode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isLiveMode' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isApprovedOnly' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isApprovedOnly' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'progressAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'profileUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LeaderboardQuery, LeaderboardQueryVariables>
export const FullMatchedGivingProgressDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FullMatchedGivingProgress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'matchedGivingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isLiveMode' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullMatchedGivingProgress' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'matchedGivingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'matchedGivingId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isLiveMode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isLiveMode' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FullMatchedGivingProgressQuery, FullMatchedGivingProgressQueryVariables>
export const PurlDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Purl' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'charityId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'params' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'purl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'charityId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'charityId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'params' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'params' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PurlQuery, PurlQueryVariables>
export const PurlParamsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PurlParams' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'charityId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'params' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'purlParams' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'charityId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'charityId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'params' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'params' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PurlParamsQuery, PurlParamsQueryVariables>
export const SalesforceContactDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SalesforceContact' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'charityId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contactId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'donorId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'salesforceContact' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'charityId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'charityId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contactId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'contactId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'donorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'donorId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'donationAmounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SalesforceContactQuery, SalesforceContactQueryVariables>
export const RecordStatsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RecordStats' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'AnalyticsInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recordStats' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RecordStatsMutation, RecordStatsMutationVariables>
export const PageMetadataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PageMetadata' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'charityId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pageId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageMetadata' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'charityId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'charityId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pageId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'charity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'CharityName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'Phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'Email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ABN' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'CustomFields' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'FaviconUrl' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'campaign' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'CampaignName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'CampaignGoal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ogImage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ogTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'gtmScriptId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ga4ScriptId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fbPixelId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isConversionsApi' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'page' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'OgImage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'OgTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'OgDescription' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PageMetadataQuery, PageMetadataQueryVariables>
export const PaymentSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PaymentSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isLiveMode' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'campaignId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isLiveMode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isLiveMode' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'platformFeeType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'donorPaysPlatformFees' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'platformFeeType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'givingType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'givingFrequencyType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'paymentProviderType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feeRanges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'startRange' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endRange' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fixFee' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'percentageFee' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'countryCodeIso2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'donationPagePaymentProviderSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stripePaymentSettings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'publishableKey' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'connectAccountId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'paymentProviderType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'paymentChargeType' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'payPalMerchantSetting' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'merchantId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'merchantEmail' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PaymentSettingsQuery, PaymentSettingsQueryVariables>
export const GetDonorProfileQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetDonorProfileQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'donorProfile' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDonorProfileQueryQuery, GetDonorProfileQueryQueryVariables>
export const DonorGivingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DonorGivings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GivingsQueryInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'donorGivings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalRecords' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'givingId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'paymentMethodType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'campaignTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'donationFrequencyType' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DonorGivingsQuery, DonorGivingsQueryVariables>
export const DonorSubscriptionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DonorSubscriptions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GivingsQueryInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'donorSubscriptions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'token' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalRecords' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'subscriptionId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'campaignTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'paymentMethodType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nextPaymentDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subscriptionStartDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subscriptionEndDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'frequency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resumeAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'externalSubscriptionId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastInvoice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'invoiceDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'invoiceStatus' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scheduledUpdate' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'subscriptionScheduleId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'externalSubscriptionScheduleId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'donationFrequencyType' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'regularGivings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'regularGivingId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'paymentMethodType' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DonorSubscriptionsQuery, DonorSubscriptionsQueryVariables>
export const LoginDonorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'LoginDonor' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loginDonor' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LoginDonorMutation, LoginDonorMutationVariables>
export const AuthenticateDonorTokenDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AuthenticateDonorToken' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authenticateDonorToken' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'token' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AuthenticateDonorTokenMutation, AuthenticateDonorTokenMutationVariables>
export const DonorPortalSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DonorPortalSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'url' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'donorPortalSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'url' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'url' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'charityId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'branding' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'donorPortalRegularGivingPermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canEditName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canEditAmount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canEditFrequency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canEditDonationEndDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canEditNextPaymentDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canCancelDonation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canPauseDonation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canResumeDonation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatePaymentDetails' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DonorPortalSettingsQuery, DonorPortalSettingsQueryVariables>
export const CharityMetadataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CharityMetadata' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'charityId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'charityMetadata' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'charityId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'charityId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'LogoUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ReversedLogoUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'FaviconUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'CharityName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CharityMetadataQuery, CharityMetadataQueryVariables>
export const RegenerateCustomerPortalSessionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RegenerateCustomerPortalSession' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'externalSubscriptionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'regenerateCustomerPortalSession' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'externalSubscriptionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'externalSubscriptionId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RegenerateCustomerPortalSessionMutation, RegenerateCustomerPortalSessionMutationVariables>
export const ValidateAndCreateCustomerPortalSessionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ValidateAndCreateCustomerPortalSession' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subscriptionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'validateAndCreateCustomerPortalSession' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'token' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subscriptionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subscriptionId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ValidateAndCreateCustomerPortalSessionMutation,
  ValidateAndCreateCustomerPortalSessionMutationVariables
>
export const DonorSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DonorSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DonorSummaryInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submitDonorSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DonorSummaryMutation, DonorSummaryMutationVariables>
